export interface ImCodes{
    [key: string]: string[];
}

export const IM_CODES:ImCodes={
"0":["Dc9","Dc8"],
"1":["Dbs","Dbo"],
"2":["Dc6","Dc4"],
"3":["Dcn","Dcl"],
"4":["DbS","DbQ"],
"5":["DbC","DbA"],
"6":["DcE","DcC"],
"7":["Dbw","Dbu"],
"8":["Daf","Dab"],
"9":["DbY","DbW"],
"10":["DcV","DcU"],
"11":["Dau","Dat"],
"12":["Dcr","Dcp"],
"13":["DcY","DcX"],
"14":["DbU","DbT"],
"15":["Daw","Dav"],
"16":["DcG","DcF"],
"17":["Dby","Dbx"],
"18":["Dad","Dac"],
"19":["Dba","DbZ"],
"20":["Dcy","Dcs"],
"21":["Dcx"],
"22":["Dc3"],
"23":["Dc2"],
"24":["Dcv"],
"25":["Dcu"],
"26":["Dc0"],
"27":["Dcz"],
"28":["Dct"],
"29":["Dcw"],
"30":["Dcf","DcZ"],
"31":["Dce"],
"32":["Dck"],
"33":["Dcj"],
"34":["Dcc"],
"35":["Dcb"],
"36":["Dch"],
"37":["Dcg"],
"38":["Dca"],
"39":["Dcd"],
"40":["DbK","DbE"],
"41":["DbJ"],
"42":["DbP"],
"43":["DbO"],
"44":["DbH"],
"45":["DbG"],
"46":["DbM"],
"47":["DbL"],
"48":["DbF"],
"49":["DbI"],
"50":["Da4","Day"],
"51":["Da3"],
"52":["Da9"],
"53":["Da8"],
"54":["Da1"],
"55":["Da0"],
"56":["Da6"],
"57":["Da5"],
"58":["Daz"],
"59":["Da2"],
"60":["DcO","DcI"],
"61":["DcN"],
"62":["DcT"],
"63":["DcS"],
"64":["DcL"],
"65":["DcK"],
"66":["DcQ"],
"67":["DcP"],
"68":["DcJ"],
"69":["DcM"],
"70":["Db6","Db0"],
"71":["Db5"],
"72":["DcB"],
"73":["DcA"],
"74":["Db3"],
"75":["Db2"],
"76":["Db8"],
"77":["Db7"],
"78":["Db1"],
"79":["Db4"],
"80":["Dan","Dah"],
"81":["Dam"],
"82":["Das"],
"83":["Dar"],
"84":["Dak"],
"85":["Daj"],
"86":["Dap"],
"87":["Dao"],
"88":["Dai"],
"89":["Dal"],
"90":["Dbi","Dbc"],
"91":["Dbh"],
"92":["Dbn"],
"93":["Dbm"],
"94":["Dbf"],
"95":["Dbe"],
"96":["Dbk"],
"97":["Dbj"],
"98":["Dbd"],
"99":["Dbg"],
"100":["Dbp"],
"200":["Dc5"],
"300":["Dcm"],
"400":["DbR"],
"500":["DbB"],
"600":["DcD"],
"700":["Dbv"],
"800":["Dae"],
"900":["DbX"],
"1000":["Dbt"],
"1200":["Dcq"],
"2000":["Dc7"],
"3000":["Dco"],
"4000":["DbV"],
"5000":["DbD"],
"6000":["DcH"],
"7000":["Dbz"],
"8000":["Dag"],
"9000":["Dbb"],
"10000":["DcW"],
"15000":["Dax"],
"20000":["Dc1"],
"30000":["Dci"],
"40000":["DbN"],
"50000":["Da7"],
"60000":["DcR"],
"70000":["Db9"],
"80000":["Daq"],
"90000":["Dbl"],
"100000":["Dbq"],
"1000000":["Dbr"],
"10 o'clock":["DeW"],
"10 past 8":["DeX"],
"10 to 5":["DeY"],
"11 minutes past 5":["Dd9"],
"2 o'clock":["Deg"],
"20 past 2":["Dee"],
"20 to 4":["Def"],
"25 past 10":["Dec"],
"25 past 11":["Dea"],
"25 past 6":["Deb"],
"25 to 10":["Ded"],
"3 o'clock":["DeZ"],
"5 o'clock":["DeA"],
"5 past 12":["DeC"],
"5 past 6":["DeB"],
"5 to 12":["DeD"],
"6 o'clock":["DeV"],
"7 o'clock":["DeU"],
"8'clock":["Dd8"],
"9 o'clock":["DeJ"],
"a":["DZm","DZl"],
"abdicate":["AAA"],
"abe":["AAB"],
"aboard":["DRR"],
"aboriginal":["AAD","AAC"],
"about":["AAE"],
"above":["DdC","AAF"],
"abroad":["Dob"],
"abstract":["AAI","AAG","AAH"],
"Abu dhabi":["AAJ","AAK","AAL"],
"abuse":["AAN","AAM"],
"acacia tree":["AAO","AAP"],
"academy":["DRS","AAQ"],
"accelerate":["DRT","AAS","AAR"],
"acceleration":["AAT"],
"accept":["DRU","AAX","AAU","AAV","AAW"],
"accident":["DRV","AAa","AAY","AAZ"],
"accommodation":["AAe","AAb","AAc","AAd"],
"accomodation":["DRW"],
"accomplish":["AAh","AAf","AAg"],
"accordian":["C4b"],
"according to":["AAi"],
"accordion":["AAl","AAj","AAk"],
"account":["AAr","AAm","AAn"],
"accountant":["C4d","C4c","AAq","AAo","AAp"],
"accumulate":["DRX","AAt","AAs"],
"accurate":["DRY","AAw","AAu","AAv"],
"accuse":["DRZ","AAz","AAx","AAy"],
"achieve":["AA5","AA0","AA1","AA2"],
"achievement":["AA4","AA3"],
"acid rain":["AA6"],
"acorn":["DRa","ABA","AA7","AA8","AA9"],
"acorns":["ABB"],
"acoustics":["ABD","ABC"],
"acrobat":["DRb","ABK","ABE","ABF","ABG","ABH"],
"acrobatics":["ABJ","ABI"],
"across":["ABL"],
"action":["ABQ","ABM"],
"action figure":["ABN"],
"action film":["ABO","ABP"],
"activate":["ABR"],
"active":["ABT","ABS"],
"actor":["ABX","ABU","ABV","ABW"],
"actress":["ABb","ABY","ABZ","ABa"],
"acute":["DRc"],
"add":["Dei","Dej"],
"add added":["Dei","Dej"],
"add sugar":["Dej"],
"addiction":["DRd","ABf","ABc","ABd","ABe"],
"addictive":["ABh","ABg"],
"adding":["Dei","Dej"],
"adding sugar":["Dej"],
"addition":["ABk","ABi","ABj"],
"address":["DRe","ABn","ABl","ABm"],
"adjectives":["ABo"],
"administrative":["ABr","ABp","ABq"],
"admire":["ABt","ABs"],
"adopt":["ABx","ABu","ABv","ABw"],
"adult":["DRf","AB0","ABy","ABz"],
"advance":["AB2","AB1"],
"adventure":["DRg","AB5","AB3","AB4"],
"advertise":["Dek"],
"advertise advertised":["Dek"],
"advertise burgers":["Dek"],
"advertisement":["AB8","AB6","AB7"],
"advertising":["Dek"],
"advertising burgers":["Dek"],
"aerobics":["AB9"],
"aeroplane":["ACE","ACA","ACB","ACC","ACD"],
"aerospace engineer":["C4e","C4f"],
"affect":["ACK","ACF","ACG"],
"affection":["DRh","ACJ","ACH","ACI"],
"afford":["DRi","ACL"],
"Afghanistan":["ACO","ACM","ACN"],
"afraid":["ACR","ACP","ACQ"],
"Africa":["ACV","ACS","ACT","ACU"],
"afternoon":["ACW"],
"again":["ACY","ACX"],
"against":["DRj","ACa","ACZ"],
"age":["DRk","ACc","ACb"],
"aggravated":["DRl","ACd"],
"agony":["DRm","ACf","ACe"],
"agree":["DRo","ACm","ACg","ACh","ACi"],
"agreement":["DRn","ACl","ACj","ACk"],
"aim":["DRp","ACq","ACn","ACo","ACp"],
"air":["AC3","ACr","ACs"],
"air conditioner":["C4g","ACt","ACu","ACv","ACw","ACx"],
"air pollution":["C4h","C4i","AC4","AC5","AC6","AC7","AC8"],
"airplane":["AC2","ACy","ACz","AC0","AC1"],
"airport":["C4j","ADF","AC9","ADA","ADB","ADC","ADD","ADE"],
"airport terminal":["ADG","ADH"],
"aisle":["ADJ","ADI"],
"aladdin":["ADM","ADK","ADL"],
"alarm":["ADT","ADN","ADO","ADP"],
"alarm clock":["C4k","ADQ","ADR","ADS"],
"albatross":["ADW","ADU","ADV"],
"albert einstein":["ADX","ADY"],
"alcohol":["DRq","ADc","ADZ","ADa","ADb"],
"alien":["DRr","ADg","ADd","ADe","ADf"],
"aliens":["DRs"],
"all":["ADx","ADh"],
"allergic":["DRt","ADj","ADi"],
"allergies":["DRu","ADl","ADk"],
"allergy":["ADn","ADm"],
"alligator":["ADr","ADo","ADp","ADq"],
"allow":["ADw","ADs","ADt","ADu","ADv"],
"alone":["DRv","ADz","ADy"],
"along":["DRw"],
"aloud":["DRx","AD1","AD0"],
"alpaca":["AD4","AD2","AD3"],
"alpha":["Doc"],
"alphabet":["DRy","AD6","AD5"],
"alternative energy":["DRz","AD7","AD8","AD9"],
"altitude":["DR0","AEB","AEA"],
"always":["AEC"],
"amaze":["DR1","AED"],
"amazing":["DR2","AEF","AEE"],
"amazon":["AEJ","AEG","AEH","AEI"],
"ambassador":["AEK"],
"amber":["C4l","AEN","AEL","AEM"],
"ambitious":["AEO"],
"ambulance":["C4m","AES","AEP","AEQ","AER"],
"ambush":["AEU","AET"],
"America":["C4p","AEp","AEV","AEW","AEX","AEY","AEZ"],
"American":["C4o","AEo","AEa","AEb"],
"American flag":["AEc"],
"American football":["C4n","AEd","AEe","AEf","AEg","AEh","AEi"],
"americano":["AEn","AEj","AEk"],
"americano iced":["AEl","AEm"],
"among":["AEq"],
"among us":["AEr"],
"amphibian":["C4q"],
"amplitude":["AEs"],
"Amsterdam":["AEw","AEt","AEu","AEv"],
"amusement":["DR4","AE3","AEx","AEy","AEz"],
"amusement park":["DR3","AE0","AE1","AE2"],
"amusing":["DR5","AE4"],
"an earache":["Dod"],
"anaconda":["AE9","AE5","AE6","AE7","AE8"],
"analogy":["AFA"],
"ancestor":["AFD","AFB","AFC"],
"anchor":["AFG","AFE","AFF"],
"ancient":["AFJ","AFH","AFI"],
"Andorra":["AFL","AFK"],
"angel":["DR7","DR6","AFQ","AFM","AFN","AFO","AFP"],
"anger":["DR8","AFS","AFR"],
"angry":["C4r","DR9","AFX","AFT","AFU","AFV"],
"angry girl":["AFW"],
"animal":["AFa"],
"animal crossing":["AFY","AFZ"],
"animal shelter":["AFd","AFe"],
"animals":["AFf","AFb","AFc"],
"animation":["AFh","AFg"],
"anime":["AFj","AFi"],
"ankle":["C4s","AFk"],
"anklet":["AFl"],
"announcer":["DSA","AFo","AFm","AFn"],
"annoy":["DSC","AFt"],
"annoyed":["C4t","DSB","AFs","AFp","AFq","AFr"],
"another":["AFu"],
"answer":["AFz","AFv","AFw","AFx","AFy"],
"ant":["C4u","AGO","AF0","AF1","AF2","AF3"],
"Antarctica":["AF7","AF4","AF5","AF6"],
"antelope":["AGA","AF8","AF9"],
"antenna":["AGD","AGB","AGC"],
"anthem":["AGF","AGE"],
"antique shop":["AGG","AGH","AGI"],
"antisocial":["AGJ"],
"antlers":["AGN","AGK","AGL","AGM"],
"ants":["AGR","AGP","AGQ"],
"anxious":["AGT","AGS"],
"apartment":["AGW","AGU","AGV"],
"apartment block":["C4v"],
"ape":["AGb","AGX","AGY","AGZ","AGa"],
"app":["AHC","AGc","AGd"],
"apparition":["AGf","AGe"],
"appear":["Doe"],
"appendix":["AGg"],
"appetizers":["AGj","AGh","AGi"],
"apple":["C4x","AGx","AGk","AGl","AGm","AGn","AGo","AGp"],
"apple juice":["C4w","AGq","AGr","AGs"],
"apple pie":["AGt","AGu","AGv","AGw"],
"apple tea":["AG4"],
"apples":["C4y","AG3","AGy","AGz","AG0"],
"applesauce":["AG2","AG1"],
"appliance":["AG7","AG5","AG6"],
"application":["AHB","AG8","AG9","AHA"],
"appreciate":["DSD","AHD"],
"apprentice":["DSE","AHG","AHE","AHF"],
"approach":["AHH"],
"apricot":["AHK","AHI","AHJ"],
"April":["Dof"],
"apron":["C4z","AHM","AHL"],
"aquamarine":["AHN"],
"aquarium":["AHP","AHO"],
"Arab":["AHT","AHQ"],
"arabesque":["AHS","AHR"],
"arcade game":["DSF","AHU"],
"archaeologist":["DSG","AHY","AHV","AHW","AHX"],
"archeologist":["DSH"],
"archery":["C40","DSI","AHb","AHZ","AHa"],
"architect":["C42","C41","AHf","AHc","AHd","AHe"],
"arctic":["AHk","AHg","AHh"],
"arctic fox":["AHi","AHj"],
"Argentina":["C44","AHo","AHl","AHm","AHn"],
"Argentina flag":["C43"],
"Argentinean":["AHp"],
"Argentinian":["C45"],
"argue":["Dem","Del"],
"argue argued":["Del","Dem"],
"arguing":["Dem","Del"],
"argument":["AHt","AHq","AHr","AHs"],
"arm":["C48","AH4","AHu","AHv"],
"arm chair":["AHx","AHy","AHz"],
"armbands":["AHw"],
"armchair":["C46"],
"Armenia":["AH3","AH0","AH1","AH2"],
"armpit":["C47"],
"arms":["C5A","C49","AH5"],
"army":["AH9","AH6","AH7","AH8"],
"aroma":["DSJ","AID","AIA","AIB","AIC"],
"around":["AIF","AIE"],
"arrange":["Den","AIK","AIG","AIH"],
"arrange arranged":["Den"],
"arrange flowers":["Den"],
"arrangement":["AIJ","AII"],
"arranging":["Den"],
"arranging flowers":["Den"],
"arrest":["Deo","AIO","AIL"],
"arrest arrested":["Deo"],
"arrest someone":["Deo"],
"arrested":["AIN","AIM"],
"arresting":["Deo"],
"arresting someone":["Deo"],
"arrival":["AIP"],
"arrive":["Deq","Dep"],
"arrive arrived":["Dep","Deq"],
"arrive at the station":["Dep"],
"arrived":["DSK"],
"arriving":["Deq","Dep"],
"arriving at the station":["Dep"],
"arrogance":["DSL","AIR","AIQ"],
"arrogant":["DSM","AIT","AIS"],
"arrow":["DSN","AIY","AIU","AIV","AIW","AIX"],
"art":["C5D","AIu","AIZ","AIa","AIb"],
"art gallery":["AIe","AIf","AIg"],
"art room":["Dog"],
"artery":["AId","AIc"],
"artichoke":["AIj","AIh","AIi"],
"article":["AIm","AIk","AIl"],
"articles":["AIn"],
"artist":["C5C","C5B","DSP","AIt","AIo","AIp","AIq"],
"artistic":["DSO","AIs","AIr"],
"artwork":["AIx","AIv","AIw"],
"as usual":["AKK","AKL"],
"ashamed":["AI2","AIy","AIz","AI0","AI1"],
"ashma":["DSQ"],
"Asia":["AI9","AI3","AI4","AI5","AI6","AI7","AI8"],
"asiatic lion":["AJA"],
"ask":["Des","Der","AJF","AJB","AJC"],
"ask a question":["Der"],
"ask asked":["Der","Des"],
"ask for help":["AJE"],
"asked":["AJD"],
"asking":["Des","Der"],
"asking a question":["Der"],
"asleep":["AJJ","AJG","AJH","AJI"],
"asparagus":["AJM","AJK","AJL"],
"aspirin":["AJP","AJN","AJO"],
"assemble":["AJU","AJQ","AJR","AJS","AJT"],
"assets":["AJX","AJV","AJW"],
"assign":["AJa"],
"assignment":["AJZ","AJY"],
"assistance":["AJd","AJb","AJc"],
"assistant":["AJi","AJe","AJf","AJg","AJh"],
"asteroid":["AJo","AJj","AJk","AJl","AJm","AJn"],
"asthma":["DSR","AJs","AJp","AJq","AJr"],
"astonish":["DST","AJ2","AJt","AJu","AJv"],
"astonished":["DSS","AJ0","AJw","AJx","AJy","AJz"],
"astonishment":["AJ1"],
"astound":["AJ4","AJ3"],
"astronaut":["C5F","C5E","AKC","AJ5","AJ6","AJ7","AJ8","AJ9","AKA","AKB"],
"astronomer":["AKE","AKD"],
"astronomy":["DSU","AKJ","AKF","AKG","AKH","AKI"],
"at":["AKz","AKM"],
"at home":["AKa","AKb","AKc"],
"at night":["AKt","AKu","AKv","AKw","AKx","AKy"],
"at risk":["AK0","AK1"],
"at school":["AK2","AK3","AK4","AK5","AK6","AK7"],
"at the back":["DdD"],
"at the beach":["ALO","ALP","ALQ"],
"at the front":["DdE"],
"at the mall":["ALR"],
"at the museum":["ALS"],
"athlete":["C5H","C5G","AKT","AKN","AKO","AKP","AKQ","AKR","AKS"],
"athletic":["DSV","AKX","AKU","AKV","AKW"],
"athletics":["AKZ","AKY"],
"atlas":["AKh","AKd","AKe","AKf","AKg"],
"atm":["C5I","AKs","AKi","AKj","AKk","AKl","AKm"],
"atmosphere":["AKr","AKn","AKo","AKp","AKq"],
"attach":["ALE","AK8","AK9"],
"attachment":["ALD","ALA","ALB","ALC"],
"attack":["ALI","ALF","ALG","ALH"],
"attend":["ALK"],
"attendance":["ALJ"],
"attention":["ALN","ALL","ALM"],
"attic":["ALX","ALT","ALU","ALV","ALW"],
"attitude":["ALZ","ALY"],
"attract":["ALj","ALa","ALb","ALc"],
"attractive":["ALi","ALd","ALe","ALf","ALg","ALh"],
"au pair":["DSY"],
"auction":["ALm","ALk","ALl"],
"audience":["ALp","ALn","ALo"],
"auditorium":["Doh"],
"August":["Doi"],
"aunt":["DZK","DSX","ALr","ALq"],
"auntie":["DSW"],
"aurora":["ALv","ALs","ALt","ALu"],
"Australia":["C5L","AL4","ALw","ALx","ALy","ALz","AL0","AL1","AL2"],
"Australia and Oceania":["AL3"],
"Australia flag":["C5J"],
"Australian":["C5K"],
"Austria":["AL9","AL5","AL6","AL7","AL8"],
"author":["C5N","C5M","AMH","AMA","AMB","AMC","AMD"],
"authority":["AMG","AME","AMF"],
"automatically":["AMK","AMI","AMJ"],
"automobile":["AMN","AML","AMM"],
"autumn":["AMU","AMO","AMP","AMQ","AMR","AMS","AMT"],
"avalanche":["AMZ","AMV","AMW","AMX","AMY"],
"avocado":["C5O","AMd","AMa","AMb","AMc"],
"avocado smoothie":["AMe","AMf"],
"avoid":["DSZ"],
"awake":["DSa"],
"aware":["DSb"],
"awe inspiring":["DSc","AMg","AMh"],
"awesome":["DSd","AMj","AMi"],
"awful":["DSe","AMm","AMk","AMl"],
"awkward":["AMp","AMn","AMo"],
"axe":["C5P","AMu","AMq","AMr","AMs","AMt"],
"axis":["AMy","AMv","AMw","AMx"],
"Azerbaijan":["AM2","AMz","AM0","AM1"],
"b":["DZo","DZn"],
"babies":["Doj"],
"baboon":["DSf","AM5","AM3","AM4"],
"baby":["DSg","ANG","AM6","AM7","AM8","AM9"],
"baby bottle":["ANA","ANB","ANC","AND"],
"baby brother":["Dok"],
"baby cat":["ANE"],
"baby dog":["ANF"],
"baby sister":["Dol"],
"babysitter":["ANI","ANH"],
"back":["ANb","ANJ","ANK"],
"back to school":["DSj","ANg","ANh"],
"backache":["DSh","ANO","ANL","ANM","ANN"],
"background":["DSi","ANS","ANP","ANQ","ANR"],
"backpack":["C5R","C5Q","ANa","ANT","ANU","ANV","ANW","ANX","ANY","ANZ"],
"backstage":["ANf","ANc","ANd","ANe"],
"backwards":["ANl","ANi","ANj","ANk"],
"backyard":["ANp","ANm","ANn","ANo"],
"bacon":["C5S","ANt","ANq","ANr","ANs"],
"bacteria":["ANx","ANu","ANv","ANw"],
"bad":["AOM","ANy","ANz","AN0","AN1","AN2","AN3"],
"bad news":["AOK","AOL"],
"bad temper":["AON"],
"badge":["AN9","AN4","AN5","AN6","AN7","AN8"],
"badges":["AOC","AOA","AOB"],
"badminton":["C5T","AOJ","AOD","AOE","AOF","AOG","AOH","AOI"],
"bag":["C5Y","C5U","AOk","AOO","AOP","AOQ","AOR","AOS","AOT","AOU"],
"bag of chips":["AOh"],
"bag of flour":["AOi","AOj"],
"bagel":["C5V","AOZ","AOV","AOW","AOX","AOY"],
"bagels":["AOb","AOa"],
"baggage":["AOg","AOc","AOd","AOe"],
"baggage claim":["AOf"],
"baggage handler":["C5W","C5X"],
"baguette":["C5Z"],
"Bahrain":["AOo","AOl","AOm","AOn"],
"bake":["AOv","AOp"],
"bake cookies":["AOq","AOr"],
"baked potato":["AOs","AOt","AOu"],
"baker":["C5b","C5a","AO1","AOw","AOx","AOy","AOz","AO0"],
"baker's":["AO2"],
"bakery":["C5c","AO7","AO3","AO4","AO5","AO6"],
"baking cookies":["AO8"],
"balance":["APD","AO9","APA","APB","APC"],
"balcony":["APK","APE","APF","APG","APH","API","APJ"],
"bald":["APP","APL","APM","APN","APO"],
"ball":["C5e","APt","APQ","APR","APS","APT","APU","APV"],
"ballerina":["APb","APW","APX","APY","APZ","APa"],
"ballet":["APi","APc","APd","APe","APf"],
"ballet classes":["APg","APh"],
"balloon":["C5d","APo","APj","APk","APl","APm","APn"],
"balloons":["APs","APp","APq","APr"],
"balls":["APv","APu"],
"bambi":["AP0","APw","APx","APy","APz"],
"ban":["ARB","AP1","AP2","AP3","AP4","AP5"],
"banana":["C5g","AQB","AP6","AP7","AP8","AP9","AQA"],
"banana milkshake":["C5f"],
"bananas":["C5h","AQH","AQC","AQD","AQE","AQF","AQG"],
"band":["AQS","AQI","AQJ","AQK","AQL","AQM"],
"band aid":["C5j"],
"bandage":["C5i","AQR","AQN","AQO","AQP","AQQ"],
"bangers and mash":["AQT"],
"Bangladesh":["AQZ","AQU","AQV","AQW","AQX","AQY"],
"bangle":["AQd","AQa","AQb","AQc"],
"bangles":["AQf","AQe"],
"banjo":["C5k","AQk","AQg","AQh","AQi","AQj"],
"bank":["AQ4","AQl","AQm","AQn","AQo","AQp","AQq","AQr"],
"bank account":["DSk","AQs","AQt","AQu","AQv","AQw","AQx","AQy"],
"bank robbers":["DSm"],
"banknote":["DSl","AQ3","AQz","AQ0","AQ1","AQ2"],
"bankrupt":["DSn","AQ7","AQ5","AQ6"],
"banner":["ARA","AQ8","AQ9"],
"baozi":["ARD","ARC"],
"bar":["Dom"],
"barbecue":["C5l","ARM","ARE","ARF","ARG","ARH","ARI","ARJ","ARK","ARL"],
"barber":["ARP","ARN","ARO"],
"barbers":["ARU","ARQ","ARR","ARS"],
"barbershop":["ART"],
"barcode":["ARX","ARV","ARW"],
"barefooted":["ARb","ARY","ARZ","ARa"],
"bargain":["ARe","ARc","ARd"],
"barista":["C5n","C5m"],
"bark":["ARk","ARf","ARg","ARh"],
"barking":["ARj","ARi"],
"barley":["ARo","ARl","ARm","ARn"],
"barn":["ARu","ARp","ARq","ARr","ARs","ARt"],
"barrel":["AR0","ARv","ARw","ARx","ARy","ARz"],
"barren":["AR4","AR1","AR2","AR3"],
"barrister":["AR8","AR5","AR6","AR7"],
"bartender":["C5p","C5o","ASE","AR9","ASA","ASB","ASC","ASD"],
"base":["ASa"],
"baseball":["C5q","ASS","ASF","ASG","ASH","ASI","ASJ"],
"baseball cap":["ASK","ASL","ASM","ASN","ASO","ASP"],
"baseball field":["ASQ","ASR"],
"baseball stadium":["AST","ASU"],
"basement":["ASZ","ASV","ASW","ASX","ASY"],
"basil":["ASg","ASb","ASc","ASd","ASe","ASf"],
"basket":["C5s","ASv","ASh","ASi","ASj","ASk","ASl","ASm"],
"basketball":["C5r","ASu","ASn","ASo","ASp","ASq","ASr","ASs","ASt"],
"bass":["ASz"],
"bassoon":["ASy","ASw","ASx"],
"bat":["C5v","ATQ","AS0","AS1","AS2","AS3","AS4","AS5","AS6"],
"bath":["C5t","ATF","AS7","AS8","AS9","ATA"],
"bathe":["ATE","ATB","ATC","ATD"],
"bathroom":["C5u","ATM","ATG","ATH","ATI","ATJ","ATK","ATL"],
"bathtub":["ATP","ATN","ATO"],
"batman":["Don"],
"batteries":["ATT","ATR","ATS"],
"battery":["C5w","ATY","ATU","ATV","ATW","ATX"],
"battle":["ATc","ATZ","ATa","ATb"],
"baubles":["ATh","ATd","ATe","ATf","ATg"],
"bay":["ATl","ATi","ATj","ATk"],
"be happy":["Det"],
"be on time":["AW4"],
"be quiet":["AW5","AW6","AW7"],
"be unhappy":["Deu"],
"be was":["Det"],
"beach":["C5x","AT2","ATm","ATn","ATo","ATp","ATq"],
"beach ball":["ATr","ATs","ATt","ATu","ATv"],
"beach bucket":["ATw"],
"beach chair":["ATx","ATy","ATz","AT0"],
"beach mat":["AT1"],
"beach towel":["AT3","AT4","AT5"],
"beach umbrella":["AT6","AT7","AT8","AT9","AUA"],
"beads":["AUF","AUB","AUC","AUD","AUE"],
"beagle":["AUH","AUG"],
"beak":["C5y","AUL","AUI","AUJ","AUK"],
"bean":["Doo"],
"bean sprouts":["AUY","AUZ","AUa","AUb"],
"beanbag":["AUN","AUM"],
"beanie":["AUQ","AUO","AUP"],
"beans":["C50","AUX","AUR","AUS","AUT","AUU","AUV","AUW"],
"beans on toast":["C5z"],
"bear":["C52","AUn","AUc","AUd","AUe","AUf","AUg","AUh"],
"beard":["C51","AUm","AUi","AUj","AUk","AUl"],
"bears":["AUp","AUo"],
"beast":["AUs","AUq","AUr"],
"beat":["AUx","AUt","AUu","AUv","AUw"],
"beautiful":["C53","AU4","AUy","AUz","AU0","AU1","AU2"],
"beautifully":["AU3"],
"beauty":["AU8","AU5","AU6"],
"beauty contest":["AU7"],
"beauty salon":["AU9","AVA","AVB"],
"beaver":["AVI","AVC","AVD","AVE","AVF","AVG","AVH"],
"become":["AVJ"],
"bed":["C54","AVS","AVK","AVL","AVM","AVN","AVO","AVP"],
"bed and breakfast":["AVQ","AVR"],
"bedroom":["C55","AVW","AVT","AVU","AVV"],
"bedside table":["AVX","AVY","AVZ","AVa"],
"bedtime":["AVe","AVb","AVc","AVd"],
"bee":["C57","AVt","AVf","AVg","AVh","AVi","AVj","AVk","AVl"],
"beef":["C56","AVs","AVm","AVn","AVo","AVp","AVq","AVr"],
"beer":["AVz","AVu","AVv","AVw","AVx","AVy"],
"bees":["AV2","AV0","AV1"],
"beetle":["C58","AV7","AV3","AV4","AV5","AV6"],
"beetroot":["AV8"],
"beetroots":["AWB","AV9","AWA"],
"beggar":["AWG","AWC","AWD","AWE","AWF"],
"begin":["AWI","AWH"],
"behind":["DdH","DdF","DdG","AWJ"],
"beige":["C59","AWM","AWK","AWL"],
"beijing":["AWP","AWN","AWO"],
"being happy":["Det"],
"being polite":["Dop"],
"being unhappy":["Deu"],
"Belgium":["AWT","AWQ","AWR","AWS"],
"believe":["AWV","AWU"],
"bell":["AWb","AWW","AWX","AWY","AWZ"],
"bell peppers":["C6A"],
"bellboy":["AWa"],
"bells":["AWc"],
"belly":["C6C","AWf","AWd","AWe"],
"belly button":["C6B"],
"below":["AWj","AWg","AWh","AWi"],
"belt":["C6D","AWn","AWk","AWl","AWm"],
"beluga":["AWq","AWo","AWp"],
"bench":["C6E","AWx","AWr","AWs","AWt","AWu","AWv","AWw"],
"bend":["Doq"],
"benefit":["AWy"],
"benefits":["AWz"],
"bengal fox":["AW0","AW1"],
"bengal tiger":["AW2","AW3"],
"berries":["AXB","AW8","AW9","AXA"],
"berry":["AXD","AXC"],
"best":["AXM","AXE","AXF"],
"best friend":["AXG","AXH"],
"best friends":["AXI","AXJ","AXK","AXL"],
"bet":["AXQ","AXN","AXO","AXP"],
"betray":["AXR"],
"better":["C6F","AXS"],
"between":["DdJ","DdI"],
"beverage":["AXV","AXT","AXU"],
"beverages":["DSo","AXW"],
"Bhutan":["AXb","AXX","AXY","AXZ","AXa"],
"bib":["Dor"],
"bicycle":["AXf","AXc","AXd","AXe"],
"big":["C6K","C6G","AXv"],
"big ben":["Dos"],
"big brother":["AXg","AXh"],
"big buddha":["AXi","AXj"],
"big dog":["AXk","AXl"],
"big ears":["AXm","AXn","AXo"],
"big elephant":["AXp","AXq","AXr"],
"big eyes":["AXs","AXt","AXu"],
"big sister":["AXw"],
"big teeth":["AXx"],
"big toe":["C6L"],
"big wheel":["AXy","AXz"],
"bigger":["C6J","C6H","C6I"],
"bike":["C6M","AYD","AX0","AX1","AX2","AX3","AX4"],
"bike lock":["AX5","AX6","AX7","AX8"],
"bike path":["AX9","AYA","AYB","AYC"],
"bike rack":["AYE","AYF","AYG"],
"bike rides":["AYH"],
"bikini":["AYN","AYI","AYJ","AYK","AYL","AYM"],
"bill":["Dot"],
"billboard":["C6N"],
"bin":["C6O","AYY","AYO","AYP","AYQ","AYR"],
"bin bag":["AYS","AYT"],
"binoculars":["AYX","AYU","AYV","AYW"],
"biodiversity":["AYa","AYZ"],
"biography":["Dou"],
"biology":["C6P","AYd","AYb","AYc"],
"bionic":["AYg","AYe","AYf"],
"birch":["AYh"],
"bird":["C6R","C6Q","AYu","AYi","AYj","AYk","AYl","AYm","AYn"],
"bird bath":["AYo","AYp"],
"bird house":["AYq","AYr","AYs","AYt"],
"bird table":["AYy"],
"birds":["AYx","AYv","AYw"],
"birth":["AY8"],
"birthday":["AY7","AYz","AY0","AY1","AY2","AY3"],
"birthday cake":["Dov"],
"birthday card":["AY4","AY5"],
"birthday hat":["AY6"],
"birthday party":["C6S"],
"biscuit":["AY9","AZA","AZB"],
"biscuits":["C6T","AZE","AZC","AZD"],
"bison":["AZJ","AZF","AZG","AZH","AZI"],
"bitcoin":["AZK"],
"bite":["Dev","Dew","AZO","AZL","AZM","AZN"],
"bite bit":["Dev","Dew"],
"bite someone":["Dew"],
"biting":["Dev","Dew"],
"biting someone":["Dew"],
"bitter":["AZR","AZP","AZQ"],
"black":["C6f","AZl","AZS"],
"black and blue":["C6U"],
"black and orange":["C6V"],
"black and pink":["C6W"],
"black and red":["C6X"],
"black and white":["C6Y"],
"black and yellow":["C6Z"],
"black bird":["AZX","AZY","AZZ"],
"black cat":["AZc"],
"black coffee":["C6b"],
"black currant":["AZd","AZe","AZf","AZg"],
"black dress":["C6c"],
"black eye":["C6d"],
"black gloves":["C6e"],
"black hair":["AZh"],
"black panther":["AZi","AZj","AZk"],
"black widow":["AZm","AZn","AZo"],
"blackbeard":["AZT"],
"blackberry":["AZW","AZU","AZV"],
"blackboard":["C6a","AZb","AZa"],
"blade":["AZr","AZp","AZq"],
"blame":["AZv","AZs","AZt","AZu"],
"blanket":["AZy","AZw","AZx"],
"blast":["AZ2","AZz","AZ0","AZ1"],
"blaze":["AZ5","AZ3","AZ4"],
"blazer":["C6g"],
"blender":["AaA","AZ6","AZ7","AZ8","AZ9"],
"blind":["AaF","AaB","AaC","AaD","AaE"],
"blink":["AaH","AaG"],
"blizzard":["C6i","C6h","AaL","AaI","AaJ","AaK"],
"block":["Dex","AaR","AaM","AaN","AaO","AaP"],
"block blocked":["Dex"],
"block of flats":["AaQ"],
"block the sun":["Dex"],
"blocking":["Dex"],
"blocking the sun":["Dex"],
"blocks":["AaT","AaS"],
"blog":["AaW","AaU","AaV"],
"blond":["AaZ","AaX","AaY","Dow"],
"blood":["Aad","Aaa","Aab","Aac"],
"blood pressure":["Aae","Aaf"],
"blood test":["Aag"],
"bloom":["Aaj","Aah","Aai"],
"blossom":["Aal","Aak"],
"blouse":["C6j","Aao","Aam","Aan"],
"blow":["Dey","Dez"],
"blow air":["Dey"],
"blow blew":["Dey","Dez"],
"blow bubbles":["Aap","Aaq"],
"blow your nose":["Dez"],
"blowfish":["Aat","Aar","Aas"],
"blowing":["Dez","Dey"],
"blowing air":["Dey"],
"blowing your nose":["Dez"],
"blue":["C6q","Aa4","Aau"],
"blue and green":["C6k"],
"blue and white":["C6l"],
"blue bird":["Aa0"],
"blue coats":["C6n"],
"blue eyes":["Aa1","Aa2","Aa3"],
"blue hat":["C6o"],
"blue pants":["C6p"],
"blue whale":["Aa5","Aa6","Aa7","Aa8","Aa9"],
"blueberries":["C6m","Aay","Aav","Aaw","Aax"],
"blueberry":["Aaz"],
"blurred":["AbB","AbA"],
"blushing":["AbE","AbC","AbD"],
"boar":["AbW","AbF","AbG","AbH"],
"board":["AbV","AbI","AbJ","AbK","AbL","AbM"],
"board game":["C6r","AbN","AbO","AbP","AbQ"],
"boarding pass":["DSp","AbR","AbS","AbT"],
"boarding school":["DSq","AbU"],
"boat":["C6s","Abd","AbX","AbY","AbZ","Aba","Abb","Abc"],
"bobble hat":["Abe","Abf","Abg","Abh","Abi"],
"body":["C6t"],
"body language":["Abl"],
"bodyguard":["Abk","Abj"],
"boil":["De0","Abt","Abm"],
"boil boiled":["De0"],
"boil water":["De0"],
"boiled egg":["Abn","Abo","Abp","Abq","Abr"],
"boiled eggs":["C6u"],
"boiling":["De0","C6w","C6v","Abs"],
"boiling water":["De0"],
"bolt":["C6x","Abx","Abu","Abv","Abw"],
"bone":["Ab0","Aby","Abz"],
"bones":["C6y","Ab2","Ab1"],
"bonfire":["Ab5","Ab3","Ab4"],
"book":["C60","AcJ","Ab6","Ab7","Ab8","Ab9","AcA","AcB"],
"book bag":["AcC"],
"book shelf":["AcM","AcN","AcO","AcP"],
"book shelves":["AcQ","AcR","AcS"],
"bookcase":["C6z","AcI","AcD","AcE","AcF","AcG","AcH"],
"books":["C61","AcY","AcK","AcL"],
"bookshelf":["Dox"],
"bookshop":["AcX","AcT","AcU","AcV","AcW"],
"bookstore":["Acc","AcZ","Aca","Acb"],
"boom":["Ach","Acd"],
"boomerang":["Acg","Ace","Acf"],
"boot":["Acr","Aci","Acj","Ack","Acl","Acm"],
"booth":["Acq","Acn","Aco","Acp"],
"boots":["C62","Acy","Acs","Act","Acu","Acv","Acw","Acx"],
"bored":["C63","Ac3","Acz","Ac0","Ac1","Ac2"],
"boring":["Ac6","Ac4","Ac5"],
"born":["Ac8","Ac7"],
"borrow":["De1","De2","AdC","Ac9","AdA","AdB"],
"borrow a book":["De1"],
"borrow a pen":["De2"],
"borrow borrowed":["De1","De2"],
"borrowing":["De2","De1"],
"borrowing a book":["De1"],
"borrowing a pen":["De2"],
"Bosnia":["AdF","AdD","AdE"],
"boss":["Doy"],
"both":["AdG"],
"bottle":["C65","AdO","AdH","AdI","AdJ","AdK"],
"bottle of ketchup":["AdL"],
"bottle of water":["AdM","AdN"],
"bottle opener":["C64"],
"bottles":["AdS","AdP","AdQ","AdR"],
"bottom":["DdK"],
"boulder":["AdW","AdT","AdU","AdV"],
"bounce":["AdY","AdX"],
"bouquet":["DSr","Adb","AdZ","Ada"],
"boutique":["Adc"],
"bow":["Adv","Add","Ade","Adf"],
"bow tie":["C68"],
"bowl":["De3","C67","Adu","Adg","Adh","Adi","Adj","Adk","Adl"],
"bowl bowled":["De3"],
"bowl of soup":["Adr","Ads"],
"bowl of strawberries":["Adt"],
"bowling":["De3","C66","Adq","Adm","Adn"],
"bowling alley":["Ado","Adp"],
"box":["C7A","Ad5","Adw","Adx","Ady","Adz"],
"boxer":["Ad1","Ad0"],
"boxes":["Doz"],
"boxing":["C69","Ad4","Ad2","Ad3"],
"boy":["AeE","Ad6","Ad7","Ad8"],
"boy scout":["AeG","AeH"],
"boyfriend":["DZL","AeD","Ad9","AeA","AeB","AeC"],
"boys":["AeI","AeF"],
"bracelet":["C7C","C7B","AeN","AeJ","AeK","AeL","AeM"],
"bragging":["DSs","AeO"],
"braids":["DSt","AeQ","AeP"],
"brain":["DSu","AeW","AeR","AeS","AeT","AeU","AeV"],
"brake":["Aea","AeX","AeY","AeZ"],
"branch":["DSv","Aej","Aeb","Aec","Aed","Aee","Aef","Aeg"],
"branches":["Aei","Aeh"],
"brave":["Aeq","Aek","Ael","Aem"],
"bravely":["Aep","Aen","Aeo"],
"Brazil":["C7F","Aeu","Aer","Aes","Aet"],
"Brazil flag":["C7D"],
"Brazilian":["C7E"],
"bread":["C7H","C7G","Aez","Aev","Aew","Aex","Aey"],
"bread roll":["Ae0"],
"bread rolls":["C7I"],
"break":["De7","De4","De5","AfK","Ae1","Ae2","Ae3","Ae4","Ae5"],
"break a cup":["De4"],
"break a window":["De5"],
"break broke":["De4","De5","De7"],
"break down":["De6","Ae6"],
"break down broke down":["De6"],
"break into":["AfI","AfJ"],
"break up":["De8"],
"break up broke up":["De8"],
"breaker":["Ae7"],
"breakfast":["AfF","Ae8","Ae9","AfA","AfB","AfC","AfD","AfE"],
"breaking":["De7","De4","De5"],
"breaking a cup":["De4"],
"breaking a window":["De5"],
"breaking down":["De6"],
"breaking news":["AfG","AfH"],
"breaking up":["De8"],
"breath":["DSx"],
"breathe":["DSw","AfO","AfL","AfM","AfN"],
"breathtaking":["DSy","AfR","AfP","AfQ"],
"breed":["AfT","AfS"],
"breeze":["AfW","AfU","AfV"],
"brick":["Afa","AfX","AfY","AfZ"],
"bricks":["Afc","Afb"],
"bride":["Do0"],
"bridge":["C7J","Afi","Afd","Afe","Aff","Afg","Afh"],
"briefcase":["C7L","C7K","Afn","Afj","Afk","Afl","Afm"],
"bright":["C7N","Afp","Afo"],
"brighter":["C7M"],
"Britain":["Afu","Afq","Afr","Afs","Aft"],
"British":["Afw","Afv"],
"British pound":["Afx","Afy"],
"brittle":["Af0","Afz"],
"broadband":["Af2","Af1"],
"broccoli":["C7O","Af9","Af3","Af4","Af5","Af6","Af7","Af8"],
"brochure":["AgC","AgA","AgB"],
"broke":["AgM","AgD","AgE"],
"broken":["C7R","AgL","AgF","AgG"],
"broken arm":["C7P","AgH","AgI"],
"broken leg":["C7Q","AgJ","AgK"],
"brontosaurus":["AgO","AgN"],
"bronze":["C7S","AgS","AgP","AgQ","AgR"],
"broom":["C7T","AgX","AgT","AgU","AgV","AgW"],
"broomstick":["AgZ","AgY"],
"brother":["DZM","Agd","Aga","Agb","Agc"],
"brothers":["Agg","Age","Agf"],
"brow":["Agq","Agh","Agi","Agj"],
"brown":["C7Y","Agp"],
"brown belt":["C7U"],
"brown coat":["C7V"],
"brown eyes":["Agk","Agl","Agm"],
"brown hair":["Agn","Ago"],
"brown pants":["C7X"],
"brownies":["C7W"],
"browse":["De9","Ags","Agr"],
"browse browsed":["De9"],
"browse the Internet":["De9"],
"browsing":["De9"],
"browsing the Internet":["De9"],
"bruise":["Agt"],
"Brunei":["Agx","Agu","Agv","Agw"],
"brush":["DfA","DfB","DfC","Ag2","Agy","Agz"],
"brush brushed":["DfA","DfB","DfC"],
"brush hair":["Ag0","Ag1"],
"brush my teeth":["Do1"],
"brush teeth":["Ag3","Ag4","Ag5","Ag6","Ag7"],
"brush your hair":["DfB"],
"brush your teeth":["DfC"],
"brushing":["DfA","DfB","DfC"],
"brushing your hair":["DfB"],
"brushing your teeth":["DfC"],
"bubble":["AhA","Ag8","Ag9"],
"bubble tea":["AhF","AhG","AhH","AhI"],
"bubbles":["AhE","AhB","AhC","AhD"],
"bucket":["C7Z","AhN","AhJ","AhK","AhL"],
"bucket and spade":["AhM"],
"buddhism":["AhR","AhO","AhP","AhQ"],
"budget":["AhU","AhS","AhT"],
"budgie":["AhX","AhV","AhW"],
"buffalo":["Ahb","AhY","AhZ","Aha"],
"buffalo wings":["Ahc","Ahd"],
"bug":["Ahg","Ahe","Ahf"],
"bug spray":["Ahh","Ahi"],
"build":["DfD","DfE","DfF","DfG","Ahs","Ahj","Ahk"],
"build a nest":["DfD"],
"build a robot":["DfE"],
"build a snowman":["DfF"],
"build a wall":["DfG"],
"build built":["DfD","DfE","DfF","DfG"],
"builder":["Aho","Ahl","Ahm","Ahn"],
"building":["DfG","DfD","DfE","DfF","Ahr","Ahp","Ahq"],
"building a nest":["DfD"],
"building a robot":["DfE"],
"building a snowman":["DfF"],
"building a wall":["DfG"],
"built":["Do2"],
"bull":["C7a","Ahx","Aht","Ahu","Ahv"],
"bulldog":["Ahw"],
"bump":["Ah3","Ahy","Ahz","Ah0"],
"bumper cars":["Ah1","Ah2"],
"bun":["AiJ","Ah4","Ah5"],
"bunch":["Ah9","Ah6","Ah7"],
"bunch of bananas":["Ah8"],
"bungee jumping":["AiA","AiB","AiC"],
"bunnies":["AiD"],
"bunny":["AiI","AiE","AiF","AiG","AiH"],
"buns":["AiL","AiK"],
"buoyant":["AiO","AiM","AiN"],
"burden":["AiQ","AiP"],
"burger":["C7c","AiZ","AiR","AiS","AiT"],
"burger and chips":["AiU","AiV","AiW"],
"burger and fries":["C7b","AiX","AiY"],
"burgers":["Aic","Aia","Aib"],
"burial tomb":["Aid"],
"burn":["DfH","Aih","Aie","Aif","Aig"],
"burn burnt":["DfH"],
"burning":["DfH"],
"burrito":["C7d","Ail","Aii","Aij","Aik"],
"burrow":["Aim"],
"bury":["Do3"],
"bus":["C7i","Ai7","Ain","Aio","Aip"],
"bus driver":["Aiq","Air","Ais"],
"bus station":["Ai8","Ai9","AjA"],
"bus stop":["C7j","AjB","AjC","AjD","AjE","AjF","Do4"],
"bush":["C7e","Aiy","Ait","Aiu","Aiv"],
"bushes":["Aix","Aiw"],
"busier":["C7f"],
"business":["DS0","Ai3"],
"businessman":["C7h","C7g","DSz","Ai2","Aiz","Ai0","Ai1"],
"businesswoman":["DS1","Ai6","Ai4","Ai5"],
"busy":["AjI","AjG","AjH"],
"butcher":["AjL","AjJ","AjK"],
"butcher's":["Do5"],
"butchers":["AjP","AjM","AjN","AjO"],
"butchery":["AjR","AjQ"],
"butter":["C7l","Aja","AjS","AjT","AjU"],
"butterfly":["C7k","AjZ","AjV","AjW","AjX","AjY"],
"button":["C7m","Ajd","Ajb","Ajc"],
"buttons":["Aje"],
"buy":["DfL","DfI","DfJ","DfK","Ajf"],
"buy a TV":["DfI"],
"buy bought":["DfI","DfJ","DfK","DfL"],
"buy coffee":["DfJ"],
"buy groceries":["DfK"],
"buying":["DfL","DfI","DfJ","DfK"],
"buying a TV":["DfI"],
"buying coffee":["DfJ"],
"buying groceries":["DfK"],
"buzz":["Ajg"],
"by the lake":["Ajj","Ajk"],
"by the river":["Ajl"],
"by the sea":["Ajm"],
"bye":["Aji","Ajh"],
"c":["DZq","DZp"],
"cab":["Aj5","Ajn","Ajo","Ajp"],
"cabbage":["C7n","Ajr","Ajq"],
"cabbages":["Ajs"],
"cabin":["Aj0","Ajt","Aju","Ajv","Ajw"],
"cabinet":["Ajz","Ajx","Ajy"],
"cable":["Aj4","Aj1"],
"cable car":["Aj2","Aj3"],
"cactus":["Aj8","Aj6","Aj7"],
"cafe":["C7p","AkD","Aj9","AkA","AkB","AkC"],
"cafe latte":["C7o"],
"cafeteria":["AkF","AkE"],
"cage":["AkJ","AkG","AkH","AkI"],
"cake":["C7q","AkQ","AkK","AkL","AkM","AkN","AkO","AkP"],
"cakes":["AkR"],
"calculate":["AkU","AkS","AkT"],
"calculator":["C7s","C7r","Aka","AkV","AkW","AkX","AkY","AkZ"],
"calendar":["Akf","Akb","Akc","Akd","Ake"],
"calf":["Akh","Akg"],
"call":["DfN","DfM","Akl","Aki","Akj","Akk"],
"call a friend":["DfM"],
"call called":["DfM","DfN"],
"calling":["DfN","DfM"],
"calling a friend":["DfM"],
"calm":["Ako","Akm","Akn"],
"Cambodia":["Akt","Akp","Akq","Akr","Aks"],
"camel":["C7t","Aky","Aku","Akv","Akw","Akx"],
"camera":["C7w"],
"cameraman":["C7v","C7u"],
"camouflage":["Ak1","Akz","Ak0"],
"camp":["AlB","Ak2","Ak3"],
"camper":["Ak6","Ak4","Ak5"],
"campfire":["Do6"],
"camping":["Ak8","Ak7"],
"camping tent":["Ak9","AlA"],
"campsite":["C7x","AlE","AlC","AlD"],
"can":["C8A","Al5","AlF","AlG","AlH","AlI"],
"can climb a tree":["C71"],
"can drive":["C73"],
"can jump":["C75"],
"can opener":["C76"],
"can play the piano":["C77"],
"can play the trumpet":["C78"],
"can play the violin":["C79"],
"can speak":["C8D"],
"can speak Chinese":["C8B"],
"can speak English":["C8C"],
"can swim":["C8E","C8F"],
"can't climb a tree":["C8G"],
"can't drive":["C8H"],
"can't play the guitar":["C8I"],
"can't read":["C8J"],
"can't ride a bike":["C8K"],
"can't swim":["C8L"],
"can't take a bus":["C8M"],
"can't understand":["C8N"],
"can't use a computer":["C8O"],
"Canada":["C7z","AlO","AlJ","AlK","AlL","AlM","AlN"],
"Canada flag":["C7y"],
"Canadian":["C70"],
"canary":["AlR","AlP","AlQ"],
"candies":["AlT","AlS"],
"candle":["C72","AlY","AlU","AlV","AlW","AlX"],
"candles":["Alc","AlZ","Ala","Alb"],
"candy":["C74","Alk","Ald","Ale","Alf","Alg"],
"candy bar":["Alh"],
"candy cane":["Ali","Alj"],
"candy store":["All","Alm","Aln","Alo"],
"cane":["Als","Alp","Alq","Alr"],
"canned food":["Alt","Alu"],
"cannon":["Aly","Alv","Alw","Alx"],
"canoe":["Al4","Alz","Al0","Al1"],
"canoeing":["Al3","Al2"],
"cantaloupe":["AmB","Al6","Al7","Al8","Al9","AmA"],
"canteen":["AmE","AmC","AmD"],
"canvas":["AmH","AmF","AmG"],
"cap":["C8P","AmR","AmI","AmJ","AmK","AmL"],
"cape":["AmO","AmM","AmN"],
"capital":["AmQ","AmP"],
"capital a":["DZl"],
"capital b":["DZn"],
"capital c":["DZp"],
"capital d":["DZr"],
"capital e":["DZt"],
"capital f":["DZv"],
"capital g":["DZx"],
"capital h":["DZz"],
"capital i":["DZ"],
"capital j":["DZ3"],
"capital k":["DZ5"],
"capital l":["DZ7"],
"capital m":["DZ9"],
"capital n":["DaB"],
"capital o":["DaD"],
"capital p":["DaF"],
"capital q":["DaH"],
"capital r":["DaJ"],
"capital s":["DaL"],
"capital t":["DaN"],
"capital u":["DaP"],
"capital v":["DaR"],
"capital w":["DaT"],
"capital x":["DaV"],
"capital y":["DaX"],
"capital z":["DaZ"],
"cappuccino":["C8Q"],
"captain":["AmV","AmS","AmT","AmU"],
"capture":["AmX","AmW"],
"car":["C8Y","And","AmY","AmZ","Ama","Amb"],
"car crash":["Amo","Amp","Amq"],
"car park":["C8V","AnP","AnQ","AnS"],
"car parking":["AnR"],
"car racing":["Ane"],
"car salesman":["C8a","C8b"],
"car wash":["An9","AoA","AoB"],
"caravan":["Ame","Amc","Amd"],
"carbohydrates":["Ami","Amf","Amg","Amh"],
"carbon dioxide":["Aml","Amm","Amn"],
"carbonated":["Amj"],
"carbonated water":["Amk"],
"card":["Am3","Amr","Ams","Amt"],
"card machine":["Am1","Am2"],
"cardboard":["Amw","Amu","Amv"],
"cardigan":["C8R","Am0","Amx","Amy","Amz"],
"cards":["C8T","C8S","Am5","Am4"],
"care":["DS5","AnC","Am6"],
"career":["DS2","Am7"],
"careful":["DS4","AnB","Am8"],
"carefully":["DS3","AnA","Am9"],
"careless":["Do7"],
"cargo":["DS6","AnF","AnD","AnE"],
"cargo shorts":["C8U"],
"caring":["Do8"],
"carnation":["AnI","AnG","AnH"],
"carnivore":["AnL","AnJ","AnK"],
"carousel":["AnO","AnM","AnN"],
"carpenter":["C8X","C8W","AnX","AnT","AnU","AnV","AnW"],
"carpet":["Anc","AnY","AnZ","Ana","Anb"],
"carriage":["Ang","Anf"],
"carrot":["Ann","Anh","Ani","Anj","Ank"],
"carrot cake":["Anl","Anm"],
"carrots":["C8Z","Anp","Ano"],
"carry":["DfQ","DfO","DfP","Anu","Anq","Anr","Ans","Ant"],
"carry a bag":["DfO"],
"carry a box":["DfP"],
"carry carried":["DfO","DfP","DfQ"],
"carrying":["DfQ","DfO","DfP"],
"carrying a bag":["DfO"],
"carrying a box":["DfP"],
"cart":["An6","Anv","Anw","Anx"],
"carton":["An3","Any","Anz","An0"],
"carton of milk":["An1","An2"],
"cartoon":["An5","An4"],
"carve":["An8","An7"],
"case":["AoE","AoC","AoD"],
"cash":["AoK","AoF","AoG","AoH"],
"cash register":["AoL","AoM"],
"cashier":["C8d","C8c","AoJ","AoI"],
"cask":["AoN"],
"cast":["AoS"],
"castle":["C8e","AoR","AoO","AoP","AoQ"],
"casual":["AoW","AoT","AoU","AoV"],
"cat":["C8g","Aoz","AoX","AoY","AoZ","Aoa","Aob"],
"cat and mouse":["Aoc","Aod","Aoe","Aof"],
"catapult":["Aoj","Aog","Aoh","Aoi"],
"catch":["DfT","DfR","DfS","Aor","Aok","Aol","Aom"],
"catch a ball":["DfR","Aon"],
"catch a cold":["DS7","Aoo","Aop"],
"catch a fish":["DfS","Aoq"],
"catch caught":["DfR","DfS","DfT"],
"catching":["DfT","DfR","DfS"],
"catching a ball":["DfR"],
"catching a fish":["DfS"],
"caterpillar":["C8f","Aow","Aos","Aot","Aou","Aov"],
"catfish":["Aoy","Aox"],
"cathedral":["Do9"],
"cats":["Ao0"],
"cattle":["Ao2","Ao1"],
"caught":["Ao4","Ao3"],
"cauldron":["Ao7","Ao5","Ao6"],
"cauliflower":["C8h","ApD","Ao8","Ao9","ApA","ApB"],
"cauliflower cheese":["ApC"],
"caution":["ApF","ApE"],
"cautious":["ApG"],
"cave":["ApJ","ApH","ApI"],
"cavern":["ApM","ApK","ApL"],
"cd":["ApP","ApN"],
"cd player":["ApO"],
"cds":["ApQ"],
"cease":["ApR"],
"cedar":["ApT","ApS"],
"ceiling":["ApX","ApU","ApV","ApW"],
"celebrate":["DfW","DfU","DfV","ApZ","ApY"],
"celebrate celebrated":["DfU","DfV","DfW"],
"celebrate Christmas":["DfU"],
"celebrate new year":["DfV"],
"celebrating":["DfW","DfU","DfV","Apb","Apa"],
"celebrating Christmas":["DfU"],
"celebrating new year":["DfV"],
"celebration":["Apc"],
"celery":["C8i","Apg","Apd","Ape","Apf"],
"celestial":["DS8","Api","Aph"],
"cell":["Apu"],
"cell phone":["Apq","Apr","Aps","Apt"],
"cellar":["Apl","Apj","Apk"],
"cello":["App","Apm","Apn","Apo"],
"cells":["Apw","Apv"],
"cement":["Apx"],
"cemetery":["Ap1","Apy","Apz","Ap0"],
"center":["DpA"],
"centipede":["Ap6","Ap2","Ap3","Ap4","Ap5"],
"CEO":["C8k","C8j"],
"ceramic":["Ap9","Ap7","Ap8"],
"cereal":["C8l","AqF","AqA","AqB","AqC","AqD"],
"cereal bar":["AqE"],
"ceremony":["AqH","AqG"],
"chain":["C8m","AqL","AqI","AqJ","AqK"],
"chair":["C8n","AqQ","AqM","AqN","AqO","AqP"],
"chairs":["AqV","AqR","AqS","AqT","AqU"],
"chalet":["AqY","AqW","AqX"],
"chalk":["Aqd","AqZ","Aqa","Aqb","Aqc"],
"challenge":["Aqg","Aqe","Aqf"],
"challenging":["Aqh"],
"chameleon":["Aqm","Aqi","Aqj","Aqk","Aql"],
"chance":["Aqo","Aqn"],
"change":["DfX","DfY","Aqr","Aqp","Aqq"],
"change a lightbulb":["DfX"],
"change changed":["DfX","DfY"],
"change into a butterfly":["DfY"],
"changing":["DfY","DfX"],
"changing a lightbulb":["DfX"],
"changing into a butterfly":["DfY"],
"chaos":["Aqw","Aqs","Aqt","Aqu","Aqv"],
"charge":["DfZ","Dfa","Aqz","Aqx","Aqy"],
"charge a phone":["DfZ","Dfa"],
"charge charged":["Dfa","DfZ"],
"charger":["Aq2","Aq0","Aq1"],
"charging":["Dfa","DfZ"],
"charging a phone":["DfZ","Dfa"],
"charity":["Aq6","Aq3","Aq4","Aq5"],
"charity shop":["Aq7"],
"Charles darwin":["Aq8"],
"chase":["Dfb","ArC","Aq9","ArA","ArB"],
"chase a mouse":["Dfb"],
"chase chased":["Dfb"],
"chasing":["Dfb"],
"chasing a mouse":["Dfb"],
"chat":["DpB"],
"chauffeur":["C8p","C8o"],
"cheap":["C8s","ArE","ArD"],
"cheaper":["C8r","C8q"],
"cheat":["DS9"],
"check":["Dfc","DTC"],
"check checked":["Dfc"],
"check in":["DTB"],
"check the bill":["DTD"],
"check the dog":["Dfc"],
"checked":["DTA"],
"checking":["Dfc"],
"checking the dog":["Dfc"],
"cheek":["ArF"],
"cheeks":["DTE"],
"cheer":["DTH","ArM"],
"cheerful":["DTF","ArG"],
"cheerleader":["DTG","ArL","ArH","ArI","ArJ","ArK"],
"cheese":["C8u","Are","ArN","ArO","ArP","ArQ","ArR"],
"cheese and tomato":["ArS","ArT"],
"cheese burger":["C8t"],
"cheese sandwich":["Arf","Arg"],
"cheese toastie":["C8v"],
"cheeseburger":["ArY","ArU","ArV","ArW","ArX"],
"cheesecake":["Ard","ArZ","Ara","Arb","Arc"],
"cheetah":["Arj","Arh","Ari"],
"chef":["C8x","C8w","Arp","Ark","Arl","Arm","Arn","Aro"],
"chemical engineer":["C8y","C8z"],
"chemical fertilizer":["Arq"],
"chemist":["DpC"],
"chemistry":["C80","DTI","Aru","Arr","Ars","Art"],
"cherish":["Arw","Arv"],
"cherries":["C81","Arz","Arx","Ary"],
"cherry":["Ar2"],
"cherry pie":["Ar0","Ar1"],
"chess":["C82","Ar6","Ar3","Ar4","Ar5"],
"chest":["AsB","Ar7"],
"chest of drawers":["Ar8","Ar9","AsA"],
"chest x ray":["AsC","AsD"],
"chewing gum":["AsE"],
"chichen itza":["AsF"],
"chick":["Asb","AsG","AsH"],
"chicken":["C87","C83","AsT","AsI","AsJ","AsK","AsL","AsM"],
"chicken and rice":["C84"],
"chicken leg":["C85","AsN","AsO"],
"chicken nugget":["AsP","AsQ","AsR"],
"chicken nuggets":["C86","AsS"],
"chicken wing":["C88","AsU"],
"chicken wings":["AsV","AsW","AsX"],
"chickpeas":["Asa","AsY","AsZ"],
"child":["Asf","Asc","Asd","Ase"],
"children":["Asj","Asg","Ash","Asi"],
"chili":["Asn","Ask","Asl","Asm"],
"chilies":["C89"],
"chill":["Ast","Aso"],
"chilli peppers":["Asp","Asq","Asr","Ass"],
"chilly":["Asu"],
"chimney":["C9A","Asy","Asv","Asw","Asx"],
"chimp":["As3","Asz"],
"chimpanzee":["As2","As0","As1"],
"chin":["C9F","AtF","As4","As5"],
"China":["C9C","AtA","As6","As7","As8","As9"],
"China flag":["C9B"],
"Chinese":["C9E","C9D","AtE","AtB","AtC"],
"Chinese new year":["AtD"],
"chips":["AtL","AtG","AtH","AtI","AtJ","AtK"],
"chips and dip":["C9G"],
"chirp":["AtN","AtM"],
"chisel":["AtR","AtO","AtP","AtQ"],
"chocolate":["C9I","Atg","AtS","AtT","AtU","AtV"],
"chocolate bar":["AtW","AtX","AtY","AtZ"],
"chocolate cake":["Ata","Atb","Atc","Atd","Ate"],
"chocolate milk":["Atf"],
"chocolate milkshake":["C9H"],
"choice":["Atj","Ath","Ati"],
"choir":["Atl","Atk"],
"choke":["Atm"],
"choose":["Ato","Atn"],
"chop":["Dfd","Atr","Atp","Atq"],
"chop an onion":["Dfd"],
"chop chopped":["Dfd"],
"chopping":["Dfd"],
"chopping an onion":["Dfd"],
"chopping board":["C9J"],
"chopsticks":["C9K","Atx","Ats","Att","Atu","Atv","Atw"],
"Christ":["AuF"],
"Christ the redeemer":["AuG"],
"Christmas":["C9L","At7","Aty","Atz"],
"Christmas candle":["At0","At1","At2"],
"Christmas dinner":["At3","At4","At5","At6"],
"Christmas stocking":["At8","At9","AuA","AuB"],
"Christmas tree":["C9M","AuC","AuD","AuE"],
"chrysanthemum":["AuI","AuH"],
"chubby":["AuM","AuJ","AuK","AuL"],
"church":["C9N","AuQ","AuN","AuO","AuP"],
"churro":["AuT","AuR","AuS"],
"Cinderella":["AuW","AuU","AuV"],
"cinema":["AuZ","AuX","AuY"],
"circle":["Auc","Aua","Aub"],
"circular saw":["Aud","Aue","Auf","Aug","Auh"],
"circus":["Aul","Aui","Auj","Auk"],
"citadel":["Aum"],
"city":["Aut","Aun","Auo","Aup","Auq"],
"city hall":["Aur","Aus"],
"civil engineer":["C9O","C9P"],
"civilization":["Auv","Auu"],
"clam":["Aux","Auw"],
"clams":["Au0","Auy","Auz"],
"clap":["Au5","Au1","Au2","Au3","Au4"],
"clarinet":["C9Q","Au9","Au6","Au7","Au8"],
"clasp":["AvA"],
"class":["AvL","AvB"],
"classic":["AvI","AvC","AvD"],
"classical":["AvH","AvE"],
"classical music":["AvF","AvG"],
"classmate":["AvJ"],
"classmates":["AvK"],
"classroom":["C9R","AvO","AvM","AvN"],
"claw":["AvQ","AvP"],
"claws":["AvR"],
"clay":["DpD"],
"clean":["Dfe","Dff","C9W","Ava","AvS"],
"clean cleaned":["Dfe","Dff"],
"clean teeth":["Avb"],
"clean the floor":["Dfe"],
"clean the house":["Avc","Avd"],
"clean the window":["Dff"],
"clean up":["Ave","Avf"],
"cleaner":["C9V","C9S","C9T","C9U","AvX","AvT","AvU","AvV","AvW"],
"cleaning":["Dfe","Dff","AvZ","AvY"],
"cleaning the floor":["Dfe"],
"cleaning the window":["Dff"],
"cleanup":["Avg"],
"clear":["Avi","Avh"],
"clear sky":["Avj","Avk"],
"cleaver":["C9X","Avo","Avl","Avm","Avn"],
"clerk":["Avq","Avp"],
"clever":["Avt","Avr","Avs"],
"click":["Dfg","Avw","Avu","Avv"],
"click clicked":["Dfg"],
"click on":["DpE"],
"click the mouse":["Dfg"],
"clicking":["Dfg"],
"clicking the mouse":["Dfg"],
"cliff":["Avz","Avx","Avy"],
"cliffs":["C9Y","Av1","Av0"],
"climate":["Av7","Av2","Av3","Av4"],
"climate change":["Av5","Av6"],
"climb":["Dfk","Dfh","Dfi","Dfj","AwD","Av8"],
"climb a mountain":["Dfi"],
"climb a tree":["Dfj"],
"climb climbed":["Dfh","Dfi","Dfj","Dfk"],
"climber":["AwA","Av9"],
"climbing":["Dfk","Dfh","Dfi","Dfj","AwC","AwB"],
"climbing a mountain":["Dfi"],
"climbing a tree":["Dfj"],
"clinic":["AwF","AwE"],
"clip":["AwG"],
"clipboard":["C9Z"],
"clock":["C9a","AwL","AwH","AwI","AwJ","AwK"],
"clocks":["AwM"],
"close":["Dfo","Dfl","Dfm","Dfn","Dfp"],
"close a laptop":["Dfm"],
"close a window":["Dfn"],
"close closed":["Dfm","Dfl","Dfn","Dfo","Dfp"],
"close the window":["Dfp"],
"closed":["DpF"],
"closet":["C9b","AwN"],
"closing":["Dfo","Dfl","Dfm","Dfn","Dfp"],
"closing a laptop":["Dfm"],
"closing a window":["Dfn"],
"closing the window":["Dfp"],
"cloth":["Awc"],
"clothes":["AwT","AwO","AwP"],
"clothes line":["AwQ","AwR","AwS"],
"clothes lines":["C9c"],
"clothes rack":["AwU","AwV","AwW"],
"clothes shop":["AwX","AwY","AwZ","Awa","Awb"],
"clothing store":["DpG"],
"cloud":["Awi","Awd","Awe","Awf","Awg","Awh"],
"clouds":["C9d","Awo","Awj","Awk","Awl","Awm","Awn"],
"cloudy":["C9f","C9e","Awr","Awp","Awq"],
"clown":["C9h","C9g","Awx","Aws","Awt","Awu","Awv"],
"clown mask":["Aww"],
"club":["Awz","Awy"],
"clue":["Aw1","Aw0"],
"cluster":["Aw2"],
"coach":["C9j","C9i","Aw6","Aw3","Aw4","Aw5","DpH"],
"coal":["AxB","Aw7","Aw8","Aw9","AxA"],
"coal miner":["C9k","C9l"],
"coast":["AxE","AxC","AxD"],
"coat":["C9o","AxK","AxF","AxG","AxH","AxI"],
"coat hangar":["C9m"],
"coat hook":["C9n"],
"coat rack":["C9p","AxL","AxM","AxN"],
"coathook":["AxJ"],
"cobbler":["AxQ","AxO","AxP"],
"cobblestone":["AxS","AxR"],
"cobra":["AxU","AxT"],
"cobweb":["Axa","AxV","AxW","AxX","AxY","AxZ"],
"coca cola":["Axb","Axc","Axd"],
"cockerel":["Axg","Axe","Axf"],
"cockroach":["Axo","Axh","Axi","Axj","Axk"],
"cockroaches":["Axn","Axl","Axm"],
"cocoa":["Axs","Axp","Axq","Axr"],
"coconut":["Ax4","Axt","Axu","Axv","Axw","Axx"],
"coconut juice":["Axy","Axz"],
"coconut milk":["Ax0","Ax1","Ax2","Ax3"],
"coconuts":["Ax9","Ax5","Ax6","Ax7","Ax8"],
"coding":["AyC","AyA","AyB"],
"coffee":["C9r","AyJ","AyD","AyE","AyF","AyG","AyH","AyI"],
"coffee machine":["C9q"],
"coffee shop":["AyK","AyL","AyM","AyN","AyO","AyP"],
"coffee table":["AyQ","AyR","AyS","AyT"],
"coffin":["DpI"],
"coin":["AyX","AyU","AyV","AyW"],
"coins":["C9s","Ayd","AyY","AyZ","Aya","Ayb","Ayc"],
"coke":["DpJ"],
"cola":["C9t","Ayi","Aye","Ayf","Ayg","Ayh"],
"cold":["C9x","C9u","C9v","Aym","Ayj","Ayk","Ayl"],
"colder":["C9w"],
"collapse":["Dfq","Ayp","Ayn","Ayo"],
"collapse collapsed":["Dfq"],
"collapsing":["Dfq"],
"collar":["DpK"],
"collect":["Dfr","Ays","Ayq"],
"collect collected":["Dfr"],
"collect garbage":["Dfr"],
"collect stamps":["DpL"],
"collecting":["Dfr"],
"collecting garbage":["Dfr"],
"collection":["Ayr"],
"college":["Ayz","Ayt","Ayu","Ayv","Ayw","Ayx","Ayy"],
"colonel":["Ay0"],
"colony":["Ay1"],
"color":["AzI","Ay2","Ay3"],
"color pen":["AzH"],
"colored pencil":["Ay4"],
"colored pencils":["Ay5","Ay6","Ay7"],
"colorful":["C9y","AzB","Ay8","Ay9","AzA"],
"coloring book":["AzC","AzD","AzE"],
"coloring picture":["AzF","AzG"],
"colors":["AzL","AzJ","AzK"],
"colosseum":["AzQ","AzM","AzN","AzO","AzP"],
"coloured pencils":["DpM"],
"colours":["DpN"],
"column":["AzW","AzR","AzS","AzT","AzU","AzV"],
"comb":["Dfs","Dft","C9z","Azc","AzX","AzY","AzZ"],
"comb combed":["Dfs","Dft"],
"comb hair":["Aza"],
"comb her hair":["Dfs"],
"comb your hair":["Dft"],
"combine":["Azb"],
"combing":["Dft","Dfs"],
"combing her hair":["Dfs"],
"combing your hair":["Dft"],
"come":["Dfu"],
"come came":["Dfu"],
"come from America":["Dfu"],
"come here":["DpQ"],
"come in":["Azd"],
"comedian":["DpO"],
"comedy":["DpP"],
"comet":["Azh","Aze","Azf","Azg"],
"comfort":["DTK","Azr","Azi","Azj","Azk"],
"comfortable":["DTJ","Azo","Azl","Azm","Azn"],
"comforter":["Azq","Azp"],
"comic book":["Azs"],
"coming":["Dfu"],
"coming from America":["Dfu"],
"common":["DpR"],
"communal":["DTM"],
"communal house":["DTL"],
"communicate":["DpS"],
"communication":["DpT"],
"community":["DTN","Azt"],
"companion":["DTO","Azx","Azu","Azv","Azw"],
"company":["DTP"],
"compare":["Azz","Azy"],
"comparison":["DTQ","Az0"],
"compass":["DTS","Az3","Az1","Az2"],
"compassion":["DTR"],
"compatible":["Az4"],
"competition":["Az5"],
"competitive":["Az6"],
"complete":["Az8","Az7"],
"complex":["DTT","A0B","Az9","A0A"],
"complicated":["A0D","A0C"],
"comply":["DTU"],
"compose":["DTV"],
"composer":["DpU"],
"comprehend":["A0E"],
"comprehension":["DTW"],
"computer":["C90","A0Q","A0F","A0G","A0H"],
"computer game":["A0I","A0J","A0K"],
"computer games":["DpV"],
"computer lab":["A0L","A0M"],
"computer mouse":["A0N","A0O","A0P"],
"computer problem":["A0R"],
"computer programmer":["A0S","A0T"],
"computer room":["A0U"],
"computer technician":["C91","C92","A0V","A0W"],
"computing":["C93"],
"concentrate":["Dfv"],
"concentrate concentrated":["Dfv"],
"concentrating":["Dfv"],
"concentration":["DTX","A0X"],
"concept":["DTY"],
"concerned":["DTa","DTZ","A0Y"],
"concert":["A0d","A0Z","A0a"],
"concert hall":["A0b","A0c"],
"condor":["A0f","A0e"],
"conduct":["A0i"],
"conductor":["DTb","A0h","A0g"],
"cone":["DTc","A0l","A0j","A0k"],
"confident":["DTd","A0m"],
"confirm":["DTe","A0q","A0n","A0o"],
"confirmation":["A0p"],
"confused":["C94","A0s","A0r"],
"confusing":["DTf","A0u","A0t"],
"conga":["A0v"],
"connect":["Dfw","A0x","A0w"],
"connect a phone":["Dfw"],
"connect connected":["Dfw"],
"connecting":["Dfw"],
"connecting a phone":["Dfw"],
"conservation":["DTg","A0z","A0y"],
"console":["DTh","A00"],
"conspicuous":["DTi"],
"constellation":["DTj","A02","A01"],
"constitutional":["A03"],
"constitutionalist":["DTk"],
"construct":["Dfx"],
"construct a building":["Dfx"],
"construct constructed":["Dfx"],
"constructing":["Dfx"],
"constructing a building":["Dfx"],
"construction area":["A04","A05","A06"],
"construction site":["C95"],
"construction worker":["C96","C97","A07","A08","A09"],
"consumers":["DTl"],
"consumption":["DTm"],
"container":["A1B","A1A"],
"containers":["DTn"],
"contest":["A1C"],
"contract":["DTo","A1G","A1D","A1E","A1F"],
"contrail":["DTp","A1J","A1H","A1I"],
"contribute":["DTq"],
"control":["Dfy"],
"control a drone":["Dfy"],
"control controlled":["Dfy"],
"controling":["Dfy"],
"controling a drone":["Dfy"],
"controller":["C98"],
"convenience store":["C99"],
"conversation":["DTr","A1N","A1K","A1L","A1M"],
"cook":["Df1","Dfz","Df0","A1T","A1O"],
"cook cooked":["Df0","Dfz","Df1"],
"cook food":["Df0"],
"cooked":["DpW"],
"cooker":["DpX"],
"cookie":["DAA","A1Q","A1P"],
"cookies":["A1S","A1R"],
"cooking":["Df1","Dfz","Df0"],
"cooking food":["Df0"],
"cool":["Df2"],
"cool cooled":["Df2"],
"cool the room":["Df2"],
"cooling":["Df2"],
"cooling the room":["Df2"],
"copper":["DAB","A1W","A1U","A1V"],
"coral":["DTs","A1Z","A1X","A1Y"],
"coral reef":["A1a"],
"cord":["A1b"],
"core":["A1d","A1c"],
"corgi":["A1f","A1e"],
"coriander":["A1i","A1g","A1h"],
"corkscrew":["DAC"],
"corn":["DAD","A17","A1j","A1k","A1l","A1m","A1n","A1o"],
"corn dog":["A1p","A1q"],
"corn field":["A1w","A1x"],
"cornbread":["DTt"],
"corner":["DTu","A1u","A1r","A1s","A1t"],
"corner shop":["DTv","A1v"],
"cornflakes":["A13","A1y","A1z","A10","A11","A12"],
"cornflower":["A14"],
"cornish pasty":["A15","A16"],
"corridor":["DAE","DTw","A2A","A18","A19"],
"corruption":["DTx"],
"cosmos":["A2B"],
"cost":["Df3","A2C"],
"cost cost":["Df3"],
"cost one dollar":["Df3"],
"costing":["Df3"],
"costume":["A2F","A2D","A2E"],
"cosy":["A2J","A2G","A2H","A2I"],
"cot":["A2O","A2K","A2L","A2M","A2N"],
"cottage":["A2S","A2P","A2Q","A2R"],
"cotton":["A2W","A2T","A2U","A2V"],
"couch":["A2b","A2X","A2Y","A2Z","A2a"],
"cough":["Df4","DAF","A2c"],
"cough coughed":["Df4"],
"cough syrup":["A2d"],
"coughing":["Df4"],
"counter":["DpY"],
"counting":["A2g","A2e","A2f"],
"country":["A2k"],
"country house":["A2h","A2i","A2j"],
"countryside":["A2m","A2l"],
"couple":["A2p","A2n","A2o"],
"coupons":["A2q"],
"courage":["A2r"],
"courthouse":["A2t","A2s"],
"courtyard":["A2w","A2u","A2v"],
"cousin":["DZN"],
"cousins":["DZO","A2y","A2x"],
"cow":["DAG","A25","A2z","A20"],
"coward":["A21"],
"cowboy":["A24","A22","A23"],
"cows":["A28","A26","A27"],
"crab":["DAH","A3E","A29","A3A","A3B","A3C","A3D"],
"crack":["Df5","A3M","A3F","A3G","A3H"],
"crack cracked":["Df5"],
"crack the screen":["Df5"],
"cracked":["DAI"],
"cracker":["A3L","A3I","A3J","A3K"],
"crackers":["DpZ"],
"cracking":["Df5"],
"cracking the screen":["Df5"],
"crane":["A3Q","A3N","A3O","A3P"],
"cranky":["A3R"],
"crash":["Df6","A3U","A3S","A3T"],
"crash a car":["Df6"],
"crash crashed":["Df6"],
"crashing":["Df6"],
"crashing a car":["Df6"],
"crater":["A3W","A3V"],
"crawl":["A3Y","A3X"],
"crayon":["A3Z"],
"crayons":["DAJ","A3e","A3a","A3b","A3c","A3d"],
"crazy":["DTy","A3i","A3f","A3g","A3h"],
"cream":["A3j"],
"creative":["A3k"],
"creativity":["DTz","A3l"],
"creature":["DT0","A3m"],
"credit card":["DAK","A3n","A3o","A3p","A3q","A3r"],
"creepy":["DT1","A3v","A3s"],
"creepy clown":["A3t"],
"creepy house":["A3u"],
"crepe":["A3y","A3w","A3x"],
"crescent":["A31","A3z","A30"],
"crest":["A32"],
"crew":["A34","A33"],
"crib":["Dpa"],
"cricket":["DAL","A4B","A35","A36","A37","A38","A39","A4A"],
"cried":["Dpb"],
"crime":["A4D","A4C"],
"criminal":["A4E"],
"cripple":["A4F"],
"crisps":["A4H","A4G"],
"crocodile":["DAM","A4N","A4I","A4J","A4K","A4L","A4M"],
"croissant":["DAN","A4T","A4O","A4P","A4Q","A4R","A4S"],
"croissants":["A4W","A4U","A4V"],
"crops":["A4Y","A4X"],
"croquet":["A4c","A4Z","A4a","A4b"],
"cross":["Df7","A4i","A4d","A4e"],
"cross crossed":["Df7"],
"cross the road":["Df7"],
"cross walk":["A4m","A4n","A4o","A4p"],
"crossing":["Df7","A4h"],
"crossing guard":["A4f","A4g"],
"crossing the road":["Df7"],
"crossroad":["A4l","A4j","A4k"],
"crosswalk":["Dpc"],
"crossword":["A4r","A4q"],
"crow":["A47","A4s","A4t","A4u","A4v"],
"crowd":["A42","A4w","A4x"],
"crowded":["A41","A4y","A4z","A40"],
"crown":["DAO","A46","A43","A44","A45"],
"crude oil":["A48","A49"],
"cruise":["A5C","A5A","A5B"],
"crunches":["A5D"],
"crush":["A5E"],
"crust":["A5G"],
"crustacean":["A5F"],
"crutches":["DAP"],
"cry":["Df8","A5J"],
"cry cried":["Df8"],
"crying":["Df8","A5I","A5H"],
"crystals":["A5L","A5K"],
"cub":["A5T"],
"Cuba":["A5P","A5M","A5N","A5O"],
"cube":["A5R","A5Q"],
"cuboid":["A5S"],
"cucumber":["DAQ","A5X","A5U","A5V","A5W"],
"cucumbers":["A5Y"],
"cue":["A5Z"],
"cultivate":["DT2","A5b","A5a"],
"cultivation":["DT3","A5c"],
"culture":["Dpd"],
"cumbersom":["DT4"],
"cunning":["DT5","A5d"],
"cup":["DAT","A55","A5e","A5f","A5g","A5h"],
"cup cake":["DAS"],
"cup of coffee":["A5x","A5y","A5z"],
"cup of hot chocolate":["A50"],
"cup of tea":["A51","A52","A53","A54"],
"cupboard":["DAR","A5m","A5i","A5j","A5k","A5l"],
"cupcake":["A5q","A5n","A5o","A5p"],
"cupcakes":["A5t","A5r","A5s"],
"cupid":["A5w","A5u","A5v"],
"cups":["A56"],
"cure":["DT6"],
"curfew":["DT7"],
"curious":["DT8","A57"],
"curly":["A6A"],
"curly hair":["A58","A59"],
"currency":["A6D","A6B","A6C"],
"curry":["A6G","A6E","A6F"],
"curry and rice":["DAU"],
"curtain":["A6I","A6H"],
"curtains":["DAV","A6M","A6J","A6K","A6L"],
"cushion":["DAW","A6Q","A6N","A6O","A6P"],
"cushions":["A6T","A6R","A6S"],
"custard apple":["A6U","A6V"],
"custody":["DT9"],
"customer":["Dpe"],
"customers":["DUA"],
"customize":["DUB"],
"customs":["DUC"],
"cut":["DgC","Df9","DgA","DgB","DAX"],
"cut cut":["Df9","DgA","DgB","DgC"],
"cut down a tree":["Df9"],
"cut paper":["DgA","DgB"],
"cute":["A6W"],
"cutlery":["A6Y","A6X"],
"cutting":["DgC","Df9","DgA","DgB"],
"cutting down a tree":["Df9"],
"cutting paper":["DgA","DgB"],
"cyan":["DAY"],
"cyberbullying":["DUD"],
"cycle":["DgD"],
"cycle cycled":["DgD"],
"cycle lane":["A6Z","A6a","A6b","A6c"],
"cycling":["DgD","DAZ","A6f","A6d","A6e"],
"cylinder":["A6h","A6g"],
"cypress tree":["A6i"],
"czar":["A6j"],
"Czech flag":["DAa"],
"Czech republic":["A6k","A6l","A6m"],
"d":["DZs","DZr"],
"dachshund":["A6n"],
"dad":["A6t","A6o","A6p","A6q"],
"daddy":["A6s","A6r"],
"daffodil":["A6u"],
"dahlia":["A6v"],
"dairy":["A6x","A6w"],
"daisy":["A60","A6y","A6z"],
"dam":["DUF","A65","A61","A62"],
"damage":["DUE","A64","A63"],
"damp":["A66"],
"dance":["DgF","DgE","A69","A67","A68"],
"dance danced":["DgF","DgE"],
"danced":["Dpf"],
"dancer":["DAc","DAb","A7B","A7A"],
"dancing":["DgF","DgE","A7C"],
"danger":["A7G","A7D","A7E"],
"dangerous":["DAd","A7F"],
"dark":["A7K","A7H"],
"dark blue":["DAe"],
"dark brown":["DAf"],
"dark green":["DAh"],
"dark hair":["A7I"],
"dark red":["DAi"],
"darker":["DAg"],
"darkness":["A7J"],
"darts":["DAj","A7Q","A7L","A7M","A7N","A7O","A7P"],
"date":["A7S","A7R"],
"daughter":["DZQ","A7V","A7T","A7U"],
"daughter-in-law":["DZP"],
"dawn":["A7Y","A7W","A7X"],
"daydream":["A7b","A7Z","A7a"],
"dazzling":["A7c"],
"dead":["DAk"],
"deal":["A7d"],
"death":["Dpg"],
"debate":["DgG"],
"debate debated":["DgG"],
"debating":["DgG"],
"decay":["A7e"],
"December":["Dph"],
"decide":["Dpi"],
"deck":["A7i"],
"deck chair":["A7f","A7g","A7h"],
"deckchair":["DAl"],
"declare":["DUG"],
"decline":["DUH","A7l","A7j","A7k"],
"decompose":["DUI","A7m"],
"decorate":["DUJ"],
"decorations":["A7n"],
"decorator":["DAn","DAm"],
"decrease":["DgH","A7q","A7o","A7p"],
"decrease decreased":["DgH"],
"decreasing":["DgH"],
"deep":["A7r"],
"deeper":["DAo"],
"deer":["DAp","A7v","A7s","A7t","A7u"],
"defeat":["A7w"],
"defend":["A7x"],
"deforestation":["DUK","A70","A7y","A7z"],
"degree":["DUL","A71"],
"dejected":["DUM","A72"],
"delete":["DUN","A73"],
"delicious":["DUO"],
"delighted":["Dpj"],
"deliver":["DgJ","DgI","A76","A74","A75"],
"deliver a package":["DgI"],
"deliver delivered":["DgI","DgJ"],
"delivering":["DgJ","DgI"],
"delivering a package":["DgI"],
"delivery":["A77"],
"delivery man":["DAq","DAr"],
"delta":["A78"],
"denim":["A8B","A79","A8A"],
"Denmark":["A8F","A8C","A8D","A8E"],
"Denmark flag":["DAs"],
"dental floss":["DAt"],
"dentist":["DAv","DAu","A8H","A8G"],
"dentistry":["A8I"],
"depart":["DgK"],
"depart departed":["DgK"],
"depart the station":["DgK"],
"departing":["DgK"],
"departing the station":["DgK"],
"department store":["DUP","A8J"],
"departure":["Dpk"],
"deposit":["DgL"],
"deposit deposited":["DgL"],
"deposit money":["DgL"],
"depositing":["DgL"],
"depositing money":["DgL"],
"depressed":["A8M","A8K","A8L"],
"desert":["DAw","A8P","A8N","A8O"],
"design":["DgO","DgM","DgN","DUQ","A8Q"],
"design a building":["DgM"],
"design clothes":["DgN"],
"design designed":["DgM","DgN","DgO"],
"designer":["Dpl"],
"designing":["DgO","DgM","DgN"],
"designing a building":["DgM"],
"designing clothes":["DgN"],
"desk":["DAx","A8T","A8R","A8S"],
"desktop computer":["DAy"],
"desolate":["DUR"],
"desperate":["DUS","A8U"],
"dessert":["A8X","A8V","A8W"],
"desserts":["Dpm"],
"destination":["Dpn"],
"destroy":["A8Y"],
"destruction":["DUT","A8a","A8Z"],
"destructive":["DUU"],
"detective":["A8d","A8b","A8c"],
"determined":["Dpo"],
"devoted":["DUV"],
"dew":["A8g","A8e","A8f"],
"diabetes":["DUW","A8j","A8h","A8i"],
"dial":["A8k"],
"diamond":["A8o","A8l","A8m","A8n"],
"diary":["A8q","A8p"],
"dice":["DAz","A8u","A8r","A8s","A8t"],
"dictionary":["A8x","A8v","A8w"],
"die":["DgP","A8z"],
"die died":["DgP"],
"die out":["DUX","A8y"],
"diet":["DUZ","DUY","A81","A80"],
"different":["DUa","A86","A82","A83","A84","A85"],
"difficult":["DUb","A88","A87"],
"dig":["DgQ","DgR","A9C"],
"dig a hole":["DgQ","DgR"],
"dig dug":["DgQ","DgR"],
"digging":["DgR","DgQ","A89"],
"digging a hole":["DgQ","DgR"],
"digital":["A9B","A9A"],
"digital camera":["Dpp"],
"dimples":["A9D"],
"dimsum":["A9H","A9E","A9F","A9G"],
"dine":["A9I"],
"diner":["A9M","A9J","A9K","A9L"],
"dingy":["A9N"],
"dining room":["A9O","A9P","A9Q"],
"dining table":["A9R","A9S"],
"dinner":["A9Y","A9T","A9U","A9V","A9W","A9X"],
"dinosaur":["DA0","A9e","A9Z","A9a","A9b","A9c","A9d"],
"dinosaurs":["A9h","A9f","A9g"],
"dip":["A9m","A9i","A9j","A9k","A9l"],
"director":["A9n"],
"dirt":["A9p","A9o"],
"dirtier":["DA2","DA1"],
"dirty":["DA5","DA3","DA4","A9u","A9q","A9r","A9s","A9t"],
"disagreement":["DUd","DUc","A9y","A9v","A9w","A9x"],
"disappear":["DUe","A91","A9z","A90"],
"disappointed":["DUf","A95","A92","A93","A94"],
"disappointing":["DUg","A97","A96"],
"disappointment":["DUh"],
"disc":["DA6"],
"disco":["BAB","A98","A99","BAA"],
"discount":["DgS","DUi","BAE","BAC","BAD"],
"discount discounted":["DgS"],
"discounting":["DgS"],
"discover":["Dpq"],
"discovery":["DUj"],
"discuss":["DUl"],
"discussion":["DUk","BAG","BAF"],
"disgust":["BAM"],
"disgusted":["DA7","BAK","BAH","BAI","BAJ"],
"disgusting":["BAL"],
"dish":["BAS","BAN","BAO","BAP","BAQ"],
"dishcloth":["DA8"],
"dishes":["BAR"],
"dishwasher":["DBA","DA9","BAV","BAT","BAU"],
"dislike":["DgT","BAZ","BAW","BAX","BAY"],
"dislike disliked":["DgT"],
"dislike icecream":["DgT"],
"disliking":["DgT"],
"dismal":["DUm"],
"dismay":["DUn"],
"disneyland":["BAe","BAa","BAb","BAc","BAd"],
"display":["DgU","BAf"],
"display clothes":["DgU"],
"display displayed":["DgU"],
"displaying":["DgU"],
"displaying clothes":["DgU"],
"disposable":["DUo","BAh","BAg"],
"dissolve":["DUp","BAi"],
"distance":["BAl","BAj","BAk"],
"distant":["BAo","BAm","BAn"],
"distillation":["BAq","BAp"],
"distract":["DUq","BAr"],
"distress":["BAt","BAs"],
"dive":["DgV","BAw","BAu","BAv"],
"dive dove":["DgV"],
"dive into the water":["DgV"],
"diver":["BAy","BAx"],
"diverse":["BA0","BAz"],
"diversity":["DUr"],
"divide":["DUt"],
"divided":["DUs","BA1"],
"diving":["DgV","DBB","BA2"],
"diving into the water":["DgV"],
"dizzy":["Dpr"],
"dj":["BA6","BA3","BA4","BA5"],
"dna":["BA9","BA7","BA8"],
"do":["DgW","DgX","DgY"],
"do a jigsaw":["DgW"],
"do did":["DgW","DgX","DgY","DgZ","Dga","Dgc"],
"do experiments":["DgX"],
"do homework":["DgY","DgZ","Dga"],
"do housework":["Dpt"],
"do karate":["Dgb"],
"do laundry":["Dgc"],
"do magic":["Dgd"],
"do maths":["Dge"],
"do my homework":["Dpu"],
"do push-ups":["Dgf"],
"do research":["Dgg"],
"do the dishes":["Dpv"],
"do up":["Dgh"],
"do up didup":["Dgh"],
"do yoga":["Dpz"],
"do your homework":["Dp0"],
"dock":["BBF","BBA","BBB","BBC","BBD","BBE"],
"doctor":["DBD","DBC","BBJ","BBG","BBH","BBI"],
"document":["DUu","BBM","BBK","BBL"],
"documentary":["Dps"],
"dodo":["BBP","BBN","BBO"],
"dog":["DBE","BBa","BBQ","BBR","BBS","BBT","BBU"],
"dog bed":["BBV"],
"dog house":["BBW","BBX","BBY","BBZ"],
"dogs":["BBb"],
"doing":["DgY","DgW","DgX"],
"doing a jigsaw":["DgW"],
"doing exercise":["BBc"],
"doing experiments":["DgX"],
"doing homework":["DgY","DgZ","Dga"],
"doing karate":["Dgb"],
"doing laundry":["Dgc"],
"doing magic":["Dgd"],
"doing maths":["Dge"],
"doing push-ups":["Dgf"],
"doing research":["Dgg"],
"doing up":["Dgh"],
"doll":["BBj","BBd","BBe","BBf","BBg"],
"doll house":["BBh","BBi"],
"dolls":["BBk"],
"dolphin":["DBF","BBt","BBl","BBm","BBn","BBo","BBp","BBq","BBr","BBs"],
"dolphins":["BBv","BBu"],
"dome":["BBx","BBw"],
"Dominican republic":["BBy","BBz","BB0"],
"domino":["BB6"],
"dominoes":["BB5","BB1","BB2","BB3","BB4"],
"donate":["BB7"],
"donkey":["DBG","BCD","BB8","BB9","BCA","BCB","BCC"],
"donut":["DBH","BCI","BCE","BCF","BCG","BCH"],
"donuts":["DBI","BCM","BCJ","BCK","BCL"],
"door":["DBL","BCW","BCN","BCO","BCP","BCQ","BCR"],
"door handle":["DBJ"],
"doorbell":["BCV","BCS","BCT","BCU"],
"doormat":["DBK"],
"doors":["BCX"],
"dormintory":["DUv"],
"dormitory":["BCY"],
"dormouse":["BCZ"],
"dots":["BCa"],
"double bass":["BCb","BCc","BCd","BCe"],
"double bed":["BCf","BCg","BCh"],
"double decker bus":["BCi","BCj","BCk","BCl","BCm"],
"dough":["BCr","BCn","BCo"],
"doughnut":["BCq","BCp"],
"dove":["BCw","BCs","BCt","BCu","BCv"],
"down":["Dpy","Dpw"],
"download":["BC0","BCx","BCy","BCz","Dpx"],
"downpour":["BC1"],
"downstairs":["BC2"],
"downtown":["BC3"],
"doze":["BC7","BC4","BC5"],
"dozen":["BC6"],
"dracula":["BC9","BC8"],
"dragon":["DBN","BDO","BDA","BDB","BDC"],
"dragon boat festival":["BDD","BDE"],
"dragon fruit":["DBM","BDK","BDL","BDM","BDN"],
"dragonfly":["BDJ","BDF","BDG","BDH","BDI"],
"drain":["DBO"],
"drama":["BDP"],
"draw":["Dgl","Dgi","Dgj","Dgk","BDX","BDQ"],
"draw a line":["Dgi"],
"draw a picture":["BDR"],
"draw drew":["Dgi","Dgj","Dgk","Dgl"],
"draw on the board":["Dgj","Dgk"],
"draw pictures":["Dp1"],
"drawer":["BDT","BDS"],
"drawers":["DBP","BDV","BDU"],
"drawing":["Dgl","Dgi","Dgj","Dgk","BDW"],
"drawing a line":["Dgi"],
"drawing on the board":["Dgj","Dgk"],
"dream":["Dgo","Dgm","Dgn","BDa","BDY","BDZ"],
"dream about basketball":["Dgn"],
"dream dreamed":["Dgn","Dgm","Dgo"],
"dreaming":["Dgo","Dgm","Dgn"],
"dreaming about basketball":["Dgn"],
"dress":["DBS","BDk","BDb","BDc","BDd","BDe","BDf","BDg","BDh"],
"dress up":["Dgp","Dgq"],
"dress up dressed up":["Dgp","Dgq"],
"dresser":["DBQ","BDj","BDi"],
"dressing gown":["DBR"],
"dressing up":["Dgp","Dgq"],
"drier":["DBT"],
"drill":["DBU","BDp","BDl","BDm","BDn","BDo"],
"drink":["Dgu","Dgr","Dgs","Dgt","Dgv","BDu","BDq","BDr"],
"drink coffee":["Dgr","Dgs","Dgt"],
"drink drank":["Dgr","Dgs","Dgt","Dgu","Dgv"],
"drink water":["Dgv"],
"drinking":["Dgu","Dgr","Dgs","Dgt","Dgv","BDt","BDs"],
"drinking coffee":["Dgr","Dgs","Dgt"],
"drinking water":["Dgv"],
"drinks":["BDv"],
"drip":["BDw"],
"drive":["Dgy","Dgw","Dgx","BD0","BDx","BDy"],
"drive a bus":["BDz"],
"drive a car":["Dgw","Dgx"],
"drive drove":["Dgx","Dgw","Dgy"],
"driver":["DBW","DBV","BD3","BD1","BD2"],
"driving":["Dgy","Dgw","Dgx","BD5","BD4"],
"driving a car":["Dgw","Dgx"],
"drizzle":["DBY","DBX"],
"drone":["DBZ","BEA","BD6","BD7","BD8","BD9"],
"drop":["Dgz","BEE","BEB","BEC","BED"],
"drop a ball":["Dgz"],
"drop dropped":["Dgz"],
"dropping":["Dgz"],
"dropping a ball":["Dgz"],
"drought":["BEI","BEF","BEG","BEH"],
"drowsy":["BEK","BEJ"],
"drugstore":["BEL"],
"drum":["BEP","BEM","BEN","BEO"],
"drums":["DBa","BEU","BEQ","BER","BES","BET"],
"drunk":["BEW","BEV"],
"dry":["Dg0","BEa","BEX"],
"dry clothes":["Dg0"],
"dry dried":["Dg0"],
"dry the dishes":["Dp2"],
"dryer":["BEZ","BEY"],
"drying":["Dg0"],
"drying clothes":["Dg0"],
"Dublin":["BEb"],
"duck":["DBb","BEl","BEc","BEd","BEe","BEf"],
"duckling":["BEi","BEg","BEh"],
"ducklings":["BEk","BEj"],
"ducks":["BEm"],
"duct tape":["BEn","BEo"],
"dull":["Dp3"],
"dump":["BEu","BEp"],
"dumpling":["BEq"],
"dumplings":["DBc","BEt","BEr","BEs"],
"dune":["BEw","BEv"],
"dung beetle":["BEz","BE0","BE1","BE2"],
"dungarees":["BEy","BEx"],
"duration":["DUw","BE3"],
"durian":["BE7","BE4","BE5","BE6"],
"dust":["BE9"],
"dustpan and brush":["DBd","BE8"],
"dusty":["DUx","BFA"],
"dvd player":["Dp4"],
"dwarf":["BFB"],
"dye":["BFC"],
"dying":["DgP"],
"dynamo":["BFD"],
"e":["DZu","DZt"],
"eager":["BFF","BFE"],
"eagle":["DBe","BFJ","BFG","BFH","BFI"],
"ear":["DBj","BFU","BFK","BFL"],
"ear buds":["DBf"],
"ear lobe":["DBg"],
"ear piercing":["BFS","BFT"],
"early":["DUy","BFM"],
"earmuffs":["DBh"],
"earn":["BFN"],
"earphones":["DBi","BFR","BFO","BFP","BFQ"],
"earring":["DBk"],
"earrings":["DBl"],
"ears":["DBm"],
"earth":["BFW","BFV"],
"earthquake":["BFZ","BFX","BFY"],
"earthworm":["BFc","BFa","BFb"],
"easier":["DBn"],
"easter":["BFh","BFd"],
"easter bunny":["BFe"],
"easter egg":["BFf","BFg"],
"easy":["BFi"],
"easygoing":["DUz"],
"eat":["Dg8","Dg1","Dg2","Dg3","Dg4","Dg5","Dg6","Dg7","Dg9","BFn","BFj","BFk","BFl"],
"eat a burger":["Dg2"],
"eat a spider":["Dg4"],
"eat an apple":["Dg3"],
"eat ate":["Dg2","Dg1","Dg3","Dg4","Dg5","Dg6","Dg7","Dg8","Dg9"],
"eat breakfast":["Dp5","Dp6"],
"eat cake":["Dg5"],
"eat dinner":["Dp7"],
"eat lunch":["Dg6"],
"eat out":["Dp8"],
"eat pizza":["Dg7"],
"eat popcorn":["Dg9"],
"eating":["Dg8","Dg1","Dg2","Dg3","Dg4","Dg5","Dg6","Dg7","Dg9","BFm"],
"eating a burger":["Dg2"],
"eating a spider":["Dg4"],
"eating an apple":["Dg3"],
"eating cake":["Dg5"],
"eating lunch":["Dg6"],
"eating pizza":["Dg7"],
"eating popcorn":["Dg9"],
"ebook":["BFs","BFo","BFp","BFq","BFr"],
"ecommerce":["BFu","BFt"],
"economy":["BFv"],
"ecosystem":["BFx","BFw"],
"edgy":["BFy"],
"education":["DU0","BF1","BFz","BF0"],
"eel":["BF4","BF2","BF3"],
"egg":["DBp","BGJ","BF5","BF6","BF7","BF8","BF9"],
"egg cup":["BGA","BGB","BGC"],
"egg tarts":["BGP","BGQ"],
"eggplant":["DBo","BGI","BGD","BGE","BGF","BGG","BGH"],
"eggs":["BGO","BGK","BGL","BGM","BGN"],
"Egypt":["DBs","BGV","BGR","BGS","BGT","BGU"],
"Egypt flag":["DBq"],
"Egyptian":["DBr"],
"Eid":["BGW"],
"eight":["Daf","Dab"],
"eight hundred":["Dae"],
"eight o'clock":["Dd8"],
"eight thousand":["Dag"],
"eighteen":["Dad","Dac"],
"eighty":["Dan","Dah"],
"eighty eight":["Dai"],
"eighty five":["Daj"],
"eighty four":["Dak"],
"eighty nine":["Dal"],
"eighty one":["Dam"],
"eighty seven":["Dao"],
"eighty six":["Dap"],
"eighty thousand":["Daq"],
"eighty three":["Dar"],
"eighty two":["Das"],
"elbow":["DBt"],
"elder":["BGY","BGX"],
"electric drill":["BGZ","BGa"],
"electric guitar":["BGb","BGc","BGd","BGe","BGf","BGg"],
"electric piano":["BGo"],
"electric toothbrush":["BGp"],
"electrical engineer":["DBu","DBv"],
"electrician":["DBx","DBw","DU1","BGl","BGh","BGi","BGj","BGk"],
"electricity":["DU2","BGn","BGm"],
"elegant":["BGr","BGq"],
"elephant":["DBy","BGx","BGs","BGt","BGu","BGv","BGw"],
"elephants":["BGy"],
"elevator":["DBz","BG1","BGz","BG0"],
"eleven":["Dau","Dat"],
"eleven minutes past five":["Dd9"],
"elf":["BG6","BG2","BG3","BG4","BG5"],
"elm tree":["BG7"],
"email":["BHB","BG8","BG9","BHA"],
"embarrased":["DU3"],
"embarrassed":["DB0","BHE","BHC","BHD"],
"embarrassing":["BHF"],
"emerald":["BHH","BHG"],
"emergency":["Dp9"],
"emergency exit":["BHI","BHJ","BHK","BHL"],
"emission":["DU4","BHM"],
"emo":["BHO","BHN"],
"emotions":["BHP"],
"emperor":["BHQ"],
"employment":["BHS","BHR"],
"empty":["DhA","BHW","BHT","BHU","BHV"],
"empty emptyed":["DhA"],
"empty the bin":["DhA"],
"emptying":["DhA"],
"emptying the bin":["DhA"],
"encounter":["DU5","BHX"],
"encourage":["DhB","DU6","BHY"],
"encourage a friend":["DhB"],
"encourage encouraged":["DhB"],
"encouraging":["DhB"],
"encouraging a friend":["DhB"],
"end":["BHa","BHZ"],
"endangered":["DU7"],
"endurance":["DU8","BHb"],
"energentic":["DU9"],
"energetic":["BHc"],
"energy":["DqA"],
"energy source":["BHd"],
"engine":["BHh","BHe","BHf","BHg"],
"England":["DB2","BHm","BHi","BHj","BHk","BHl"],
"England flag":["DB1"],
"English":["DB5","DB3","BHo"],
"English breakfast":["DB4"],
"English class":["BHn"],
"enhance":["DVA"],
"enjoy":["DhC","DVB","BHs","BHp","BHq"],
"enjoy enjoyed":["DhC"],
"enjoy reading":["DhC"],
"enjoying":["DhC","BHr"],
"enjoying reading":["DhC"],
"enormous":["BHv","BHt","BHu"],
"entertain":["BHw"],
"entertainment":["DVC"],
"enthusiam":["DVD"],
"enthusiasm":["BHx"],
"Enthusiastically":["DVE"],
"entrance":["BH0","BHy","BHz"],
"envelope":["DB6","BH4","BH1","BH2","BH3"],
"environment":["BH9","BH5","BH6","BH7"],
"environmentalist":["DVF","BH8"],
"environmentally friendly":["DVG"],
"equality":["DVH","BIB","BIA"],
"equation":["DVI","BID","BIC"],
"equator":["DVJ"],
"equipment":["BIF","BIE"],
"equivalent":["DVK"],
"eraser":["DB7","BII","BIG","BIH"],
"erode":["DVL","BIK","BIJ"],
"erosion":["DVM","BIN","BIL","BIM"],
"error message":["BIO"],
"erupt":["DhD"],
"erupt erupted":["DhD"],
"erupting":["DhD"],
"eruption":["BIR","BIP","BIQ"],
"escalate":["DVN"],
"escalator":["DB8","BIV","BIS","BIT","BIU"],
"escape":["DVO","BIX","BIW"],
"espresso":["DB9"],
"esteemed":["DVP"],
"estimate":["DVQ"],
"ethnic minorities":["DVR"],
"ethnic minority":["DqB"],
"Europe":["BId","BIY","BIZ","BIa","BIb"],
"European union":["BIc"],
"evaporate":["DVS"],
"evaporation":["DVT"],
"evening":["BIe"],
"event":["BIf"],
"Everest":["BIi","BIg","BIh"],
"everyone":["BIj"],
"evil":["BIm","BIk","BIl"],
"evolution":["BIo","BIn"],
"evolve":["DVU"],
"exaggerate":["DVV"],
"exam":["BIr","BIp"],
"examine":["DhE","BIq"],
"examine a patient":["DhE"],
"examine examined":["DhE"],
"examining":["DhE"],
"examining a patient":["DhE"],
"example":["DqC"],
"excavate":["DVW"],
"excavation":["BIs"],
"exceed":["DVX","BIt"],
"exchange":["DhF","DhG","DVY","BIu"],
"exchange exchanged":["DhF","DhG"],
"exchange money":["DhF","DhG"],
"exchanging":["DhF","DhG"],
"exchanging money":["DhF","DhG"],
"excited":["DCA","DVZ","BIw","BIv"],
"exciting":["DCB","BIy","BIx"],
"executioner":["BI0","BIz"],
"exercise":["DhH","BI4","BI1","BI2","BI3"],
"exercise exercised":["DhH"],
"exercising":["DhH","BI6","BI5"],
"exhausted":["DCC","BI7"],
"exhibit":["DVb"],
"exhibition":["DVa","BJB","BI8","BI9","BJA"],
"exhilarate":["DVd"],
"exhilarated":["DVc"],
"exile":["DVe"],
"exit":["DqD"],
"exotic":["BJF","BJC","BJD","BJE"],
"expand":["DVf","BJG"],
"expel":["DVg"],
"expenditure":["DVh"],
"expensive":["DCD","DVi","BJJ","BJH","BJI"],
"experience":["DqE"],
"expired":["DVj"],
"explain":["DhI","DVk","BJO","BJK","BJL","BJM","BJN"],
"explain explained":["DhI"],
"explaining":["DhI"],
"explore":["BJQ","BJP"],
"explorer":["DVl","BJR"],
"explosion":["BJU","BJS","BJT"],
"expunge":["DVm"],
"extension cord":["BJV","BJW"],
"exterior":["DVn"],
"extinct":["DVo"],
"extract":["DVp","BJX"],
"extraordinary":["DVq"],
"eye":["DCI","BJj","BJY","BJZ","BJa"],
"eyebrow":["DCE","BJd","BJb","BJc"],
"eyebrows":["DCF"],
"eyelash":["DCH","BJi","BJe","BJf","BJg"],
"eyelashes":["DCG","BJh"],
"eyes":["DCJ","BJm","BJk","BJl"],
"f":["DZw","DZv"],
"fabric":["BJo","BJn"],
"face":["DCK","DVr","BJs","BJp","BJq","BJr"],
"face to face":["DVs"],
"facebook":["DqF"],
"facial expression":["BJt","BJu","BJv"],
"facility":["BJw"],
"factory":["DCL","BJz","BJx","BJy"],
"fail":["DhJ"],
"fail a test":["DhJ"],
"fail an exam":["DVt"],
"fail failed":["DhJ"],
"failing":["DhJ"],
"failing a test":["DhJ"],
"fair hair":["BJ0"],
"fairy":["BJ4","BJ1","BJ2","BJ3"],
"fairy tales":["DVu"],
"falcon":["BJ8","BJ5","BJ6","BJ7"],
"fall":["DhN","DhK","DhL","DhM","BKH","BJ9","BKA","BKB","BKC","BKD"],
"fall asleep":["DhL"],
"fall asleep fell asleep":["DhL"],
"fall fell":["DhN","DhK"],
"fall in love":["DVv","BKG"],
"fall out":["DVw"],
"fall over":["DhM"],
"fall over fell over":["DhM"],
"falling":["DhN","DhK","DhL","DhM"],
"falling asleep":["DhL"],
"falling over":["DhM"],
"falling rocks":["BKE","BKF"],
"fallorautumn":["DqG"],
"family":["DZR","BKK","BKI","BKJ"],
"famine":["DVx"],
"famished":["DVy"],
"famous":["DVz"],
"fan":["DCM","BKR","BKL","BKM","BKN","BKO"],
"fancy":["DqH"],
"fangs":["BKQ","BKP"],
"fans":["DqI"],
"fantastic":["DV0","BKS"],
"fantasy":["BKT"],
"far":["BKh","BKU"],
"farm":["BKg","BKV","BKW","BKX","BKY","BKZ"],
"farm house":["BKf"],
"farmer":["DCO","DCN","BKe","BKa","BKb","BKc","BKd"],
"fascinating":["DV1"],
"fashion":["BKl"],
"fashion designer":["DCP","DCQ","DV2"],
"fashionable":["BKk","BKi","BKj"],
"fast":["DCT","BKp","BKm","BKn"],
"fast horse":["BKo"],
"faster":["DCS","DCR"],
"fat":["DCU","BKw","BKq","BKr","BKs"],
"fatal":["BKt"],
"father":["DZT","BKv","BKu"],
"father-in-law":["DZS"],
"fatter":["DCV"],
"faucet":["DCW","BK0","BKx","BKy","BKz"],
"fawn":["BK2","BK1"],
"fax  machine":["BK3"],
"fear":["BK6","BK4"],
"fearful":["BK5"],
"fearless":["DV3"],
"feast":["DV4","BK7"],
"feather":["BLA","BK8"],
"feather duster":["BK9"],
"feathers":["DCX","BLB"],
"February":["DqJ"],
"feeble":["DV5"],
"feed":["DhP","DhO","BLG","BLC","BLD"],
"feed a cat":["DhO"],
"feed fed":["DhO","DhP"],
"feed the cat":["DqK"],
"feed the dog":["DhP","BLH"],
"feedback":["BLF","BLE"],
"feeding":["DhP","DhO"],
"feeding a cat":["DhO"],
"feeding the dog":["DhP"],
"feel":["DhR","DhQ"],
"feel anxious":["DV6"],
"feel bored":["DhQ"],
"feel dizzy":["DV7"],
"feel felt":["DhQ","DhR"],
"feel sick":["DhR","DV8"],
"feel tired":["DV9"],
"feeling":["DhR","DhQ"],
"feeling bored":["DhQ"],
"feeling sick":["DhR"],
"feet":["DCY","BLK","BLI","BLJ"],
"felt tip":["BLL"],
"female":["BLN","BLM"],
"femur":["DWA","BLO"],
"fence":["DCZ","BLQ","BLP"],
"fencing":["DqL"],
"fern":["BLS","BLR"],
"ferocious":["BLT"],
"Ferrari":["DqM"],
"ferret":["BLU"],
"ferris wheel":["BLV","BLW"],
"ferry":["BLX"],
"fertile":["DWB","BLY"],
"festival":["DWC","BLZ"],
"fetch":["BLa"],
"fever":["BLc","BLb"],
"fidget toy":["BLd","BLe"],
"field":["BLj","BLf","BLg","BLh","BLi"],
"fierce":["BLk"],
"fifteen":["Daw"],
"fifteen thousand":["Dax"],
"fifteen-":["Dav"],
"fifty":["Da4","Day"],
"fifty eight":["Daz"],
"fifty five":["Da0"],
"fifty four":["Da1"],
"fifty nine":["Da2"],
"fifty one":["Da3"],
"fifty seven":["Da5"],
"fifty six":["Da6"],
"fifty thousand":["Da7"],
"fifty three":["Da8"],
"fifty two":["Da9"],
"fig":["BLq","BLl","BLm","BLn"],
"fight":["DhS","BLp","BLo"],
"fight fought":["DhS"],
"fighting":["DhS"],
"figs":["BLu","BLr","BLs","BLt"],
"file":["BLx","BLv","BLw"],
"fill":["DhU","DhT","DWD","BLy"],
"fill a glass":["DhT","DhU"],
"fill filled":["DhT","DhU"],
"fill out":["DhW","DhV"],
"fill out a form":["DhV"],
"fill out filled out":["DhV","DhW"],
"fill up":["DhX"],
"fill up filled up":["DhX"],
"filling":["DhU","DhT"],
"filling a glass":["DhT","DhU"],
"filling out":["DhW","DhV"],
"filling out a form":["DhV"],
"filling up":["DhX"],
"film":["BLz"],
"film star":["DWE","BL0"],
"filtered coffee":["BL1"],
"fin":["DCd","BMN","BL2","BL3","BL4"],
"find":["BL6","BL5"],
"find out":["DWF"],
"finger":["DCb","BL9","BL7","BL8"],
"finger nail":["DCa"],
"fingerprint":["BMB","BMA"],
"fingerprint scan":["BMC"],
"fingers":["DCc","BMD","BME"],
"finish":["DhY","DWH","BMH","BMF","BMG"],
"finish class":["DWG"],
"finish finished":["DhY"],
"finish school":["DhY"],
"finish work":["DWI"],
"finishing":["DhY"],
"finishing school":["DhY"],
"Finland":["BMM","BMI","BMJ","BMK","BML"],
"fins":["BMO"],
"fire":["BMj","BMP","BMQ","BMR"],
"fire engine":["DCe","BMW","BMX","BMY"],
"fire extinguisher":["DCf"],
"fire station":["BMk"],
"fire truck":["BMl"],
"fireball":["BMV","BMS","BMT","BMU"],
"fired":["DWJ"],
"firefighter":["DCh","DCg","BMd","BMZ","BMa","BMb","BMc"],
"firefighters":["DqN"],
"fireman":["BMf","BMe"],
"fireplace":["DCi","BMi","BMg","BMh"],
"fireworks":["DCj","BMo","BMm","BMn"],
"first":["DqO"],
"first aid kit":["BMp","BMq"],
"fish":["DhZ","DCp","DCk","DCl","BNH","BMr","BMs","BMt","BMu","BMv"],
"fish and chips":["DCm","BMw","BMx","BMy"],
"fish bowl":["BMz","BM0","BM1","BM2","BM3"],
"fish fished":["DhZ"],
"fisherman":["DCo","DCn","BM7","BM4","BM5","BM6"],
"fishing":["DhZ","BNA","BM8","BM9"],
"fishing rod":["BNB","BNC","BND","BNE"],
"fishmonger":["BNG","BNF"],
"fist":["BNK","BNI","BNJ"],
"fit":["BNP","BNL"],
"fitness":["BNO"],
"fitness center":["BNM","BNN"],
"five":["DbC","DbA"],
"five hundred":["DbB"],
"five o'clock":["DeA"],
"five past six":["DeB"],
"five past twelve":["DeC"],
"five thousand":["DbD"],
"five to twelve":["DeD"],
"fix":["Dhc","Dha","Dhb","BNS","BNQ","BNR"],
"fix a car":["Dha"],
"fix a computer":["Dhb"],
"fix fixed":["Dha","Dhb","Dhc"],
"fix the water":["Dhc"],
"fixing":["Dhc","Dha","Dhb"],
"fixing a car":["Dha"],
"fixing a computer":["Dhb"],
"fixing the water":["Dhc"],
"fizzy drink":["BNT"],
"flag":["DCq","BNW","BNU","BNV"],
"flags":["BNY","BNX"],
"flame":["BNd","BNZ","BNa","BNb","BNc"],
"flamingo":["BNh","BNe","BNf","BNg"],
"flap":["BNi"],
"flashlight":["DCr","BNm","BNj","BNk","BNl"],
"flat":["DCs"],
"flat tyre":["BNn","BNo"],
"flavour":["BNp"],
"flavours":["DWK","BNq"],
"flax":["BNr"],
"flexible":["DWL","BNt","BNs"],
"flies":["DqP"],
"flight":["BNw"],
"flight attendant":["DCt","DCu","DWM","BNu","BNv"],
"flip chart":["DCv","BNx","BNy"],
"flip flops":["DCw","BNz","BN0","BN1","BN2","BN3"],
"flippers":["BN5","BN4"],
"float":["DWO","DWN"],
"flood":["DCy","DCx","BOB","BN6","BN7","BN8","BN9","BOA"],
"floor":["BOF","BOC","BOD","BOE"],
"florist":["DC1","DCz","DC0","BOH","BOG"],
"flour":["BOK","BOI","BOJ"],
"flow":["BOW"],
"flower":["DC3","DC2","BON","BOL","BOM"],
"flower pot":["BOO","BOP","BOQ"],
"flowerpot":["BOR"],
"flowers":["BOV","BOS","BOT","BOU"],
"flu":["BOY","BOX"],
"fluctuate":["DWP"],
"fluent":["DWQ"],
"flute":["BOb","BOZ","BOa"],
"fly":["Dhf","Dhd","DC4","BOd","BOc"],
"fly a kite":["Dhd"],
"fly a plane":["DqQ"],
"fly flew":["Dhd","Dhe","Dhf"],
"fly over":["Dhe"],
"fly over the mountains":["Dhe"],
"flying":["Dhf","Dhd"],
"flying a kite":["Dhd"],
"flying over":["Dhe"],
"flying over the mountains":["Dhe"],
"foal":["BOf","BOe"],
"fog":["BOk","BOg","BOh","BOi"],
"foggy":["BOj"],
"fold":["DqR"],
"folder":["DC5","BOp","BOl","BOm","BOn","BOo"],
"follow":["Dhg","BOq"],
"follow followed":["Dhg"],
"follow mother":["Dhg"],
"following":["Dhg"],
"following mother":["Dhg"],
"fond of":["DWR"],
"fondu":["BOr"],
"food":["DqT","DqS"],
"food pyramid":["BOs"],
"foods":["BOt"],
"fool":["BOw","BOu","BOv"],
"foot":["DC6","BO9","BOx","BOy"],
"football":["BO3","BOz","BO0","BO1"],
"football player":["BO2"],
"footballer":["DqU"],
"footpath":["BO8","BO4","BO5","BO6","BO7"],
"footprints":["BPD","BPA","BPB","BPC"],
"forager":["DWS"],
"forbid":["DWT","BPE"],
"force":["DWU","BPF"],
"forearm":["BPH","BPG"],
"forecast":["BPI"],
"forehead":["BPJ"],
"forest":["DC9","BPP","BPK","BPL"],
"forest fire":["DC7","DC8","BPM","BPN","BPO"],
"forever":["DWV","BPQ"],
"forget":["Dhh","DWW"],
"forget forgot":["Dhh"],
"forget me not":["BPR"],
"forget your key":["Dhh"],
"forgeting":["Dhh"],
"forgetv your key":["Dhh"],
"forgot":["DqV"],
"fork":["DDA","BPT","BPS"],
"formal":["DWX","BPV","BPU"],
"fortress":["DWY","BPW"],
"fortune":["DWZ","BPX"],
"forty":["DbK","DbE"],
"forty eight":["DbF"],
"forty five":["DbG"],
"forty four":["DbH"],
"forty nine":["DbI"],
"forty one":["DbJ"],
"forty seven":["DbL"],
"forty six":["DbM"],
"forty thousand":["DbN"],
"forty three":["DbO"],
"forty two":["DbP"],
"forward":["DWa","BPZ","BPY"],
"fossil":["BPb","BPa"],
"fossil fuels":["DWb"],
"fountain":["DDC","BPe","BPc","BPd"],
"fountain pen":["DDB"],
"four":["DbS","DbQ"],
"four hundred":["DbR"],
"four thousand":["DbV"],
"fourteen":["DbU","DbT"],
"fourth":["DqW"],
"fox":["DDD","BPj","BPf","BPg","BPh","BPi"],
"fracture":["DWc","BPk"],
"frame":["DWd","BPl"],
"France":["DDF","BPp","BPm","BPn","BPo"],
"France flag":["DDE"],
"frankenstein":["BPt","BPq","BPr","BPs"],
"freckles":["BPx","BPu","BPv","BPw"],
"freeze":["BP0","BPy","BPz"],
"freezer":["BP1"],
"freezing":["DDH","DDG","BP2"],
"French":["DDI"],
"french fries":["BP3","BP4","BP5"],
"french horn":["BP6","BP7","BP8"],
"frequency":["BP9"],
"Frequently":["DWe"],
"fresh":["DqX"],
"Friday":["DDL","DDJ","DDK"],
"fridge":["DDM","BQD","BQA","BQB","BQC"],
"fried chicken":["DDN","BQE","BQF","BQG"],
"fried egg":["BQH","BQI","BQJ","BQK","BQL"],
"fried eggs":["BQM","BQN","BQO"],
"fried food":["BQP"],
"fried rice":["DDO","BQQ","BQR","BQS","BQT"],
"friend":["BQX","BQU","BQV"],
"friendly":["BQW"],
"friends":["DWf","BQe","BQY","BQZ","BQa","BQb"],
"friendship":["BQd","BQc"],
"fries":["DDP","DWg","BQg","BQf"],
"frighten":["DWi"],
"frightened":["DWh","BQj","BQh","BQi"],
"frightening":["BQm","BQk","BQl"],
"frisbee":["BQp","BQn","BQo"],
"frisk":["DWj"],
"frog":["DDQ","BQs","BQq","BQr"],
"frogs":["DqY"],
"front door":["BQt","BQu","BQv","BQw","BQx","BQy"],
"frost":["BQ0","BQz"],
"frosty":["DWk","BQ2","BQ1"],
"frown":["Dhi","BQ5","BQ3","BQ4"],
"frown frowned":["Dhi"],
"frowning":["Dhi"],
"frozen":["BQ8","BQ6","BQ7"],
"fruit":["DDR","BRF","BQ9","BRA","DqZ"],
"fruit juice":["BRB","BRC","BRD","BRE"],
"fruit salad":["BRG","BRH","BRI"],
"fruit smoothie":["DDS"],
"fruit stall":["BRJ","BRK","BRL","BRM"],
"fruit stand":["BRN"],
"frustrated":["BRP","BRO"],
"fry":["Dhj","BRU","BRQ","BRR"],
"fry fried":["Dhj"],
"frying":["Dhj","BRT","BRS"],
"frying pan":["DDT"],
"fuchsia":["BRW","BRV"],
"fuel":["DWl","BRX"],
"full moon":["BRY","BRZ","BRa","BRb"],
"fume":["BRf","BRc","BRd","BRe"],
"fun":["Dqd","Dqa","Dqb"],
"funfair":["BRi","BRg","BRh"],
"fungi":["BRl","BRj","BRk"],
"funnel":["Dqc"],
"funny":["DWm","BRp","BRm","BRn","BRo"],
"fur":["DDU"],
"furious":["DWn","BRs","BRq","BRr"],
"furnace":["DWo","BRu","BRt"],
"furniture":["BRv"],
"furry":["BRw"],
"fuses":["BRx"],
"futsal":["BRy"],
"g":["DZy","DZx"],
"galaxy":["BR2","BRz","BR0","BR1"],
"gallery":["BR5","BR3","BR4"],
"game":["BR9","BR6","BR7","BR8"],
"game console":["Dqe"],
"game designer":["DWp"],
"game show":["DWq"],
"games":["Dqf"],
"games console":["DDV","BSA","BSB","BSC"],
"garage":["DDW","BSD"],
"garbage":["BSP","BSE","BSF","BSG","BSH","BSI"],
"garbage can":["BSJ","BSK","BSL","BSM","BSN"],
"garbage truck":["BSQ","BSR"],
"garbageman":["DDY","DDX","BSO"],
"garden":["DDb","BSW","BSS","BST"],
"gardener":["DDa","DDZ","BSU"],
"gardening":["BSV"],
"gargoyle":["BSZ","BSX","BSY"],
"garlic":["DDc","BSe","BSa","BSb","BSc","BSd"],
"gas":["BSf"],
"gas station":["DDd","BSg","BSh","BSi"],
"gate":["DDe","BSp","BSj","BSk","BSl","BSm","BSn","BSo"],
"gather":["DWr","BSq"],
"gathering":["Dqg"],
"gaze":["DWs","BSv","BSr"],
"gazelle":["BSu","BSs","BSt"],
"gecko":["BSy","BSw","BSx"],
"geese":["BS1","BSz","BS0"],
"gem":["BS6","BS2","BS3","BS4","BS5"],
"generous":["DWt"],
"gentlemen":["BS7"],
"geography":["DDf","BTB","BS8","BS9","BTA"],
"German":["DDg"],
"German shepherd":["BTC"],
"Germany":["DDi","BTH","BTD","BTE","BTF","BTG"],
"Germany flag":["DDh"],
"germs":["BTK","BTI","BTJ"],
"get":["Dhk","Dhl"],
"get a book":["Dhk"],
"get a drink":["Dhl"],
"get a haircut":["Dhm","Dhn"],
"get an injection":["Dho"],
"get dressed":["Dhp"],
"get dressed got dressed":["Dhp"],
"get eyes checked":["Dhq"],
"get got":["Dhk","Dhl"],
"get home":["Dqh"],
"get married":["Dhr"],
"get married got married":["Dhr"],
"get on":["Dhs","Dhu","Dht"],
"get on a bus":["Dht"],
"get on got on":["Dhs","Dhu"],
"get to":["Dhv"],
"get to got to":["Dhv"],
"get to work":["Dhv"],
"get up":["Dhw","Dhx"],
"get up got up":["Dhw","Dhx"],
"get your nails painted":["Dhy"],
"getting":["Dhl","Dhk"],
"getting a book":["Dhk"],
"getting a drink":["Dhl"],
"getting a haircut":["Dhm","Dhn"],
"getting an injection":["Dho"],
"getting dressed":["Dhp"],
"getting eyes checked":["Dhq"],
"getting married":["Dhr"],
"getting on":["Dhs","Dhu","Dht"],
"getting on a bus":["Dht"],
"getting to":["Dhv"],
"getting to work":["Dhv"],
"getting up":["Dhw","Dhx"],
"getting your nails painted":["Dhy"],
"gherkin":["BTL"],
"gherkins":["BTN","BTM"],
"ghost":["BTR","BTO","BTP","BTQ"],
"giant":["BTS"],
"gift":["DDj","BTV","BTT","BTU"],
"gift shop":["Dqi"],
"gifts":["BTY","BTW","BTX"],
"gigantic":["BTa","BTZ"],
"gills":["Dqj"],
"ginger":["DDk","BTp","BTb","BTc","BTd"],
"ginger hair":["BTm","BTn","BTo"],
"gingerbread":["BTl","BTe"],
"gingerbread house":["BTf","BTg","BTh"],
"gingerbread man":["BTi","BTj","BTk"],
"giraffe":["DDl","BTu","BTq","BTr","BTs","BTt"],
"girder":["BTx","BTv","BTw"],
"girl":["BT1","BTy","BTz","BT0"],
"give":["Dhz","Dh0","Dh1","BT8","BT2","BT3","BT4"],
"give a gift":["Dhz","Dh0"],
"give a hand":["BT5","BT6"],
"give a presentation":["Dh1"],
"give flowers":["BT7"],
"give gave":["Dhz","Dh0","Dh1"],
"give out":["Dh2"],
"give out gave out":["Dh2"],
"give out money":["Dh2"],
"giving":["Dh1","Dhz","Dh0"],
"giving a gift":["Dhz","Dh0"],
"giving a presentation":["Dh1"],
"giving out":["Dh2"],
"giving out money":["Dh2"],
"glacier":["BUB","BT9","BUA"],
"glad":["BUI","BUC","BUD"],
"gladiator":["BUH","BUE","BUF","BUG"],
"glass":["DDo","BUW","BUJ","BUK","BUL","BUM","BUN"],
"glass of milk":["BUS","BUT","BUU","BUV"],
"glass water":["BUX","BUY","BUZ"],
"glasses":["DDn","DDm","BUR","BUO","BUP","BUQ"],
"glitch":["DWu"],
"global":["DWv","BUd","BUa","BUb","BUc"],
"global warming":["BUe"],
"globe":["DDp","BUg","BUf"],
"gloomy":["BUi","BUh"],
"glove":["BUk","BUj"],
"gloves":["DDq","BUo","BUl","BUm","BUn"],
"glue":["DWw","BUq","BUp"],
"glue stick":["BUr"],
"gluten free":["DWx"],
"go":["Dh9","Dh8"],
"go back":["Dqk"],
"go cycling":["Dql"],
"go diving":["Dh3"],
"go fishing":["Dqm"],
"go for a walk":["Dqn"],
"go hiking":["Dh4"],
"go home":["Dqo"],
"go jogging":["Dqp"],
"go shopping":["Dh5"],
"go shopping went shopping":["Dh5"],
"go sightseeing":["Dqv"],
"go skating":["Dqw"],
"go skiing":["Dqx"],
"go swimming":["Dqy"],
"go to":["Dh6","Dh7"],
"go to a cafe":["Dh6"],
"go to bed":["Dh7"],
"go to school":["Dh8"],
"go to the cinema":["Dqz"],
"go to the WC":["Dh9"],
"go to the zoo":["Dq0"],
"go to went to":["Dh7"],
"go to work":["Dq1"],
"go viral":["DW0"],
"go went":["Dh8","Dh3","Dh4"],
"goal":["BUt","BUs"],
"goat":["DDr","BUy","BUu","BUv","BUw","BUx"],
"goats":["BU0","BUz"],
"god":["BU1"],
"goggles":["DDs","BU5","BU2","BU3","BU4"],
"going":["Dh9","Dh8"],
"going diving":["Dh3"],
"going hiking":["Dh4"],
"going shopping":["Dh5"],
"going to":["Dh6","Dh7"],
"going to a cafe":["Dh6"],
"going to bed":["Dh7"],
"going to school":["Dh8"],
"going to the WC":["Dh9"],
"gold":["DDt","BVJ","BU6","BU7","BU8"],
"golden eagle":["BU9","BVA","BVB","BVC"],
"goldfish":["BVI","BVD","BVE","BVF","BVG"],
"goldfish bowl":["BVH"],
"golf":["DDu","BVN","BVK","BVL","BVM"],
"good":["DWz","BVT"],
"good bye":["Dqq"],
"good evening":["Dqr"],
"good idea":["BVR","BVS"],
"good morning":["Dqs"],
"good night":["Dqt","Dqu"],
"goodbye":["DWy","BVQ","BVO","BVP"],
"google":["BVU"],
"goose":["BVa","BVV","BVW","BVX"],
"gooseberry":["BVZ","BVY"],
"gorilla":["DDv","BVf","BVb","BVc","BVd","BVe"],
"gosling":["BVi","BVg","BVh"],
"government":["BVk","BVj"],
"gown":["BVl"],
"gps":["BVo","BVm","BVn"],
"grab":["Dq2"],
"graceful":["DW1","BVq","BVp"],
"gradually":["BVs","BVr"],
"graduate":["DiA","DW2","BVw","BVt","BVu","BVv"],
"graduate college":["DiA"],
"graduate graduated":["DiA"],
"graduating":["DiA"],
"graduating college":["DiA"],
"graduation":["BVy"],
"graduation ceremony":["BVx"],
"grain":["BV1","BVz","BV0"],
"grains":["Dq3"],
"grandad":["DW4","DW3"],
"granddaughter":["DZU","DW6","DW5","BV3","BV2"],
"grandfather":["DZV","DW8","DW7","BV6","BV4","BV5"],
"grandma":["DXA","DW9","BV9","BV7","BV8"],
"grandmother":["DZW","DXB","BWA"],
"grandpa":["DXC","BWC","BWB"],
"grandparents":["DXD","BWE","BWD"],
"grandson":["DZX","DXE","BWH","BWF","BWG"],
"granite":["DXF","BWL","BWI","BWJ","BWK"],
"granny":["DXG","BWN","BWM"],
"grape juice":["BWT","BWU"],
"grapefruit":["DDw","BWS","BWO","BWP","BWQ","BWR"],
"grapes":["DDx","BWZ","BWV","BWW","BWX","BWY"],
"graphic designer":["DDy","DDz","BWa"],
"grasp":["BWb"],
"grass":["BWj","BWc","BWd","BWe"],
"grasshopper":["DD0","BWi","BWf","BWg","BWh"],
"grassland":["Dq4"],
"grate":["BWl","BWk"],
"grater":["DD1"],
"gravel":["BWq","BWm","BWn","BWo","BWp"],
"graveyard":["BWv","BWr","BWs","BWt","BWu"],
"gravity":["DXH"],
"gravy":["BWx","BWw"],
"gray":["BWy"],
"graze":["BW1","BWz","BW0"],
"grazing":["BW3","BW2"],
"great grandfather":["DXI","BW4"],
"great grandmother":["DXJ"],
"great wall of china":["BW5","BW6","BW7"],
"great white shark":["BW8"],
"Greece":["BXC","BW9","BXA","BXB"],
"Greece flag":["DD2"],
"greedy":["Dq5"],
"Greek":["Dq6"],
"green":["DD3","BXX"],
"green bean":["BXD","BXE","BXF","BXG"],
"green beans":["Dq7"],
"green eyes":["BXH"],
"green frog":["BXI"],
"green pepper":["BXT"],
"green peppers":["BXU","BXV","BXW"],
"green salad":["BXY","BXZ"],
"green scarf":["DD4"],
"green shorts":["DD5"],
"green tea":["BXa","BXb"],
"greengrocer":["BXM","BXJ","BXK","BXL"],
"greengrocers":["Dq8"],
"greenhouse":["BXS","BXN","BXO","BXP","BXQ"],
"greenhouse effect":["BXR"],
"greet":["DiB"],
"greet greeted":["DiB"],
"greeting":["DiB"],
"greetings":["DXK"],
"grey":["DD6"],
"grill":["BXc"],
"grim":["BXd"],
"grin":["BXf","BXe"],
"grip":["BXh","BXg"],
"grocery":["BXi"],
"grocery store":["BXj"],
"groom":["BXk","Dq9"],
"ground":["BXl"],
"ground floor":["DXL"],
"groundwater":["DXM","BXm"],
"group":["BXp","BXn","BXo"],
"grow":["DiC","BXs"],
"grow food":["BXq"],
"grow grew":["DiC"],
"growing":["DiC"],
"growling":["BXr"],
"grumpy":["BXu","BXt"],
"guacamole":["DD7"],
"guard":["DiD","DiE"],
"guard guarded":["DiD","DiE"],
"guard the door":["DiE"],
"guarding":["DiD","DiE"],
"guarding the door":["DiE"],
"guava":["BXy","BXv","BXw","BXx"],
"guest":["DXN"],
"guests":["DXO"],
"guide":["DiF","BX0"],
"guide book":["BXz"],
"guide guided":["DiF"],
"guide tourists":["DiF"],
"guiding":["DiF"],
"guiding tourists":["DiF"],
"guinea pig":["BX1","BX2","BX3","BX4"],
"guitar":["DD8","BX9","BX5","BX6","BX7","BX8"],
"gull":["BYD","BYA","BYB","BYC"],
"gum":["BYJ","BYE","BYF","BYG"],
"gummybears":["BYI","BYH"],
"guy":["BYK"],
"gym":["DD9","BYR","BYL","BYM","BYN"],
"gymnasium":["BYO"],
"gymnastics":["BYQ","BYP"],
"h":["DZ0","DZz"],
"habitable":["DXP"],
"habitat":["BYS"],
"hack":["BYU","BYT"],
"hacksaw":["BYY","BYV","BYW","BYX"],
"hail":["DEB","DEA","BYa","BYZ"],
"hair":["DEG","BYl","BYb"],
"hair dryer":["DEF","BYh","BYi","BYj"],
"hair salon":["DEH","BYm","BYn","BYo"],
"hair stylist":["BYp","BYq"],
"hairbrush":["DEC","BYe","BYc","BYd"],
"hairdresser":["DEE","DED","BYg","BYf"],
"hairline":["BYk"],
"half":["BYr"],
"half past 12":["DeH"],
"half past 2":["DeI"],
"half past 5":["DeF"],
"half past 7":["DeG"],
"half past five":["DeF"],
"half past seven":["DeG"],
"half past twelve":["DeH"],
"half past two":["DeI"],
"hall":["BY1","BYs","BYt","BYu"],
"halloween":["BY0","BYv","BYw","BYx"],
"halloween candy":["BYy","BYz"],
"hallway":["BY4","BY2","BY3"],
"halt":["BY6","BY5"],
"ham":["DEK","BZR","BY7","BY8","BY9"],
"hamburger":["BZF","BZA","BZB","BZC","BZD","BZE"],
"hamburgers":["BZG"],
"hamlet":["BZH"],
"hammer":["DiG","DEI","BZM","BZI","BZJ","BZK","BZL"],
"hammer a nail":["DiG"],
"hammer hammered":["DiG"],
"hammering":["DiG"],
"hammering a nail":["DiG"],
"hammock":["DEJ","BZQ","BZN","BZO","BZP"],
"hamster":["BZY","BZS","BZT","BZU","BZV"],
"hamster cage":["BZW","BZX"],
"hand":["DEN","BZl","BZZ","BZa"],
"hand drill":["BZh"],
"hand dryer":["DEM"],
"hand in":["DiH"],
"hand in handed in":["DiH"],
"hand in homework":["DiH"],
"hand out":["DiI"],
"hand out fliers":["DiI"],
"hand out handed out":["DiI"],
"handbag":["DEL","BZf","BZb","BZc","BZd","BZe"],
"handball":["BZg"],
"handing in":["DiH"],
"handing in homework":["DiH"],
"handing out":["DiI"],
"handing out fliers":["DiI"],
"handlebars":["BZk","BZi","BZj"],
"handrail":["DEO"],
"hands":["DEP","BZu","BZm","BZn","BZo"],
"hands up":["BZv"],
"handsaw":["BZq","BZp"],
"handsome":["BZt","BZr","BZs"],
"handyman":["DER","DEQ"],
"hang":["BZ2","BZw","BZx"],
"hang out":["DiJ","DiK"],
"hang out hung out":["DiJ","DiK"],
"hang out with friends":["DiK"],
"hang up":["DiM","DiL"],
"hang up clothes":["DiL"],
"hang up hung up":["DiL","DiM"],
"hanger":["BZ0","BZy","BZz"],
"hangers":["BZ1"],
"hanging out":["DiJ","DiK"],
"hanging out with friends":["DiK"],
"hanging up":["DiM","DiL"],
"hanging up clothes":["DiL"],
"happier":["DES"],
"happiness":["DXQ","BZ3"],
"happy":["DET","DXR","BZ7","BZ4","BZ5","BZ6"],
"harbor":["BaC","BZ8","BZ9","BaA","BaB"],
"hard":["BaD"],
"hard working":["DrA"],
"hardwood":["BaE"],
"hardworking":["DXS","BaF"],
"hare":["BaI","BaG","BaH"],
"harmful gas":["DXT"],
"harmless":["DXU"],
"harmonica":["DEU","BaM","BaJ","BaK","BaL"],
"harp":["DEV","BaR","BaN","BaO","BaP","BaQ"],
"harvest":["BaT","BaS"],
"hat":["DEY","DEW","DEX","BaX","BaU","BaV","BaW"],
"haunted house":["BaY","BaZ","Baa","Bab"],
"have":["Dif","Die"],
"have a baby":["DiN"],
"have a barbecue":["DrB"],
"have a bbq":["DiO"],
"have a campfire":["DiP"],
"have a cat":["DiQ"],
"have a dog":["DiR"],
"have a meeting":["DiS"],
"have a music lesson":["DrC"],
"have a party":["DiU"],
"have a photo taken":["DiV"],
"have a picnic":["DrD"],
"have a snowball fight":["DiW"],
"have an online meeting":["DiT"],
"have bad breath":["DiX"],
"have breakfast":["DiY","DiZ"],
"have class":["Dia"],
"have coffee":["Dib"],
"have cooking class":["Dic"],
"have dinner":["DrE"],
"have fun":["DrF"],
"have had":["DiO","DiP","DiQ","Die"],
"have lunch":["Did"],
"have two pens":["Die"],
"have two phones":["Dif"],
"having":["Dif","Die"],
"having a baby":["DiN"],
"having a bbq":["DiO"],
"having a campfire":["DiP"],
"having a cat":["DiQ"],
"having a dog":["DiR"],
"having a meeting":["DiS"],
"having a party":["DiU"],
"having a photo taken":["DiV"],
"having a snowball fight":["DiW"],
"having an online meeting":["DiT"],
"having bad breath":["DiX"],
"having breakfast":["DiY","DiZ"],
"having class":["Dia"],
"having coffee":["Dib"],
"having cooking class":["Dic"],
"having lunch":["Did"],
"having two pens":["Die"],
"having two phones":["Dif"],
"hawk":["Bag","Bac","Bad","Bae","Baf"],
"hay":["Bal","Bah","Bai","Baj","Bak"],
"hay fever":["DXV"],
"hazel":["Bao"],
"hazelnuts":["Ban","Bam"],
"head":["DEd","DEZ","Ba0","Bap"],
"head of lettuce":["Bat","Bau"],
"headache":["DEa","DXW","Bar","Baq"],
"headband":["Bas"],
"headphones":["DEc","DEb","Baz","Bav","Baw","Bax","Bay"],
"headset":["DEe","Ba4","Ba1","Ba2","Ba3"],
"health":["Ba5"],
"healthier":["DEf"],
"healthy":["Ba6"],
"hear":["Dig","Ba8"],
"hear a noise":["Dig"],
"hear heard":["Dig"],
"hearing":["Dig","Ba7"],
"hearing a noise":["Dig"],
"heart":["BbI","Ba9","BbA","BbB","BbC","BbD"],
"heart attack":["BbE","BbF","BbG","BbH"],
"heat":["BbN","BbJ","BbK"],
"heater":["DEg"],
"heating":["BbM","BbL"],
"heavier":["DEi","DEh"],
"heavy":["DEk","DEj","BbS","BbO","BbP","BbQ","BbR"],
"hedge":["Bbb","BbT","BbU","BbV"],
"hedgehog":["Bba","BbW","BbX","BbY","BbZ"],
"heel":["DEl"],
"height":["DXX","Bbd","Bbc"],
"helicopter":["DEm","Bbj","Bbe","Bbf","Bbg","Bbh","Bbi"],
"hell":["Bbl","Bbk"],
"helmet":["DEn","Bbp","Bbm","Bbn","Bbo"],
"help":["Bbr","Bbq"],
"helpful":["DXY"],
"hen":["Bbt","Bbs"],
"herbal":["Bbx","Bbu","Bbv","Bbw"],
"herbivore":["DXZ"],
"hero":["DrG"],
"heron":["Bb0","Bby","Bbz"],
"hesitate":["DXa"],
"hexagon":["Bb2","Bb1"],
"hibernate":["DXb","Bb4","Bb3"],
"hibernation":["DXc"],
"hiccup":["Bb5"],
"hidden":["BcA","Bb6","Bb7","Bb8","Bb9"],
"hide":["Dih","BcD","BcB","BcC"],
"hide and seek":["DrH"],
"hide behind the tree":["Dih"],
"hide hid":["Dih"],
"hideing":["Dih"],
"hiding behind the tree":["Dih"],
"hieroglyphics":["BcH","BcE","BcF","BcG"],
"high":["DEr","BcT","BcI","BcJ"],
"high heels":["DEp"],
"high jump":["DEq","BcK","BcL"],
"higher":["DEo"],
"highlands":["BcP","BcM","BcN","BcO"],
"highlight":["Dii"],
"highlight highlighted":["Dii"],
"highlight lines":["Dii"],
"highlighter":["BcS","BcQ","BcR"],
"highlighting":["Dii"],
"highlighting lines":["Dii"],
"hike":["BcW","BcU","BcV"],
"hiking":["Bcd","BcX"],
"hiking boots":["BcY","BcZ","Bca","Bcb","Bcc"],
"hiking trail":["Bce","Bcf","Bcg","Bch"],
"hilarious":["DXd"],
"hill":["Bcl","Bci","Bcj","Bck"],
"hills":["Bco","Bcm","Bcn"],
"himalaya":["Bcq","Bcp"],
"hippo":["DEs","Bcu","Bcr","Bcs","Bct"],
"hippopotamus":["DrI"],
"hippos":["Bcw","Bcv"],
"hips":["DXe"],
"hired":["Bcx"],
"historic":["Bc1","Bcy","Bcz","Bc0"],
"history":["DEt","Bc4","Bc2"],
"history book":["Bc3"],
"hit":["Dik","Dij","Bc6","Bc5"],
"hit a ball":["Dij"],
"hit a nail":["Dik"],
"hit hit":["Dij","Dik"],
"hitting":["Dik","Dij"],
"hitting a ball":["Dij"],
"hitting a nail":["Dik"],
"hive":["BdA","Bc7","Bc8","Bc9"],
"hobby":["DXf","BdB"],
"hockey":["DEu","BdG","BdC","BdD","BdE","BdF"],
"hoe":["BdI","BdH"],
"hold":["Din","Dil","Dim","BdL","BdJ"],
"hold a baby":["Dil"],
"hold a ball":["Dim"],
"hold hands":["Din","BdK"],
"hold held":["Dil","Dim","Din"],
"hold on":["Dio"],
"hold on held on":["Dio"],
"hold out":["Dip"],
"hold out held out":["Dip"],
"hold up":["Diq"],
"hold up a sign":["Diq"],
"hold up held up":["Diq"],
"holding":["Din","Dil","Dim"],
"holding a baby":["Dil"],
"holding a ball":["Dim"],
"holding hands":["Din"],
"holding on":["Dio"],
"holding out":["Dip"],
"holding up":["Diq"],
"holding up a sign":["Diq"],
"hole":["BdQ","BdM","BdN","BdO","BdP"],
"hole punch":["BdR","BdS","BdT"],
"holiday":["BdV","BdU"],
"hollow":["BdW"],
"holly":["BdX"],
"home":["Bdf","BdY","BdZ","Bda"],
"homeland":["Bdb"],
"homeless":["Bde","Bdc","Bdd"],
"hometown":["DXg"],
"homework":["Bdi","Bdg","Bdh"],
"honey":["DEv","Bdm","Bdj","Bdk","Bdl"],
"Hong Kong flag":["DEw"],
"hoodie":["DEx","Bds","Bdn","Bdo","Bdp","Bdq","Bdr"],
"hook":["Bdv","Bdt","Bdu"],
"hooves":["Bdx","Bdw"],
"hop":["DXj"],
"hope":["DXi","Bdz"],
"hopeful":["DXh","Bdy"],
"horizon":["DXk","Bd1","Bd0"],
"hormone":["DXl"],
"horns":["Bd4","Bd2","Bd3"],
"horror":["Bd5"],
"horse":["DEy","Bd9","Bd6","Bd7","Bd8"],
"horse racing":["BeA","BeB","BeC"],
"horse riding":["DEz","BeD","BeE","BeF"],
"horses":["BeJ","BeG","BeH","BeI"],
"hose":["BeN","BeK","BeL","BeM"],
"hospital":["DE0","BeR","BeO","BeP","BeQ"],
"hostel":["DXm","BeS"],
"hostile":["DXn"],
"hot":["DE7","DE1","DE2","Bep","BeT"],
"hot air balloon":["BeU","BeV","BeW"],
"hot and spicy":["BeX","BeY","BeZ"],
"hot chocolate":["DE3","Bea","Beb","Bec","Bed"],
"hot cross buns":["Bee","Bef","Beg"],
"hot dog":["DE4","Beh","Bei","Bej","Bek","Bel"],
"hot dogs":["Bem"],
"hot soup":["Beq","Ber"],
"hotel":["Beo","Ben"],
"hotel manager":["DE5","DE6"],
"hotter":["DE8"],
"hound":["Bev","Bes","Bet","Beu"],
"hounds":["Bey","Bew","Bex"],
"hour":["DrJ"],
"house":["DE9","Be5","Bez","Be0","Be1","Be2"],
"household chores":["DXo"],
"housekeeper":["Be4","Be3"],
"housewife":["Be9","Be6","Be7","Be8"],
"how":["Ddk"],
"how are you":["DrK"],
"How do you go to school":["Ddk"],
"how far":["Ddl"],
"How far is London":["Ddl"],
"how heavy":["Ddm"],
"How heavy are you":["Ddm"],
"how much":["Ddn"],
"How much is the book":["Ddn"],
"how old":["Ddo"],
"How old are you":["Ddo"],
"how tall":["Ddp"],
"How tall are you":["Ddp"],
"huddle":["BfB","BfA"],
"hug":["Dir","Dis","BfF","BfC","BfD","BfE"],
"hug hugged":["Dir","Dis"],
"hug someone":["Dis"],
"hugging":["Dir","Dis"],
"hugging someone":["Dis"],
"hulk":["DXp"],
"humid":["DrL"],
"hummingbird":["BfI","BfG","BfH"],
"hump":["BfJ"],
"hundred":["DrM"],
"hungry":["BfK"],
"hunt":["BfQ","BfL"],
"hunter":["BfP","BfM","BfN","BfO"],
"hurricane":["DFB","DFA","BfT","BfR","BfS"],
"hurt":["DFC","BfU"],
"husband":["DZY","BfY","BfV","BfW","BfX"],
"hut":["Bfd","BfZ","Bfa","Bfb","Bfc"],
"hyacinth":["Bff","Bfe"],
"hyena":["Bfj","Bfg","Bfh","Bfi"],
"i":["DZ2","DZ1"],
"I am happy":["DrN"],
"ice":["DFG","BgL","Bfk","Bfl","Bfm"],
"ice age":["Bfn","Bfo"],
"ice coffee":["DFD"],
"ice cream":["DFE","DFF","Bfq","Bfr","Bfs","Bft","Bfu"],
"ice cream stand":["Bfv"],
"ice cream van":["Bfw","Bfx","Bfy"],
"ice cube":["Bfz"],
"ice cubes":["Bf0","Bf1"],
"ice giant":["BgA"],
"ice hockey":["BgB","BgC","BgD"],
"ice lolly":["BgJ","BgK"],
"ice rink":["BgM","BgN"],
"ice skate":["BgO","BgP","BgQ"],
"ice skates":["BgR","BgS","BgT"],
"ice skating":["BgU","BgV","BgW"],
"ice tea":["DFH"],
"iceberg":["Bfp"],
"iced coffee":["Bf2","Bf3","Bf4","Bf5"],
"iced tea":["Bf6","Bf7","Bf8","Bf9"],
"Iceland":["BgI","BgE","BgF","BgG","BgH"],
"icicle":["BgY","BgX"],
"icicles":["Bgd","BgZ","Bga","Bgb","Bgc"],
"icy":["Bgh","Bge","Bgf","Bgg"],
"id":["Bgn","Bgi","Bgj","Bgk"],
"ID card":["DFI"],
"idea":["Bgl"],
"identify":["Bgm"],
"igloo":["Bgr","Bgo","Bgp","Bgq"],
"igneous":["Bgs"],
"ignore":["Dit"],
"ignore ignored":["Dit"],
"ignore someone":["Dit"],
"ignoring":["Dit"],
"ignoring someone":["Dit"],
"iguana":["Bgv","Bgt","Bgu"],
"ill":["Bgx","Bgw"],
"illiterate":["DXq"],
"illuminated":["Bg0","Bgy","Bgz"],
"illustration":["Bg3","Bg1","Bg2"],
"illustrator":["DFK","DFJ","DXr"],
"image":["Bg4"],
"imagine":["Bg5"],
"impact":["DXs"],
"impatient":["DXt"],
"imperative":["DXu"],
"implant":["DXv"],
"important":["Bg7","Bg6"],
"imposter":["DXw"],
"impractical":["DXx"],
"impure":["Bg8"],
"in":["DdQ","DdL","DdM","Bho"],
"in charge":["DXy"],
"in front":["DdP","DX5"],
"in front of":["DdN","DdO"],
"in love":["Bhl","Bhm","Bhn"],
"in the middle":["DdR"],
"inappropriate":["Bg9"],
"income":["DXz"],
"inconvenient":["DX0"],
"increase":["BhB","BhA"],
"India":["DFN","BhG","BhC","BhD","BhE"],
"India flag":["DFL"],
"Indian":["DFM"],
"Indian elephant":["BhF"],
"indicate":["DX1"],
"indignant":["DX2"],
"indigo":["DFO"],
"individual":["BhI","BhH"],
"Indonesia":["BhM","BhJ","BhK","BhL"],
"Indonesia flag":["DFP"],
"industry":["BhQ","BhN","BhO","BhP"],
"inexpensive":["DX3"],
"infant":["BhT","BhR","BhS"],
"infection":["BhU"],
"inflict":["DX4"],
"information":["BhX","BhV"],
"information board":["BhW"],
"ingredients":["Bha","BhY","BhZ"],
"inhaling":["DX6"],
"inherit":["DX7"],
"initial":["DX8"],
"initiative":["DX9"],
"injection":["Bhb"],
"injure":["DYA"],
"injury":["Bhf","Bhc","Bhd","Bhe"],
"ink":["Bhi","Bhg","Bhh"],
"inline skates":["Bhj","Bhk"],
"inner core":["DYB"],
"innovation":["DYC"],
"insect":["DFQ","Bhp"],
"insects":["DrO"],
"insert":["Diu"],
"insert inserted":["Diu"],
"inserting":["Diu"],
"inside":["Bhq"],
"inspirational":["Bhr"],
"instant coffee":["DFR"],
"instant noodles":["DFS","Bhs","Bht","Bhu","Bhv","Bhw"],
"instruments":["DrP"],
"insurance":["DYD","Bhx"],
"integration":["DYE"],
"intelligent":["Bh0","Bhy","Bhz"],
"interactive whiteboard":["Bh1","Bh2"],
"interested":["Bh3"],
"interesting":["DYF"],
"interior":["Bh4"],
"internet":["Bh6","Bh5"],
"interpret":["Div"],
"interpret interpreted":["Div"],
"interpreter":["DFU","DFT"],
"interpreting":["Div"],
"interview":["Diw","Dix","Bh8","Bh7"],
"interview interviewed":["Diw","Dix"],
"interview someone":["Dix"],
"interviewing":["Diw","Dix"],
"interviewing someone":["Dix"],
"intestines":["BiA","Bh9"],
"introduce":["DrQ"],
"intuition":["BiB"],
"invent":["BiC"],
"invention":["DrR"],
"inventor":["DYG","BiD"],
"investment":["BiE"],
"invisible":["DrS"],
"invitation":["DYH"],
"invite":["DYI"],
"iphone":["BiG","BiF"],
"Iran":["BiK","BiH","BiI","BiJ"],
"Ireland":["DFW","BiQ","BiL","BiM","BiN","BiO","BiP"],
"Ireland flag":["DFV"],
"Irish":["DFX"],
"iron":["Diy","BiR"],
"iron a shirt":["Diy"],
"iron ironed":["Diy"],
"ironing":["Diy"],
"ironing a shirt":["Diy"],
"irritated":["DYJ"],
"irritating":["DYK"],
"is was":["Deu"],
"island":["DFY","BiU","BiS","BiT"],
"isolated":["DYL"],
"Italian":["DFZ"],
"Italy":["DFb","Bia","BiV","BiW","BiX","BiY","BiZ"],
"Italy flag":["DFa"],
"itch":["Bib"],
"itchy":["DrT"],
"itinerary":["DYM"],
"its cold":["DrU"],
"its sunny":["DrV"],
"j":["DZ4","DZ3"],
"jack fruit":["Big","Bih"],
"jack in the box":["Bii"],
"jack o lantern":["DrX"],
"jacket":["DFc","Bif","Bic","Bid","Bie"],
"jackfruit":["DrW"],
"jade":["Bik","Bij"],
"jaguar":["Bio","Bil","Bim","Bin"],
"jailbreak":["DYN"],
"jam":["Biw","Bip","Biq","Bir"],
"Jamaica":["Biv","Bis","Bit","Biu"],
"janitor":["DFe","DFd"],
"January":["DrY"],
"Japan":["DFh","Bi2","Bix","Biy","Biz","Bi0","Bi1"],
"Japan flag":["DFg"],
"Japanese":["DFf"],
"jar":["Bi7","Bi3","Bi4","Bi5","Bi6"],
"jasmine":["Bi9","Bi8"],
"javelin":["DFi"],
"jaw":["BjA"],
"jazz":["BjC","BjB"],
"jealous":["DFj","DYO"],
"jeans":["DFk","BjI","BjD","BjE","BjF","BjG","BjH"],
"jeep":["BjM","BjJ","BjK","BjL"],
"jello":["BjO","BjN"],
"jelly":["BjU","BjP"],
"jellybeans":["BjR","BjQ"],
"jellyfish":["BjT","BjS"],
"jester":["BjY","BjV","BjW","BjX"],
"jet":["Bjb","BjZ","Bja"],
"jewel":["Bje","Bjc","Bjd"],
"jewelry":["DrZ"],
"jewelry store":["Bjf","Bjg"],
"jigsaw":["DFl","Bjj","Bjh","Bji"],
"jingle bells":["Bjk","Bjl","Bjm","Bjn"],
"job":["Bjo"],
"jockey":["Bjr","Bjp","Bjq"],
"jog":["Diz","Bj1","Bjs","Bjt","Bju","Bjv","Bjw"],
"jog jogged":["Diz"],
"jogging":["Diz","Bj0","Bjx","Bjy","Bjz"],
"join":["Di0","Bj2"],
"join a book club":["Di0"],
"join joined":["Di0"],
"joining":["Di0"],
"joining a book club":["Di0"],
"joints":["Bj3"],
"joke":["DYP"],
"jolly":["DYQ"],
"journalist":["DFn","DFm","Bj4"],
"journey":["Bj8","Bj5","Bj6","Bj7"],
"joy":["BkB","Bj9","BkA"],
"judge":["BkF","BkC","BkD","BkE"],
"judo":["BkK","BkG","BkH","BkI","BkJ"],
"jug":["DFo","BkS","BkL","BkM","BkN"],
"juggle":["BkP","BkO"],
"juggler":["BkR","BkQ"],
"juice":["BkV","BkT","BkU"],
"July":["Dra"],
"jump":["Di4","Di1","Di2","Di3","Bkg","BkW","BkX","BkY"],
"jump jumped":["Di3","Di1","Di2","Di4"],
"jump over a puddle":["Di3"],
"jump rope":["Bkh","Bki","Bkj","Bkk"],
"jumper":["Bkd","BkZ","Bka","Bkb","Bkc"],
"jumping":["Di4","Di1","Di2","Di3","Bkf","Bke"],
"jumping over a puddle":["Di3"],
"June":["Drb"],
"jungle":["Bko","Bkl","Bkm","Bkn"],
"junk food":["Bkp","Bkq","Bkr"],
"jupiter":["Bkt","Bks"],
"k":["DZ6","DZ5"],
"kangaroo":["DFp","Bkz","Bku","Bkv","Bkw","Bkx","Bky"],
"karate":["DFq","Bk3","Bk0","Bk1","Bk2"],
"kayak":["Bk9","Bk4","Bk5"],
"kayaking":["Bk8","Bk6","Bk7"],
"keep":["BlA"],
"Kenya":["BlF","BlB","BlC","BlD","BlE"],
"ketchup":["DFr","BlI","BlG","BlH"],
"kettle":["DFs","BlM","BlJ","BlK","BlL"],
"key":["BlV","BlN","BlO","BlP"],
"keyboard":["DFu","DFt","BlU","BlQ","BlR","BlS","BlT"],
"keyring":["BlZ","BlW","BlX","BlY"],
"keys":["DFv","Blb","Bla"],
"khaki":["DFw"],
"kick":["Di5","Blh","Blc","Bld","Ble","Blf","Blg"],
"kick a ball":["Di5"],
"kick kicked":["Di5"],
"kicking":["Di5"],
"kicking a ball":["Di5"],
"kid":["Bll"],
"kidney":["Blj","Bli"],
"kidneys":["Blk"],
"kids":["Blm"],
"killer whale":["Bln","Blo","Blp","Blq"],
"kilogram":["Bls","Blr"],
"kind":["Blt"],
"king":["Bl0","Blu","Blv"],
"king cobra":["Blw"],
"kingfisher":["Blz","Blx","Bly"],
"kiss":["Bl4","Bl1","Bl2","Bl3"],
"kit":["BmF"],
"kitchen":["DFx","Bl8","Bl5","Bl6","Bl7"],
"kite":["DFy","BmE","Bl9","BmA","BmB","BmC"],
"kite flying":["BmD"],
"kites":["Drc"],
"kitten":["BmK","BmG","BmH","BmI","BmJ"],
"kittens":["BmM","BmL"],
"kiwi":["BmR","BmN","BmO"],
"kiwi fruit":["DFz","BmP","BmQ"],
"knead":["Di6","BmT","BmS"],
"knead dough":["Di6"],
"knead kneaded":["Di6"],
"kneading":["Di6"],
"kneading dough":["Di6"],
"knee":["DF0","BmU"],
"kneel":["Di7"],
"kneel down":["Di7"],
"kneel knelt":["Di7"],
"kneeling":["Di7"],
"kneeling down":["Di7"],
"knees":["Drd"],
"knife":["DF1","BmX","BmV","BmW"],
"knight":["Bmb","BmY","BmZ","Bma"],
"knit":["Di8"],
"knit knitted":["Di8"],
"knitting":["Di8","Bme","Bmc","Bmd"],
"knives":["Bmf"],
"know":["Di9"],
"know knew":["Di9"],
"know the answer":["Di9"],
"knowing":["Di9"],
"knowing the answer":["Di9"],
"knowledge":["Bmg"],
"knuckle":["DF2"],
"knuckles":["DF3"],
"koala":["Bml","Bmh","Bmi","Bmj","Bmk"],
"Korea":["Bmp","Bmm","Bmn","Bmo"],
"Korea flag":["DF4"],
"kumquat":["Bmt","Bmq","Bmr","Bms"],
"kung fu":["Bmu","Bmv","Bmw","Bmx"],
"l":["DZ8","DZ7"],
"lab technician":["Bm5","Bm6"],
"laboratory":["Bm1","Bmy","Bmz","Bm0"],
"labrador":["Bm4","Bm2","Bm3"],
"lace":["Bm8","Bm7"],
"laces":["Bm9"],
"ladder":["DF5","BnD","BnA","BnB","BnC"],
"ladies":["BnF","BnE"],
"ladle":["Dre"],
"lady":["BnS","BnG","BnH","BnI"],
"ladybird":["BnN","BnJ","BnK","BnL","BnM"],
"ladybug":["BnP","BnO"],
"ladybugs":["BnR","BnQ"],
"lake":["DF6","BnY","BnT","BnU","BnV","BnW","BnX"],
"lamb":["DF7","Bnc","BnZ","Bna","Bnb"],
"lamp":["DF9","DF8","Bnf","Bnd","Bne"],
"land":["Bnr","Bng","Bnh","Bni","Bnj"],
"landfill":["Bno","Bnk","Bnl","Bnm","Bnn"],
"landmark":["Bnq","Bnp"],
"landscape":["Drf"],
"landslide":["Bnv","Bns","Bnt","Bnu"],
"lane":["Bny","Bnw","Bnx"],
"language":["Bnz"],
"languages":["Bn0"],
"lantern":["Bn3","Bn1","Bn2"],
"lanterns":["Bn6","Bn4","Bn5"],
"laptop":["DGB","DGA","BoB","Bn7","Bn8","Bn9","BoA"],
"large":["BoD","BoC"],
"late":["BoE"],
"latte":["BoL","BoF","BoG","BoH","BoI","BoJ","BoK"],
"laugh":["DjA","BoS","BoM","BoN"],
"laugh laughed":["DjA"],
"laughing":["DjA","BoR","BoO","BoP","BoQ"],
"laughter":["BoW","BoT","BoU","BoV"],
"laundromat":["BoZ","BoX","BoY"],
"laundry":["Bod","Boa","Bob","Boc"],
"laundry room":["Drg"],
"lava":["Bog","Boe","Bof"],
"lavender":["Boi","Boh"],
"lawn":["Bou","Boj","Bok","Bol","Bom","Bon"],
"lawn mower":["DGC","Boo","Bop","Boq","Bor","Bos","Bot"],
"lawyer":["DGE","DGD","Boy","Bov","Bow","Box"],
"lay":["DjB"],
"lay eggs":["DjB"],
"lay laid":["DjB"],
"lay out":["DjC"],
"lay out a table":["DjC"],
"lay out laid out":["DjC"],
"layers":["Boz"],
"laying":["DjB"],
"laying eggs":["DjB"],
"laying out":["DjC"],
"laying out a table":["DjC"],
"lazy":["Bo3","Bo0","Bo1","Bo2"],
"leaf":["DGF","Bo7","Bo4","Bo5","Bo6"],
"learn":["DjE","DjD","Bo9","Bo8"],
"learn Japanese":["DjD"],
"learn learned":["DjD"],
"learn learnt":["DjE"],
"learn maths":["DjE"],
"learning":["DjE","DjD"],
"learning Japanese":["DjD"],
"learning maths":["DjE"],
"leash":["BpD","BpA","BpB","BpC"],
"leather":["BpF","BpE"],
"leave":["DjF","DjG","DjH"],
"leave left":["DjF","DjG","DjH"],
"leave school":["DjG"],
"leave work":["DjH"],
"leaves":["BpK","BpG","BpH","BpI","BpJ"],
"leaving":["DjF","DjG","DjH"],
"leaving school":["DjG"],
"leaving work":["DjH"],
"lecturer":["BpM","BpL"],
"leek":["BpO","BpN"],
"leg":["DGH","BpU","BpP"],
"leggings":["DGG"],
"lego":["BpT","BpQ","BpR","BpS"],
"legs":["DGJ","DGI","BpX","BpV","BpW"],
"lemon":["DGL","Bpg","BpY","BpZ","Bpa"],
"lemon juice":["Bpe","Bpf"],
"lemon tea":["DGN","Bpm","Bpn","Bpo","Bpp"],
"lemonade":["DGK","Bpd","Bpb","Bpc"],
"lemons":["DGM","Bpl","Bph","Bpi","Bpj","Bpk"],
"lend":["Bpr","Bpq"],
"lend a book":["DjI"],
"lend lent":["DjI"],
"lending a book":["DjI"],
"length":["Bps"],
"lentils":["Bpx","Bpt","Bpu","Bpv","Bpw"],
"leopard":["Bp2","Bpy","Bpz","Bp0","Bp1"],
"let go":["Drh"],
"letter":["DGO"],
"letter a":["DZm"],
"letter b":["DZo"],
"letter c":["DZq"],
"letter d":["DZs"],
"letter e":["DZu"],
"letter f":["DZw"],
"letter g":["DZy"],
"letter h":["DZ0"],
"letter i":["DZ2"],
"letter j":["DZ4"],
"letter k":["DZ6"],
"letter l":["DZ8"],
"letter m":["DaA"],
"letter n":["DaC"],
"letter o":["DaE"],
"letter p":["DaG"],
"letter q":["DaI"],
"letter r":["DaK"],
"letter s":["DaM"],
"letter t":["DaO"],
"letter u":["DaQ"],
"letter v":["DaS"],
"letter w":["DaU"],
"letter x":["DaW"],
"letter y":["DaY"],
"letter z":["Daa"],
"letters":["Bp6","Bp3","Bp4","Bp5"],
"lettuce":["DGP","BqA","Bp7","Bp8","Bp9"],
"level":["BqB"],
"librarian":["BqC"],
"library":["DGQ","BqF","BqD","BqE"],
"licence":["BqG"],
"lick":["BqI","BqH"],
"lid":["BqN","BqJ","BqK","BqL","BqM"],
"lie":["BqP","BqO"],
"lie down":["DjJ","DjK"],
"lie down lay down":["DjK"],
"lie lay":["DjJ"],
"life jacket":["BqZ","Bqa"],
"lifebelt":["BqS","BqQ","BqR"],
"lifeboat":["BqV","BqT","BqU"],
"lifeguard":["DGS","DGR","BqY","BqW","BqX"],
"lift":["DjL","DjM","Bqd","Bqb","Bqc"],
"lift lifted":["DjL","DjM"],
"lift weights":["DjM","Bqe","Bqf"],
"lifting":["DjL","DjM"],
"lifting weights":["DjM"],
"light":["DjN","DGc","Bqv","Bqg","Bqh","Bqi"],
"light a candle":["DjN"],
"light blue":["DGT"],
"light brown":["DGU"],
"light bulb":["DGV","Bqj","Bqk"],
"light bulbs":["Bql","Bqm"],
"light green":["DGY"],
"light lighted":["DjN"],
"light red":["DGd"],
"lighter":["DGX","DGW"],
"lighthouse":["DGZ","Bqr","Bqn","Bqo","Bqp","Bqq"],
"lighting":["DjN"],
"lighting a candle":["DjN"],
"lightning":["DGb","DGa","Bqu","Bqs","Bqt"],
"lights":["Bqz","Bqw","Bqx","Bqy"],
"like":["DjQ","DjO","DjP","Bq1","Bq0"],
"like apples":["DjO"],
"like football":["DjP"],
"like icecream":["DjQ"],
"like liked":["DjO","DjP","DjQ"],
"liking":["DjQ","DjO","DjP"],
"lily":["Bq4","Bq2","Bq3"],
"lime":["DGe","BrB","Bq5","Bq6","Bq7"],
"lime juice":["Bq8","Bq9","BrA"],
"limes":["DGf","BrD","BrC"],
"limo":["DGg"],
"line":["DGh"],
"line up":["Dri"],
"link":["BrE"],
"lion":["DGi","BrJ","BrF","BrG","BrH","BrI"],
"lions":["BrN","BrK","BrL","BrM"],
"lip":["Drj"],
"lip stick":["DGj"],
"lips":["BrS","BrO","BrP","BrQ","BrR"],
"lipstick":["BrW","BrT","BrU","BrV"],
"liquid":["BrZ","BrX","BrY"],
"list":["Drl"],
"listen":["DjR","DjS","Brd","Bra","Brb"],
"listen listened":["DjR","DjS"],
"listen to":["Drk"],
"listen to music":["DjS","Bre","Brf","Brg"],
"listening":["DjR","DjS"],
"listening to music":["DjS","Brc"],
"literature":["Brk","Brh","Bri","Brj"],
"Lithuania":["Bro","Brl","Brm","Brn"],
"litter":["Brs","Brp","Brq","Brr"],
"little brother":["Brt"],
"little sister":["Bru"],
"live":["DjT"],
"live in London":["DjT"],
"live lived":["DjT"],
"liver":["Brw","Brv"],
"Liverpool":["Drm"],
"living":["DjT"],
"living in London":["DjT"],
"living room":["DGk","Brx","Bry","Brz","Br0","Br1","Br2"],
"lizard":["DGl","Br7","Br3","Br4","Br5","Br6"],
"llama":["Drn"],
"loaf":["Dro"],
"loaf of bread":["Br8","Br9","BsA","BsB"],
"loaves":["BsF","BsC","BsD","BsE"],
"lobby":["BsJ","BsG","BsH","BsI"],
"lobster":["DGm","BsP","BsK","BsL","BsM","BsN","BsO"],
"lock":["DjV","DjU","Bsb","BsQ","BsR","BsS"],
"lock a door":["DjU"],
"lock locked":["DjU","DjV"],
"lock the door":["DjV"],
"locker":["BsW","BsT","BsU","BsV"],
"lockers":["DGn"],
"locket":["Bsa","BsX","BsY","BsZ"],
"locking":["DjV","DjU"],
"locking a door":["DjU"],
"locking the door":["DjV"],
"locust":["Bsc"],
"lodge":["Bsf","Bsd","Bse"],
"log":["Bsh","Bsg"],
"logo":["Drp"],
"logs":["Bsj","Bsi"],
"lollipop":["Bso","Bsk","Bsl","Bsm","Bsn"],
"lollipops":["Drq"],
"London":["Drr"],
"lonely":["Bss","Bsp","Bsq","Bsr"],
"long":["DGr","Bsy"],
"long hair":["Bst","Bsu","Bsv","Bsw"],
"long jump":["DGq"],
"long neck":["Bsx"],
"longer":["DGp","DGo"],
"look":["Dja","DjX","Bs4","Bsz"],
"look after":["DjW","Bs0"],
"look after looked after":["DjW"],
"look at":["DjY","DjZ","Bs1","Bs2","Bs3"],
"look at a clock":["DjY"],
"look at each other":["DjZ"],
"look at looked at":["DjX"],
"look at pictures":["DjX"],
"look in the mirror":["Dja"],
"look looked":["DjY","DjZ","Dja"],
"look through":["Djb"],
"look through a telescope":["Djb"],
"looking":["Dja","DjX"],
"looking after":["DjW"],
"looking at":["DjY","DjZ"],
"looking at a clock":["DjY"],
"looking at each other":["DjZ"],
"looking at pictures":["DjX"],
"looking in the mirror":["Dja"],
"looking through":["Djb"],
"looking through a telescope":["Djb"],
"lorry":["Bs9","Bs5","Bs6","Bs7","Bs8"],
"lose":["Djc"],
"lose lost":["Djc"],
"lose the game":["Djc"],
"losing":["Djc"],
"losing the game":["Djc"],
"lotus":["BtB","BtA"],
"loud":["DGs","BtF","BtC","BtD","BtE"],
"love":["Djd","BtJ","BtG","BtH","BtI"],
"love loved":["Djd"],
"love the cat":["Djd"],
"lovely":["Drs"],
"loving":["Djd"],
"lower":["DGt"],
"loyal":["BtK"],
"luck":["BtL"],
"lucky":["BtM"],
"lucky money":["Drt"],
"luggage":["DGu","BtS","BtN","BtO","BtP","BtQ","BtR"],
"lumberjack":["DGw","DGv"],
"lunch":["BtW","BtT"],
"lunch box":["BtU","BtV"],
"lunchbox":["Dru"],
"lungs":["BtZ","BtX","BtY"],
"Luxembourg":["Btc","Bta","Btb"],
"luxury":["Btf","Btd","Bte"],
"lychee":["Btj","Btg","Bth","Bti"],
"lying down":["DjJ","DjK"],
"m":["DaA","DZ9"],
"machine":["Btn","Btk","Btl","Btm"],
"machu picchu":["Bto"],
"mad":["Btt","Btp"],
"Madagascar":["Bts","Btq","Btr"],
"magazine":["Btx","Btu","Btv","Btw"],
"magazines":["Bty"],
"magenta":["DGx"],
"magic":["Bt5","Btz","Bt0"],
"magician":["DGz","DGy","Bt4","Bt1","Bt2","Bt3"],
"magnet":["DG0","Bt9","Bt6","Bt7","Bt8"],
"magnifying glass":["BuA","BuB","BuC","BuD","BuE","BuF"],
"mahjong":["BuI","BuG","BuH"],
"maid":["DG2","DG1","BuL","BuJ","BuK"],
"mail":["BuU","BuM","BuN"],
"mail carrier":["Drv"],
"mailbox":["BuS","BuO","BuP","BuQ","BuR"],
"mailman":["DG4","DG3","BuT"],
"main course":["Drw"],
"maize":["BuX","BuV","BuW"],
"majority":["Drx"],
"make":["Djj","Dje","Djf","Djg","Djh","Dji"],
"make a cake":["Dry"],
"make a model":["Dje"],
"make a sandwich":["Djf"],
"make a snowman":["Drz"],
"make a speech":["Djg"],
"make a web":["Djh"],
"make coffee":["Dji"],
"make friends":["Dr0"],
"make made":["Dje","Djf","Djh","Dji","Djj"],
"make my bed":["Dr1","Dr2"],
"make some food":["Djj"],
"making":["Djj","Dje","Djf","Djg","Djh","Dji"],
"making a model":["Dje"],
"making a sandwich":["Djf"],
"making a speech":["Djg"],
"making a web":["Djh"],
"making coffee":["Dji"],
"making some food":["Djj"],
"Malaysia":["Bua","BuY","BuZ"],
"Malaysia flag":["DG5"],
"mall":["Bui","Bub","Buc","Bud","Bue"],
"mallet":["Buh","Buf","Bug"],
"mammal":["DG6"],
"mammals":["Dr3"],
"mammoth":["Bum","Buj","Buk","Bul"],
"man":["Dr6"],
"manage":["Dr4"],
"manager":["Dr5"],
"mandolin":["Buq","Bun","Buo","Bup"],
"mane":["DG7","But","Bur","Bus"],
"mango":["DG9","Buz","Buu","Buv","Buw","Bux","Buy"],
"mangoes":["DG8"],
"mangosteen":["Bu4","Bu0","Bu1","Bu2","Bu3"],
"mantis":["Bu8","Bu5","Bu6","Bu7"],
"manufacture":["BvA","Bu9"],
"many":["Dr7"],
"map":["DHA","BvD","BvB","BvC"],
"marathon":["BvG","BvE","BvF"],
"marble":["BvJ","BvH","BvI"],
"marbles":["BvN","BvK","BvL","BvM"],
"march":["BvP","BvO"],
"March":["Dr8"],
"marigold":["BvS","BvQ","BvR"],
"marine":["BvT"],
"marker":["DHB","BvW","BvU","BvV"],
"markers":["BvY","BvX"],
"market":["Bvd","BvZ","Bva","Bvb","Bvc"],
"marriage":["Bvh","Bve","Bvf","Bvg"],
"married":["Bvi"],
"marry":["Bvl","Bvj","Bvk"],
"mars":["Bvs","Bvm","Bvn"],
"marshmallow":["Bvr","Bvo","Bvp","Bvq"],
"martian":["Bvt"],
"mascot":["Bvv","Bvu"],
"mashed potatoes":["Bvw","Bvx","Bvy"],
"mask":["Bv2","Bvz","Bv0","Bv1"],
"massage":["Djk"],
"massage massaged":["Djk"],
"massaging":["Djk"],
"masseuse":["DHD","DHC"],
"mat":["BwJ","Bv3","Bv4"],
"match":["BwD","Bv5","Bv6","Bv7"],
"matchbox":["Bv9","Bv8"],
"matches":["BwC","BwA","BwB"],
"math":["BwG","BwE"],
"mathematics":["BwF"],
"maths":["DHE","BwI","BwH"],
"mature":["BwK"],
"maximum speed":["BwL"],
"May":["DsA"],
"mayo":["BwN"],
"mayonnaise":["BwM"],
"mayor":["Dr9"],
"meal":["BwQ","BwO","BwP"],
"mean":["DsB"],
"measure":["BwS","BwR"],
"meat":["Bwb","BwT","BwU","BwV"],
"meatball":["BwW"],
"meatballs":["Bwa","BwX","BwY","BwZ"],
"mechanic":["DHI","DHF","Bwf","Bwc","Bwd","Bwe"],
"mechanical engineer":["DHG","DHH"],
"medal":["DHJ","Bwi","Bwg","Bwh"],
"medals":["Bwk","Bwj"],
"media":["DsC"],
"medicine":["DHK","Bwo","Bwl","Bwm","Bwn"],
"meerkat":["Bws","Bwp","Bwq","Bwr"],
"meet":["Djl"],
"meet friends":["DsD"],
"meet met":["Djl"],
"meet someone":["Djl"],
"meeting":["Djl","Bwv","Bwt","Bwu"],
"meeting room":["Bww","Bwx","Bwy"],
"meeting someone":["Djl"],
"melancholy":["Bw3","Bwz","Bw0","Bw1","Bw2"],
"melon":["Bw7","Bw4","Bw5","Bw6"],
"melt":["BxA","Bw8","Bw9"],
"memory":["BxB"],
"memory stick":["DsE"],
"mend":["BxC"],
"mental":["BxD"],
"menu":["DsF"],
"mercury":["DsH","DsG"],
"mermaid":["DHL","BxH","BxE","BxF","BxG"],
"merry go round":["DsI"],
"mess":["DsK"],
"message":["DsJ"],
"messages":["DHM"],
"messier":["DHN"],
"messy":["DHO","BxK","BxI","BxJ"],
"metal":["BxP","BxL","BxM","BxN"],
"metal detector":["BxO"],
"meteor":["BxS","BxQ","BxR"],
"metropolitan":["BxU","BxT"],
"Mexican":["DHP"],
"Mexico":["DHR","BxZ","BxV","BxW","BxX","BxY"],
"Mexico flag":["DHQ"],
"mice":["Bxb","Bxa"],
"microchip":["Bxd","Bxc"],
"microphone":["DHS","Bxh","Bxe","Bxf","Bxg"],
"microscope":["DHT","Bxl","Bxi","Bxj","Bxk"],
"microwave":["DHU","Bxp","Bxm","Bxn","Bxo"],
"microwave oven":["DsL"],
"middle":["DdS"],
"midnight":["DsM"],
"mild":["DHW","DHV"],
"milk":["DHX","Bxt","Bxq","Bxr","Bxs"],
"milkshake":["Bxw","Bxu","Bxv"],
"milkshakes":["Bxy","Bxx"],
"milky way":["Bxz"],
"millipede":["Bx3","Bx0","Bx1","Bx2"],
"mime":["Bx4"],
"minecraft":["Bx5"],
"miner":["ByA"],
"mineral water":["Bx6","Bx7","Bx8","Bx9"],
"mini":["ByC"],
"mini car":["ByB"],
"minivan":["ByD"],
"mints":["DHY"],
"minus":["ByE"],
"mirror":["DHa","DHZ","ByI","ByF","ByG","ByH"],
"miserable":["ByJ"],
"mistake":["DsN"],
"mistletoe":["ByL","ByK"],
"mittens":["DHb","ByO","ByM","ByN"],
"mix":["ByQ","ByP"],
"mixer":["DHc"],
"mixture":["DsO"],
"mobile":["DsP"],
"mobile game":["DHd"],
"mobile phone":["ByR","ByS","ByT"],
"model":["Djm","DHg","DHe","ByV","ByU"],
"model clothes":["Djm"],
"model modeled":["Djm"],
"model plane":["DHf"],
"modeling":["Djm"],
"modeling clothes":["Djm"],
"modern":["ByX","ByW"],
"moisture":["Bya","ByY","ByZ"],
"mole":["Byd","Byb","Byc"],
"mollusca":["DHh"],
"molten":["Byh","Bye","Byf","Byg"],
"mom":["Byj","Byi"],
"mona lisa":["Byn"],
"Monaco":["Bym","Byk","Byl"],
"Monday":["DHk","DHi","DHj"],
"money":["DHl","Byp","Byo"],
"Mongolia flag":["DHm"],
"monitor":["Byt","Byq","Byr","Bys"],
"monkey":["DHn","Byw","Byu","Byv"],
"monkeys":["Byx"],
"monster":["DsQ"],
"monument":["By0","Byy","Byz"],
"moon":["By9","By1","By2","By3","By4"],
"moon cake":["DsR"],
"mooncake":["By8","By5","By6","By7"],
"moose":["DsS"],
"mop":["Djn","DHp","BzI","BzA","BzB","BzC"],
"mop mopped":["Djn"],
"mop the floor":["Djn","BzJ"],
"moped":["DHo","BzH","BzD","BzE","BzF","BzG"],
"mopping":["Djn"],
"mopping the floor":["Djn"],
"more beautiful":["DHq","DHr"],
"more boring":["DHs"],
"more casual":["DHt"],
"more colorful":["DHu","DHv"],
"more dangerous":["DHw"],
"more difficult":["DHx"],
"more exciting":["DHy"],
"more expensive":["DHz","DH0"],
"more formal":["DH1"],
"morning":["DYR","BzM"],
"morning glory":["BzK","BzL"],
"Morocco":["BzP","BzN","BzO"],
"mortgage":["BzQ"],
"mosque":["BzR"],
"mosquito":["BzV","BzS","BzT","BzU"],
"motel":["BzY","BzW","BzX"],
"moth":["Bzd","BzZ","Bza"],
"mother":["DZa","Bzc","Bzb"],
"mother-in-law":["DZZ"],
"motorbike":["DH2","Bzi","Bze","Bzf","Bzg","Bzh"],
"motorboat":["Bzm","Bzj","Bzk","Bzl"],
"motorcycle":["Bzp","Bzn","Bzo"],
"motorhome":["Bzt","Bzq","Bzr","Bzs"],
"mountain":["DH3","B0A","Bzu","Bzv","Bzw","Bzx","Bzy"],
"mountain bike":["Bzz","Bz0","Bz1","Bz2","Bz3"],
"mountain biking":["Bz4","Bz5","Bz6"],
"mountainous":["Bz9","Bz7","Bz8"],
"mountains":["B0D","B0B","B0C"],
"mouse":["DH5","DH4","B0I","B0E","B0F","B0G","B0H"],
"mousetrap":["B0K","B0J"],
"moustache":["DH6","B0M","B0L"],
"mouth":["DH7","B0Q","B0N","B0O","B0P"],
"move":["Djo","Djp","Djq","B0R"],
"move a chair":["Djo"],
"move moved":["Djo","Djp","Djq"],
"move the mouse":["Djp"],
"move the sofa":["Djq"],
"movie":["B0T","B0S"],
"movie theater":["DH8","B0U"],
"movies":["DsT"],
"moving":["Djq","Djo","Djp"],
"moving a chair":["Djo"],
"moving the mouse":["Djp"],
"moving the sofa":["Djq"],
"mp player":["B0V","B0W"],
"mud":["B0b","B0X","B0Y","B0Z","B0a"],
"muffin":["DH9","B0h","B0c","B0d","B0e","B0f","B0g"],
"muffins":["DsU"],
"mug":["DIA","B0n","B0i","B0j","B0k","B0l","B0m"],
"mule":["B0p","B0o"],
"multiply":["B0q"],
"mum":["B0s","B0r"],
"mummy":["DsV"],
"muscle":["B0u","B0t"],
"muscles":["DsW"],
"muscular":["B0w","B0v"],
"museum":["B0z","B0x","B0y"],
"mushroom":["B04","B00","B01","B02","B03"],
"mushrooms":["DIB","B08","B05","B06","B07"],
"music":["DIE","B1I","B09","B1A","B1B","B1C","B1D"],
"music room":["DsY"],
"musical":["DsX"],
"musician":["DID","DIC","B1H","B1E","B1F","B1G"],
"musketeer":["B1J"],
"musketeers":["B1K"],
"mustard":["DIF","B1O","B1L","B1M","B1N"],
"mute":["B1Q","B1P"],
"my aunt":["DZK"],
"my boyfriend":["DZL"],
"my brother":["DZM"],
"my cousin":["DZN"],
"my cousins":["DZO"],
"my daughter":["DZQ"],
"my daughter-in-law":["DZP"],
"my family":["DZR"],
"my father":["DZT"],
"my father-in-law":["DZS"],
"my granddaughter":["DZU"],
"my grandfather":["DZV"],
"my grandmother":["DZW"],
"my grandson":["DZX"],
"my husband":["DZY"],
"my mother":["DZa"],
"my mother-in-law":["DZZ"],
"my nephew":["DZb"],
"my niece":["DZc"],
"my parents":["DZd"],
"my sister":["DZe"],
"my son":["DZg"],
"my son-in-law":["DZf"],
"my twin sister":["DZh"],
"my uncle":["DZi"],
"my wife":["DZj"],
"Myanmar":["B1U","B1R","B1S"],
"Myanmar flag":["B1T"],
"mysterious":["B1W","B1V"],
"n":["DaC","DaB"],
"nail":["DIH","B1Z","B1X"],
"nail clippers":["DIG","B1Y"],
"nail polish":["B1a","B1b","B1c","B1d"],
"nails":["B1g","B1e","B1f"],
"nanny":["DIJ","DII","B1h"],
"nap":["B1n","B1i","B1j"],
"napkin":["B1m","B1k","B1l"],
"napkins":["DsZ"],
"narrow":["B1o"],
"nationality":["Dsa"],
"natural":["B1r","B1p","B1q"],
"nature":["B1u","B1s","B1t"],
"naughty":["B1v"],
"navigate":["B1x","B1w"],
"neat":["B1y"],
"neck":["DIM","B15","B1z","B10"],
"necklace":["DIL","DIK","B14","B11","B12","B13"],
"necktie":["B17","B16"],
"nectarine":["B2A","B18","B19"],
"needle":["DIO","B2D","B2B","B2C"],
"needle and thread":["DIN"],
"neighbor":["Dsb"],
"neighborhood":["B2G","B2E","B2F"],
"neighbour":["Dsc"],
"neon sign":["B2H","B2I","B2J"],
"nephew":["DZb"],
"neptune":["B2K"],
"nervous":["DIP"],
"nest":["B2O","B2L","B2M","B2N"],
"net":["B2S","B2P","B2Q","B2R"],
"Netherlands flag":["DIQ"],
"new year party":["B2b"],
"New York":["Dsf"],
"New zealand":["B2c","B2d","B2e","B2f"],
"newer":["DIR"],
"news":["Dse"],
"news reporter":["B2W","B2X"],
"newsagents":["Dsd"],
"newspaper":["DIS","B2V","B2T","B2U"],
"newt":["B2a","B2Y","B2Z"],
"next":["Dsg"],
"next to":["DdT","DdU","DdV"],
"niece":["DZc"],
"Nigeria":["B2i","B2g","B2h"],
"Nigeria flag":["DIT"],
"night":["B2p","B2j","B2k"],
"night market":["B2n","B2o"],
"nightmare":["B2m","B2l"],
"nine":["DbY","DbW"],
"nine hundred":["DbX"],
"nine o'clock":["DeJ"],
"nine thousand":["Dbb"],
"nineteen":["Dba","DbZ"],
"ninety":["Dbi","Dbc"],
"ninety eight":["Dbd"],
"ninety five":["Dbe"],
"ninety four":["Dbf"],
"ninety nine":["Dbg"],
"ninety one":["Dbh"],
"ninety seven":["Dbj"],
"ninety six":["Dbk"],
"ninety thousand":["Dbl"],
"ninety three":["Dbm"],
"ninety two":["Dbn"],
"no entry":["B2q"],
"no parking":["Dsi"],
"noisier":["DIU"],
"noisy":["B2r"],
"noodle soup":["B2w","B2x","B2y","B2z"],
"noodles":["DIV","B20","B2s","B2t","B2u","B2v"],
"noon":["Dsh"],
"North america":["B21"],
"northern lights":["B22","B23"],
"Norway":["B28","B24","B25","B26","B27"],
"nose":["DIX","B3A","B29"],
"nose bleed":["DIW"],
"note":["B3E"],
"notebook":["B3D","B3B","B3C"],
"notepad":["DIY"],
"notes":["B3G","B3F"],
"nothing":["Dsj"],
"notice":["Dsk"],
"novel":["B3K","B3H","B3I","B3J"],
"November":["Dsl"],
"now":["Dsm"],
"nuclear engineer":["DIZ","DIa"],
"nuggets":["B3M","B3L"],
"numbers":["B3P","B3N","B3O"],
"nurse":["DIc","DIb","B3S","B3Q","B3R"],
"nut":["B3T"],
"nuts":["DId","B3X","B3U","B3V","B3W"],
"o":["DaE","DaD"],
"oar":["B3Z","B3Y"],
"oasis":["B3c","B3a","B3b"],
"oats":["B3g","B3d","B3e","B3f"],
"obedient":["B3h"],
"obelisk":["B3k","B3i","B3j"],
"oboe":["B3n","B3l","B3m"],
"observation":["B3p","B3o"],
"observatory":["B3q"],
"observe":["B3s","B3r"],
"obsidian":["B3v","B3t","B3u"],
"obstacle":["B3y","B3w","B3x"],
"ocean":["B31","B3z","B30"],
"octagon":["B33","B32"],
"October":["Dsn"],
"octopus":["DIe","B39","B34","B35","B36","B37","B38"],
"odd":["Dso"],
"offer":["B4B","B4A"],
"office":["DIf","B4H","B4C","B4D","B4E","B4F","B4G"],
"office worker":["DIg","DIh","B4I","B4J"],
"office workers":["B4K"],
"often":["DYS"],
"oil":["B4P","B4L","B4M","B4N","B4O"],
"oil rig":["B4Q","B4R","B4S","B4T"],
"oil tanker":["B4U"],
"oil well":["B4V"],
"ok":["Dsp"],
"okay":["B4W"],
"old":["DIm","DIi","DIj","B4j","B4X","B4Y","B4Z","B4a"],
"old city":["B4b"],
"old fashioned":["B4c","B4d","B4e","B4f"],
"old man":["B4g","B4h","B4i"],
"old woman":["B4k","B4l"],
"older":["DIl","DIk"],
"olive":["DIn","B4p","B4m"],
"olive oil":["B4n","B4o"],
"olives":["DIo","B4t","B4q","B4r","B4s"],
"olympic":["B4v","B4u"],
"olympics":["B4x","B4w"],
"omelette":["B40","B4y","B4z"],
"on":["DdY","DdW","DdX"],
"on fire":["DIp"],
"on the left":["DdZ","Dda","Ddb"],
"on the right":["Ddc","Ddd","Dde"],
"on top":["DYU"],
"one":["Dbs","Dbo"],
"one hundred":["Dbp"],
"one hundred thousand":["Dbq"],
"one million":["Dbr"],
"one thousand":["Dbt"],
"onion":["DIq","B45","B41","B42","B43","B44"],
"onions":["DIr","B49","B46","B47","B48"],
"online":["B5D"],
"online class":["B5A","B5B","B5C"],
"only":["DYT"],
"opal":["B5E"],
"open":["Djr","Djs","Djt","Dju","Djv","DIs","DYX"],
"open a bottle":["Djr"],
"open a window":["Djs"],
"open minded":["DYW"],
"open opened":["Djr","Djs","Djt","Dju","Djv"],
"open the book":["Dsq"],
"open the door":["Djt"],
"open the store":["Dju"],
"open the window":["Djv"],
"open window":["DYY"],
"open your book":["Dsr"],
"opening":["Djv","Djr","Djs","Djt","Dju"],
"opening a bottle":["Djr"],
"opening a window":["Djs"],
"opening presents":["DYV"],
"opening the door":["Djt"],
"opening the store":["Dju"],
"opening the window":["Djv"],
"opera":["DYZ","B5F"],
"oppose":["DYa","B5G"],
"opposite":["B5J","B5H","B5I"],
"opposition":["DYb"],
"optician":["DIu","DIt","B5M","B5K","B5L"],
"optics":["DYc"],
"optometrist":["B5P","B5N","B5O"],
"orange":["DIz","DIv","B5X","B5Q","B5R"],
"orange hats":["DIw"],
"orange juice":["DIx","DIy","B5S","B5T","B5U","B5V","B5W"],
"orange shirt":["DI0"],
"oranges":["DI1","B5Z","B5Y"],
"orbit":["DYd"],
"orchard":["B5e","B5a","B5b","B5c","B5d"],
"orchid":["B5g","B5f"],
"order":["Djw","Djx","B5i","B5h"],
"order a pizza":["Djw"],
"order food":["Djx"],
"order ordered":["Djw","Djx"],
"ordering":["Djx","Djw"],
"ordering a pizza":["Djw"],
"ordering food":["Djx"],
"ornaments":["Dss"],
"ostrich":["B5m","B5j","B5k","B5l"],
"otter":["B5p","B5n","B5o"],
"outlet":["B5q"],
"outside":["B5r"],
"outskirts":["B5s"],
"outstanding":["B5t"],
"oval":["B5x","B5u","B5v","B5w"],
"oven":["B51","B5y","B5z","B50"],
"overcast":["DI2","B55","B52","B53","B54"],
"overpopulation":["B57","B56"],
"oversleep":["B58"],
"overtake":["B59"],
"overweight":["B6C","B6A","B6B"],
"owl":["DI3","B6H","B6D","B6E","B6F","B6G"],
"owner":["B6J","B6I"],
"ox":["B6M","B6K","B6L"],
"oyster":["B6P","B6N","B6O"],
"ozone layer":["B6Q","B6R"],
"p":["DaG","DaF"],
"pack":["Djy"],
"pack a bag":["Djy"],
"pack packed":["Djy"],
"package":["B6W","B6S","B6T","B6U","B6V"],
"packaging":["B6X"],
"packing":["Djy"],
"packing a bag":["Djy"],
"pad":["B6c","B6Y"],
"paddle":["B6b","B6Z","B6a"],
"paddles":["DI4"],
"padlock":["DI5"],
"page":["B6d"],
"pagoda":["Dst"],
"paid":["Dsu"],
"pail":["B6f","B6e"],
"pain":["B6i","B6g","B6h"],
"paint":["Dj2","Djz","Dj0","Dj1","Dj3","B62","B6j","B6k","B6l"],
"paint a picture":["Djz","Dj0","Dj1","B6m","B6n"],
"paint brush":["Dsv"],
"paint painted":["Djz","Dj0","Dj1","Dj2","Dj3"],
"paint pictures":["Dsw"],
"paint roller":["B63","B64","B65"],
"paint the wall":["Dj3"],
"paintbrush":["DI6","B6s","B6o","B6p","B6q","B6r"],
"painter":["B6v","B6t","B6u"],
"painting":["Dj2","Djz","Dj0","Dj1","Dj3","B60","B6w","B6x"],
"painting a picture":["Djz","Dj0","Dj1","B6y","B6z"],
"painting the wall":["Dj3"],
"paintings":["B61"],
"paints":["B67","B66"],
"pajamas":["B68"],
"Pakistan flag":["DI7"],
"palace":["B7E","B69","B7A","B7B","B7C","B7D"],
"pale":["B7H","B7F","B7G"],
"palm tree":["B7I","B7J","B7K"],
"pan":["B7e","B7L","B7M"],
"Panama":["B7Q","B7N","B7O","B7P"],
"pancake":["B7S","B7R"],
"pancakes":["DI8","B7W","B7T","B7U","B7V"],
"pancreas":["B7X"],
"panda":["DI9","B7b","B7Y","B7Z","B7a"],
"pandas":["B7c"],
"pangolin":["B7d"],
"panini":["DJA"],
"pants":["DJC","DJB","B7j","B7f","B7g","B7h","B7i"],
"papaya":["B7o","B7k","B7l","B7m","B7n"],
"papaya salad":["B7p","B7q"],
"paper":["DJE","B70","B7r"],
"paper clip":["B7u","B7v","B7w"],
"paper clips":["DJD","B7x","B7y","B7z"],
"paper towel":["B71","B72"],
"paper towels":["DJF","B73"],
"paperbag":["B7t","B7s"],
"parachute":["B75","B74"],
"parade":["B76"],
"paradise":["B78","B77"],
"paragraph":["B79"],
"parallel":["B8A"],
"paramedic":["DJH","DJG","B8C","B8B"],
"parasol":["B8F","B8D","B8E"],
"parcel":["B8G"],
"parent":["B8H"],
"parents":["DZd","B8J","B8I"],
"Paris":["Dsx"],
"park":["DJI","B8S","B8K","B8L","B8M"],
"parking garage":["B8N","B8O","B8P"],
"parking lot":["B8Q","B8R"],
"parrot":["DJJ","B8W","B8T","B8U","B8V"],
"partly cloudy":["Dsy"],
"partner":["Dsz"],
"party":["B8Y","B8X"],
"party hat":["Ds0"],
"pass":["Dj4"],
"pass a test":["Dj4"],
"pass passed":["Dj4"],
"passenger":["B8a","B8Z"],
"passengers":["B8c","B8b"],
"passing":["Dj4"],
"passing a test":["Dj4"],
"passion fruit":["B8d","B8e","B8f","B8g"],
"passport":["B8j","B8h","B8i"],
"password":["Ds1"],
"pasta":["DJK","B8n","B8k","B8l","B8m"],
"pastries":["B8q","B8o","B8p"],
"pastry":["B8s","B8r"],
"pasture":["B8w","B8t","B8u","B8v"],
"pat":["B84"],
"path":["B8z","B8x","B8y"],
"patient":["B83","B80","B81","B82"],
"patriot":["B88","B85","B86","B87"],
"pattern":["B9B","B89","B9A"],
"pavement":["B9F","B9C","B9D","B9E"],
"paw":["B9J","B9G","B9H","B9I"],
"paws":["B9L","B9K"],
"pay":["Dj6","Dj5","B9P","B9M","B9N","B9O"],
"pay attention":["Ds2"],
"pay money":["Dj5"],
"pay paid":["Dj5","Dj6"],
"paying":["Dj6","Dj5"],
"paying money":["Dj5"],
"pc":["B9Q"],
"pea":["B9o"],
"peace":["B9V","B9R","B9S"],
"peaceful":["B9U","B9T"],
"peach":["DJN","DJL","B9c","B9W"],
"peach blossom":["B9X"],
"peaches":["DJM","B9b","B9Y","B9Z","B9a"],
"peacock":["DJO","B9f","B9d","B9e"],
"peanut":["B9n","B9g"],
"peanut butter":["DJP","B9h","B9i","B9j","B9k","B9l","B9m"],
"peanuts":["Ds3"],
"pear":["DJQ","B9v","B9p","B9q","B9r"],
"pearl":["B9s"],
"pearls":["B9u","B9t"],
"pears":["DJR","B9y","B9w","B9x"],
"peas":["DJT","DJS","B91","B9z","B90"],
"pebbles":["B95","B92","B93","B94"],
"pedal":["B96"],
"pedals":["B98","B97"],
"peddler":["B99"],
"pedestal":["CAB","CAA"],
"pedestrian":["CAH","CAC"],
"pedestrian crossing":["CAD","CAE","CAF","CAG"],
"pedestrians":["CAJ","CAI"],
"peel":["Dj7","CAN","CAK","CAL","CAM"],
"peel a banana":["Dj7"],
"peel peeled":["Dj7"],
"peeler":["DJU"],
"peeling":["Dj7"],
"peeling a banana":["Dj7"],
"peg":["DJV","CAQ","CAO","CAP"],
"pegs":["CAR"],
"pelican":["CAU","CAS","CAT"],
"pen":["DJa","DJW","CAv","CAV","CAW","CAX"],
"pencil":["DJY","CAd","CAY","CAZ","CAa"],
"pencil box":["CAb"],
"pencil case":["DJX","CAc"],
"pencil sharpener":["CAg","CAh","CAi"],
"pencils":["CAj","CAe","CAf"],
"pendant":["CAm","CAk","CAl"],
"penguin":["DJZ","CAp","CAn","CAo"],
"penguins":["CAr","CAq"],
"peninsula":["CAu","CAs","CAt"],
"pens":["CAy","CAw","CAx"],
"pentagon":["CAz"],
"people":["CA0"],
"pepper":["CA9","CA1","CA2","CA3","CA4"],
"peppermint":["CA7","CA5","CA6"],
"pepperoni":["CA8"],
"peppers":["CBD","CBA","CBB","CBC"],
"perfect":["CBE"],
"perform":["CBJ","CBF"],
"performance":["CBI","CBG","CBH"],
"perfume":["CBM","CBK","CBL"],
"personal trainer":["DJb","DJc"],
"Peru":["CBQ","CBN","CBO","CBP"],
"pet":["CBY","CBR","CBS","CBT"],
"pet food":["DJd","CBU","CBV","CBW","CBX"],
"pet store":["DJe"],
"petrol":["CBc","CBZ","CBa","CBb"],
"petrol station":["CBd","CBe","CBf"],
"pets":["CBh","CBg"],
"pharmacist":["DJg","DJf","CBk","CBi","CBj"],
"pharmacy":["DJh","CBl"],
"Philippines":["CBp","CBm","CBn","CBo"],
"Philippines flag":["DJi"],
"phone":["DJl","DJj","CBt","CBq","CBr","CBs"],
"phone charger":["DJk"],
"photo":["CB2"],
"photo album":["CBu"],
"photocopier":["CBx","CBv","CBw"],
"photographer":["DJn","DJm","CB0","CBy","CBz"],
"photography":["CB1"],
"phrase":["CB3"],
"physical education":["DJo"],
"physical therapy":["CB4"],
"physics":["DJp","CB6","CB5"],
"physiotherapy":["CB7"],
"piano":["DJq","CCC","CB8","CB9","CCA","CCB"],
"pick":["Dj8","Dj9","CCE","CCD"],
"pick apples":["Dj8"],
"pick flowers":["Dj9"],
"pick picked":["Dj8","Dj9"],
"pick up":["DkA"],
"pick up picked up":["DkA"],
"picking":["Dj9","Dj8"],
"picking apples":["Dj8"],
"picking flowers":["Dj9"],
"picking up":["DkA"],
"picnic":["CCI","CCF","CCG","CCH"],
"picture":["DJr","CCL","CCJ","CCK"],
"pictures":["CCM"],
"picturesque":["CCP","CCN","CCO"],
"pie":["DJt","DJs","CCZ","CCQ","CCR","CCS"],
"piece":["CCY"],
"piece of cake":["CCT","CCU","CCV","CCW","CCX"],
"pier":["CCd","CCa","CCb","CCc"],
"pig":["DJu","CCr","CCe","CCf","CCg","CCh"],
"pig pen":["CCq"],
"pigeon":["CCl","CCi","CCj","CCk"],
"piglet":["CCp","CCm","CCn","CCo"],
"pile":["CCu","CCs","CCt"],
"pill":["CC4","CCv","CCw"],
"pillow":["DJv","CCz","CCx","CCy"],
"pillows":["CC3","CC0","CC1","CC2"],
"pills":["CC7","CC5","CC6"],
"pilot":["DJx","DJw","CDB","CC8","CC9","CDA"],
"pin":["CDS","CDC"],
"pinball":["CDD"],
"pine":["CDM"],
"pineapple":["DJy","CDJ","CDE","CDF","CDG"],
"pineapple juice":["CDH","CDI"],
"pineapples":["CDL","CDK"],
"pinecone":["Ds4"],
"ping pong":["CDN","CDO","CDP","CDQ"],
"pink":["DJz"],
"pink tshirt":["DJ0"],
"pinocchio":["CDR"],
"pins":["DJ1"],
"pipe":["Ds5"],
"piranha":["CDT"],
"pirate":["CDW","CDU","CDV"],
"pirate ship":["CDX","CDY"],
"pitch":["Ds6"],
"pitcher":["CDa","CDZ"],
"pizza":["DJ3","DJ2","CDg","CDb","CDc","CDd","CDe","CDf"],
"plaid":["CDh"],
"plain":["CDi"],
"plane":["DJ4","CDo","CDj","CDk","CDl","CDm","CDn"],
"planet":["DJ5","CDp"],
"planets":["CDs","CDq","CDr"],
"plant":["DkB","DJ6","CDy","CDt","CDu","CDv","CDw","CDx"],
"plant a tree":["DkB"],
"plant planted":["DkB"],
"planting":["DkB"],
"planting a tree":["DkB"],
"plants":["CD1","CDz","CD0"],
"plastic":["CD7","CD2","CD3"],
"plastic bag":["CD4","CD5","CD6"],
"plastic straw":["CD8","CD9","CEA"],
"plate":["DJ7","CED","CEB","CEC"],
"plates":["CEF","CEE"],
"platform":["CEH","CEG"],
"platypus":["Ds7"],
"play":["DkC","DkD","DkE","DkF","DkG","DkH","DkI","DkJ","DkK","DkL","DkM","DkN","DkP","DkQ","DkR","DkS","DkT"],
"play a boardgame":["DkC"],
"play a game":["DkD"],
"play a guitar":["DkE"],
"play a video game":["DkF"],
"play basketball":["DkG"],
"play cards":["DkH","DkI"],
"play cards played cards":["DkH"],
"play chess":["DkJ"],
"play football":["DkK"],
"play hockey":["Ds8"],
"play music":["DkL"],
"play on a swing":["DkM"],
"play played":["DkT","DkC","DkD","DkE","DkF","DkG","DkI","DkJ","DkK","DkL","DkN"],
"play pool":["DkN"],
"play saxophone":["DkO"],
"play soccer":["DkP"],
"play tennis":["DkQ"],
"play the drums":["Ds9"],
"play the guitar":["DkR"],
"play the piano":["DtA"],
"play the trumpet":["DkS"],
"play video games":["DkT"],
"play with friend":["DtB"],
"play with friends":["DtC"],
"playful":["CEJ","CEI"],
"playground":["DJ8","CEL","CEK"],
"playing":["DkT","DkC","DkD","DkE","DkF","DkG","DkH","DkI","DkJ","DkK","DkL","DkM","DkN","DkP","DkQ","DkR","DkS"],
"playing a boardgame":["DkC"],
"playing a game":["DkD"],
"playing a guitar":["DkE"],
"playing a video game":["DkF"],
"playing basketball":["DkG"],
"playing cards":["DkH","DkI"],
"playing chess":["DkJ"],
"playing football":["DkK"],
"playing music":["DkL"],
"playing on a swing":["DkM"],
"playing pool":["DkN"],
"playing saxophone":["DkO"],
"playing soccer":["DkP"],
"playing tennis":["DkQ"],
"playing the guitar":["DkR"],
"playing the trumpet":["DkS"],
"playing video games":["DkT"],
"pleasant":["CEM"],
"please":["DtD"],
"pliers":["CEP","CEN","CEO"],
"plough":["CEV","CEQ","CER","CES","CET","CEU"],
"plug":["DKB","DJ9","CEa","CEW","CEX","CEY"],
"plug hole":["DKA"],
"plug in":["Dkh","DkU","CEZ"],
"plug in a laptop":["DkU"],
"plug in plugged in":["Dkh"],
"plug plugged":["DkU"],
"plugging in":["Dkh","DkU"],
"plugging in a laptop":["DkU"],
"plum":["DKE","CEh","CEb","CEc"],
"plumber":["DKD","DKC","CEf","CEd","CEe"],
"plump":["CEi","CEg"],
"plums":["DKF","CEm","CEj","CEk","CEl"],
"plunger":["CEo","CEn"],
"plus":["CEq","CEp"],
"pluto":["CEr"],
"poached egg":["CEs"],
"poached eggs":["CEt"],
"pocket":["CEw","CEu","CEv"],
"poem":["CEz","CEx","CEy"],
"poet":["CE0"],
"point":["DkW","CE2","CE1"],
"point at":["DkV"],
"point at a clock":["DkV"],
"point at the tv":["DkW"],
"point pointed":["DkV","DkW"],
"pointing":["DkW"],
"pointing at":["DkV"],
"pointing at a clock":["DkV"],
"pointing at the tv":["DkW"],
"poison":["DtE"],
"poisonous":["CE5","CE3","CE4"],
"Poland":["CE9","CE6","CE7","CE8"],
"Poland flag":["DKG"],
"polar bear":["CFA","CFB","CFC"],
"pole":["DtF"],
"police":["CFK"],
"police car":["CFD","CFE","CFF"],
"police officer":["DKH","DKI","CFG","CFH","CFI","CFJ"],
"police station":["CFL"],
"policewoman":["DtG"],
"polish":["CFM"],
"politician":["DKK","DKJ","CFN"],
"polka dot":["CFO"],
"pollute":["CFS","CFP","CFQ"],
"polluted":["CFR"],
"pollution":["CFV","CFT","CFU"],
"polo shirt":["DKL"],
"pomegranate":["CFa","CFW","CFX","CFY","CFZ"],
"pomelo":["CFd","CFb","CFc"],
"pond":["CFj","CFe","CFf","CFg","CFh","CFi"],
"pony":["CFo","CFk","CFl","CFm","CFn"],
"ponytail":["CFq","CFp"],
"ponytails":["CFr","CFs"],
"pool":["DKN","DKM","CFw","CFt","CFu","CFv"],
"poor":["CFx"],
"pop music":["CF2"],
"pop star":["CF9"],
"popcorn":["DKO","CF1","CFy","CFz","CF0"],
"poppy":["CF6","CF3","CF4","CF5"],
"popsicle":["CF8","CF7"],
"population":["CGB","CGA"],
"porch":["CGE","CGC","CGD"],
"porcupine":["CGH","CGF","CGG"],
"pork":["DKQ","CGM","CGI","CGJ","CGK"],
"pork belly":["CGL"],
"pork chop":["DKP"],
"porridge":["CGQ","CGN","CGO","CGP"],
"port":["CGV","CGR","CGS","CGT","CGU"],
"portrait":["DtH"],
"Portugal":["CGZ","CGW","CGX","CGY"],
"Portugual flag":["DKR"],
"positive":["CGb","CGa"],
"post office":["DKS"],
"postcard":["CGe","CGc","CGd"],
"poster":["CGi","CGf","CGg","CGh"],
"postman":["CGj"],
"pot":["CG0","CGk","CGl","CGm"],
"potato":["CGy","CGn","CGo","CGp"],
"potato chips":["DKT","CGq","CGr","CGs","CGt"],
"potatoes":["DKU","CGx","CGu","CGv","CGw"],
"potion":["CGz"],
"potted plant":["CG1","CG2"],
"pottery":["DtI"],
"poultry":["CG4","CG3"],
"pour":["DkY","DkX","CG8","CG5","CG6","CG7"],
"pour coffee":["DkX"],
"pour poured":["DkX","DkY"],
"pouring":["DkY","DkX"],
"pouring coffee":["DkX"],
"poverty":["CG9"],
"power":["CHD"],
"power socket":["CHE"],
"powerful":["CHC","CHA","CHB"],
"practice the piano":["DtJ"],
"prawn":["CHH","CHF","CHG"],
"prawns":["CHL","CHI","CHJ","CHK"],
"pray":["CHP","CHM","CHN","CHO"],
"predator":["CHT","CHQ","CHR","CHS"],
"preparation":["CHU"],
"prepare":["DtK"],
"present":["DkZ","CHZ","CHV","CHW"],
"present presented":["DkZ"],
"presenter":["CHY","CHX"],
"presenting":["DkZ"],
"presents":["CHd","CHa","CHb","CHc"],
"preserve":["CHf","CHe"],
"president":["CHg"],
"press":["Dka","Dkb","CHh"],
"press a button":["Dka"],
"press pressed":["Dka","Dkb"],
"press the button":["Dkb"],
"pressing":["Dkb","Dka"],
"pressing a button":["Dka"],
"pressing the button":["Dkb"],
"pretty":["CHi"],
"pretzel":["DKV","CHn","CHj","CHk","CHl","CHm"],
"prey":["CHq","CHo","CHp"],
"price":["CHs","CHr"],
"prickly":["DtL"],
"priest":["DtM"],
"primitive":["CHu","CHt"],
"prince":["CHv"],
"princess":["CHx","CHw"],
"principal":["CHz","CHy"],
"principal's office":["CH0"],
"print":["Dkc","CH5","CH1"],
"print printed":["Dkc"],
"printer":["DKW","CH4","CH2","CH3"],
"printing":["Dkc"],
"prison":["DtN"],
"prize":["CH8","CH6","CH7"],
"problem":["DtO"],
"product":["DtP"],
"professional":["CIA","CH9"],
"professor":["CIC","CIB"],
"profitable":["CID"],
"program":["DtQ"],
"programmer":["CIE"],
"progress":["CIF"],
"projector":["CII","CIG","CIH"],
"promise":["CIJ"],
"protect":["CIK"],
"proud":["DKX","CIL"],
"prune":["CIM"],
"pub":["CIR","CIN","CIO"],
"public restroom":["CIP"],
"public transport":["CIQ"],
"pudding":["CIT","CIS"],
"puddle":["DtR"],
"pull":["Dkd"],
"pull a rope":["Dkd"],
"pull pulled":["Dkd"],
"pull ups":["CIU"],
"pulling":["Dkd"],
"pulling a rope":["Dkd"],
"pump":["Dke","CId","CIV"],
"pump gas":["Dke"],
"pump pumped":["Dke"],
"pumping":["Dke"],
"pumping gas":["Dke"],
"pumpkin":["DKY","CIc","CIW","CIX","CIY","CIZ"],
"pumpkin pie":["CIa","CIb"],
"punch":["Dkf","CIe"],
"punch a monster":["Dkf"],
"punch punched":["Dkf"],
"punching":["Dkf"],
"punching a monster":["Dkf"],
"pup":["CIn"],
"pupil":["CIh","CIf","CIg"],
"puppet":["CIk","CIi"],
"puppeteer":["CIj"],
"puppies":["CIm","CIl"],
"puppy":["CIr","CIo","CIp","CIq"],
"purple":["DKZ"],
"purple socks":["DKa"],
"purse":["DKb","CIw","CIs","CIt","CIu","CIv"],
"push":["Dkg","CIx"],
"push a car":["Dkg"],
"push pushed":["Dkg"],
"push ups":["CIy","CIz"],
"pushing":["Dkg"],
"pushing a car":["Dkg"],
"put":["Dki","Dkk","Dkl","Dkm"],
"put a bottle in the bin":["Dki"],
"put away":["Dkj"],
"put away put away":["Dkj"],
"put books in a bag":["Dkk"],
"put food in a microwave":["Dkl"],
"put ketchup on a burger":["Dkm"],
"put on":["Dko","Dkn","Dkp"],
"put on a coat":["Dkn"],
"put on put on":["Dko"],
"put on shoes":["Dkp"],
"put out":["Dkr","Dkq"],
"put out a fire":["Dkq"],
"put out put out":["Dkr"],
"put put":["Dkl","Dki","Dkk","Dkm"],
"put up":["Dks"],
"put up put up":["Dks"],
"putting":["Dki","Dkk","Dkl","Dkm"],
"putting a bottle in the bin":["Dki"],
"putting away":["Dkj"],
"putting books in a bag":["Dkk"],
"putting food in a microwave":["Dkl"],
"putting ketchup on a burger":["Dkm"],
"putting on":["Dko","Dkn","Dkp"],
"putting on a coat":["Dkn"],
"putting on shoes":["Dkp"],
"putting out":["Dkr","Dkq"],
"putting out a fire":["Dkq"],
"putting up":["Dks"],
"puzzle":["CI0"],
"puzzles":["DtS"],
"pyjamas":["CI1"],
"pyramid":["CI5","CI2","CI3","CI4"],
"python":["CI6"],
"q":["DaI","DaH"],
"q tips":["CI7"],
"quail":["CJA","CI8","CI9"],
"quarter past 1":["DeL"],
"quarter past 10":["DeM"],
"quarter past 11":["DeK"],
"quarter past 2":["DeN"],
"quarter past eleven":["DeK"],
"quarter past one":["DeL"],
"quarter past ten":["DeM"],
"quarter past two":["DeN"],
"quarter to 1":["DeR"],
"quarter to 10":["DeS"],
"quarter to 12":["DeT"],
"quarter to 4":["DeQ"],
"quarter to 5":["DeP"],
"quarter to 8":["DeO"],
"quarter to eight":["DeO"],
"quarter to five":["DeP"],
"quarter to four":["DeQ"],
"quarter to one":["DeR"],
"quarter to ten":["DeS"],
"quarter to twelve":["DeT"],
"queen":["CJB"],
"question":["CJD","CJC"],
"queue":["CJE"],
"quick":["CJF"],
"quickly":["DtT"],
"quiet":["DKd","CJG"],
"quieter":["DKc"],
"quilt":["DtU"],
"quit":["CJI","CJH"],
"quiz":["CJJ"],
"r":["DaK","DaJ"],
"rabbit":["DKe","CJO","CJK","CJL","CJM","CJN"],
"rabbits":["DtV"],
"raccoon":["CJS","CJP","CJQ","CJR"],
"race":["CJU","CJT"],
"rack":["CJa","CJV","CJW"],
"racket":["CJZ","CJX","CJY"],
"radiate":["CJd","CJb","CJc"],
"radio":["CJf","CJe"],
"radish":["CJj","CJg","CJh","CJi"],
"rafting":["DtW"],
"rag":["CJk"],
"railroad":["CJn","CJl","CJm"],
"railway":["DtX"],
"railway station":["CJo","CJp"],
"rain":["Dkt","DKj","DKf","CJ6","CJq","CJr","CJs"],
"rain boots":["CJt"],
"rain rained":["Dkt"],
"rainbow":["DKh","DKg","CJx","CJu","CJv","CJw"],
"raincoat":["DKi","CJz","CJy"],
"rainforest":["CJ3","CJ0","CJ1","CJ2"],
"raining":["Dkt","CJ5","CJ4"],
"rainy":["CJ8","CJ7"],
"raisin":["CKB","CJ9","CKA"],
"raisins":["CKE","CKC","CKD"],
"rake":["CKI","CKF","CKG","CKH"],
"ram":["CKL","CKJ","CKK"],
"ranch":["CKP","CKM","CKN","CKO"],
"random":["CKQ"],
"ranger":["CKR"],
"rarely":["DtY"],
"rash":["DKk","CKS"],
"raspberries":["CKV","CKT","CKU"],
"raspberry":["CKZ","CKW","CKX"],
"raspberry juice":["CKY"],
"rat":["DKl","CKe","CKa","CKb","CKc","CKd"],
"rattlesnake":["CKf"],
"ray":["DtZ"],
"razor":["DKm"],
"reach":["CKi","CKg"],
"reaching":["CKh"],
"react":["CKj"],
"read":["Dkz","Dku","Dkv","Dkw","Dkx","Dky","CKo","CKk","CKl"],
"read a book":["Dku","Dkv","Dkw"],
"read a newspaper":["Dky"],
"read aloud":["Dkx"],
"read aloud read aloud":["Dkx"],
"read books":["Dta"],
"read comics":["Dtb"],
"read read":["Dky","Dku","Dkv","Dkw","Dkz"],
"reading":["Dkz","Dku","Dkv","Dkw","Dkx","Dky","CKn","CKm"],
"reading a book":["Dku","Dkv","Dkw"],
"reading a newspaper":["Dky"],
"reading aloud":["Dkx"],
"reading books":["Dtc"],
"ready":["CKp"],
"real estate agent":["DKn","DKo"],
"realize":["CKq"],
"receipt":["CKs","CKr"],
"receive":["Dk0","Dk1","CKt"],
"receive a package":["Dk1"],
"receive an email":["Dk0"],
"receive received":["Dk0","Dk1"],
"receiving":["Dk1","Dk0"],
"receiving a package":["Dk1"],
"receiving an email":["Dk0"],
"reception":["CKz","CKu"],
"reception desk":["CKv","CKw"],
"receptionish":["DKq","DKp"],
"receptionist":["CKy","CKx"],
"recipie":["DYe"],
"recliner":["DKr"],
"recommend":["DYf"],
"record":["Dtd"],
"recorder":["CK0"],
"rectangle":["CK1"],
"rectangular":["CK2"],
"recycle":["CK5","CK3","CK4"],
"recycling":["CK9"],
"recycling bank":["CK6"],
"recycling bin":["CK7","CK8"],
"red":["DKy"],
"red and blue":["DKs"],
"red and green":["DKt"],
"red and white":["DKu"],
"red and yellow":["DKv"],
"red apple":["CLA"],
"red glasses":["DKw"],
"red hair":["CLB","CLC","CLD","CLE"],
"red jacket":["DKx"],
"red pepper":["CLF","CLG","CLH"],
"red socks":["DKz"],
"reel":["CLI"],
"referee":["DK1","DK0","CLL","CLJ","CLK"],
"reflect":["Dk3","Dk2","CLP","CLM"],
"reflect reflected":["Dk3","Dk2"],
"reflecting":["Dk3","Dk2"],
"reflective vest":["CLN","CLO"],
"refrigerator":["CLS","CLQ","CLR"],
"refuse":["Dk4","CLU","CLT"],
"refuse money":["Dk4"],
"refuse refused":["Dk4"],
"refusing":["Dk4"],
"refusing money":["Dk4"],
"region":["CLV"],
"regions":["CLW"],
"regret":["CLX"],
"rehearse":["CLY"],
"reindeer":["CLb","CLZ","CLa"],
"relationship":["CLd","CLc"],
"relatives":["CLf","CLe"],
"relax":["Dk6","Dk5","CLp","CLg","CLh"],
"relax relaxed":["Dk6","Dk5"],
"relaxed":["CLk","CLi","CLj"],
"relaxing":["Dk6","Dk5","CLo","CLl","CLm","CLn"],
"religious":["CLq"],
"remote":["DK2","CLx","CLr","CLs"],
"remote control":["CLt","CLu","CLv","CLw"],
"renewable":["CLz","CLy"],
"renminbi":["CL0"],
"repair":["Dk7","Dk8","Dk9","CL2","CL1"],
"repair a phone":["Dk7","Dk8"],
"repair repaired":["Dk7","Dk8","Dk9"],
"repair the AC":["Dk9"],
"repairing":["Dk9","Dk7","Dk8"],
"repairing a phone":["Dk7","Dk8"],
"repairing the AC":["Dk9"],
"repeat":["Dte"],
"reply":["CL3"],
"report":["Dtf"],
"reporter":["DK4","DK3","CL4"],
"reptile":["DK5","CL7","CL5","CL6"],
"rescue":["DlA","DlB","CL9","CL8"],
"rescue rescued":["DlA","DlB"],
"rescue someone":["DlB"],
"rescuing":["DlA","DlB"],
"rescuing someone":["DlB"],
"reservation":["Dtg"],
"resign":["CMB","CMA"],
"respect":["CMC"],
"responsible":["Dth"],
"rest":["DlC","CMI"],
"rest rested":["DlC"],
"restaurant":["DK6","CMG","CMD","CME","CMF"],
"resting":["DlC","CMH"],
"restroom":["CMK","CMJ"],
"resume":["CML"],
"rhino":["DK7","CMP","CMM","CMN","CMO"],
"rhinoceros":["Dti"],
"rhubarb":["CMT","CMQ","CMR","CMS"],
"rib":["CMa"],
"rib cage":["CMY","CMZ"],
"ribbon":["CMX","CMU","CMV","CMW"],
"ribs":["CMe","CMb","CMc","CMd"],
"rice":["DK9","CMk","CMf","CMg","CMh","CMi","CMj"],
"rice and vegetables":["DK8"],
"rice pudding":["CMl"],
"rich":["CMm"],
"rickshaw":["CMq","CMn","CMo","CMp"],
"ride":["DlD","DlE","DlF","DlG","CMw"],
"ride a bicycle":["Dtj"],
"ride a bike":["DlD","CMr","CMs"],
"ride a horse":["DlE","CMt"],
"ride a motorbike":["DlF","CMu"],
"ride a scooter":["DlG"],
"ride a skateboard":["CMv"],
"ride my bike":["Dtk"],
"ride rode":["DlD","DlE","DlF","DlG"],
"riding":["DlD","DlE","DlF","DlG"],
"riding a bike":["DlD"],
"riding a horse":["DlE"],
"riding a motorbike":["DlF"],
"riding a scooter":["DlG","CMx"],
"right":["Dtl"],
"ring":["DlI","DlH","CM2","CMy","CMz","CM0","CM1"],
"ring rang":["DlH","DlI"],
"ringing":["DlI","DlH"],
"rinse":["CM3"],
"riot":["CM6","CM4","CM5"],
"rip":["CNB","CM7"],
"ripe":["CNA","CM8","CM9"],
"riper":["DLA"],
"rise":["DlJ","CNC"],
"rise rose":["DlJ"],
"rising":["DlJ"],
"rival":["CND"],
"river":["DLB","CNK","CNE","CNF","CNG","CNH"],
"river bank":["CNI","CNJ"],
"river rapids":["CNL","CNM","CNN"],
"road":["DLC","CNQ","CNO","CNP"],
"road rage":["CNR"],
"roadworks":["CNS"],
"roar":["CNU","CNT"],
"roast":["CNX"],
"roast beef":["DLD"],
"roast chicken":["CNV","CNW"],
"roast vegetables":["CNY"],
"robe":["Dtm"],
"robin":["CNb","CNZ","CNa"],
"robot":["CNf","CNc","CNd","CNe"],
"rock":["CNu","CNg"],
"rock climbing":["CNh","CNi","CNj","CNk","CNl"],
"rock pool":["CNv"],
"rocket":["DLE","CNq","CNm","CNn","CNo","CNp"],
"rocking horse":["CNr","CNs","CNt"],
"rocks":["CN2","CNw","CNx","CNy","CNz","CN0","CN1"],
"rod":["Dtn"],
"roll":["COP","CN3","CN4"],
"roller blades":["CN5","CN6","CN7"],
"roller blading":["CN8","CN9","COA"],
"roller coaster":["COB","COC","COD","COE","COF","COG","COH"],
"roller skate":["COI"],
"roller skates":["Dtq"],
"roller skating":["COJ"],
"rollerblading":["Dto"],
"rollerblads":["Dtp"],
"rolling pin":["COK","COL","COM","CON","COO"],
"romance":["COV","COQ","COR","COS","COT","COU"],
"Romania":["COZ","COW","COX","COY"],
"romantic":["COd","COa","COb","COc"],
"roof":["COi","COe","COf","COg","COh"],
"room":["COk"],
"roommates":["COj"],
"roomservice":["COl"],
"rooster":["COp","COm","COn","COo"],
"roots":["COt","COq","COr","COs"],
"rope":["COy","COu","COv","COw","COx"],
"rosary":["CO1","COz","CO0"],
"rose":["CO5","CO2","CO3","CO4"],
"roses":["CO8","CO6","CO7"],
"rotate":["CPA","CO9"],
"rough":["Dtr"],
"round":["Dtt","Dts"],
"roundabout":["CPC","CPB"],
"route":["Dtu"],
"row":["DlK"],
"row a boat":["DlK","CPD"],
"row rowed":["DlK"],
"rowing":["DlK"],
"rowing a boat":["DlK"],
"royal":["CPE"],
"rubber":["CPF"],
"rubbish":["CPI","CPG","CPH"],
"rucksack":["DLF"],
"rug":["DLH","CPO","CPJ"],
"rugby":["DLG","CPN","CPK","CPL","CPM"],
"ruler":["DLI","CPR","CPP","CPQ"],
"run":["DlP","DlL","DlM","DlN","CPV","CPS"],
"run a marathon":["DlN"],
"run out":["DlO"],
"run out ran out":["DlO"],
"run ran":["DlL","DlM","DlN","DlP"],
"running":["DlP","DlL","DlM","DlN","DLJ","CPU","CPT"],
"running a marathon":["DlN"],
"running out":["DlO"],
"rural":["CPa","CPW","CPX","CPY"],
"rural area":["CPZ"],
"rush":["CPe"],
"rush hour":["CPb","CPc","CPd"],
"Russia":["DLM","CPi","CPf","CPg","CPh"],
"Russia flag":["DLK"],
"Russian":["DLL"],
"s":["DaM","DaL"],
"sack":["Dtv"],
"sacred":["CPk","CPj"],
"sad":["DLO","CPr","CPl","CPm"],
"sadder":["DLN"],
"saddle":["CPp","CPn","CPo"],
"sadness":["CPq"],
"safari":["DYg"],
"safe":["CPu","CPs","CPt"],
"safer":["DLP"],
"safety":["DYh","CPv"],
"sail":["DlQ","CP5","CPw"],
"sail a boat":["DlQ","CPx"],
"sail sailed":["DlQ"],
"sailboat":["CPy"],
"sailing":["DlQ","DYi","CP1","CPz"],
"sailing a boat":["DlQ"],
"sailing boat":["CP0"],
"sailor":["DLR","DLQ","CP4","CP2","CP3"],
"saint":["CP7","CP6"],
"salad":["DLS","CQC","CP8","CP9","CQA","CQB"],
"salami":["CQG","CQD","CQE","CQF"],
"sales clerk":["CQH"],
"salesperson":["Dtw"],
"salmon":["DLT","CQM","CQI","CQJ","CQK","CQL"],
"salsa":["CQP","CQN","CQO"],
"salt":["DLU","CQU","CQQ","CQR"],
"salt and pepper":["CQS","CQT"],
"salty":["CQV"],
"salute":["CQZ","CQW","CQX","CQY"],
"same":["CQb","CQa"],
"samosas":["DLV"],
"sand":["CQx","CQc","CQd","CQe","CQf"],
"sand castle":["CQk","CQl","CQm","CQn","CQo"],
"sand dunes":["CQp","CQq","CQr","CQs","CQt"],
"sandals":["DLW","CQj","CQg","CQh","CQi"],
"sandcastle":["Dtx"],
"sandpaper":["CQu"],
"sandpit":["CQw","CQv"],
"sandstorm":["CQ2","CQy","CQz","CQ0","CQ1"],
"sandwich":["DLX","CRB","CQ3","CQ4","CQ5","CQ6"],
"sandwiches":["CRA","CQ7","CQ8","CQ9"],
"santa":["CRK","CRC","CRD","CRE","CRF"],
"santa claus":["CRG","CRH","CRI","CRJ"],
"sapling":["CRQ","CRL","CRM","CRN","CRO","CRP"],
"sapphire":["CRV","CRR","CRS","CRT","CRU"],
"sarcophagus":["CRZ","CRW","CRX","CRY"],
"sardines":["CRe","CRa","CRb","CRc","CRd"],
"satchel":["DLY"],
"satellite":["CRk","CRf","CRg","CRh","CRi","CRj"],
"satellite dish":["DLZ"],
"satsumas":["CRm","CRl"],
"Saturday":["DLc","DLa","DLb"],
"saturn":["CRs","CRn","CRo","CRp","CRq","CRr"],
"sauce":["CRx","CRt","CRu","CRv","CRw"],
"saucepan":["DLd"],
"sausage":["DLe","CRz","CRy"],
"sausages":["DLf","CR2","CR0","CR1"],
"savannah":["CR6","CR3","CR4","CR5"],
"save money":["CR7"],
"savoury":["CR9","CR8"],
"saw":["DLg","CSC","CSA","CSB"],
"saxophone":["DLh","CSI","CSD","CSE","CSF","CSG","CSH"],
"say":["DlR","DlS"],
"say hello":["DlR","DlS"],
"say said":["DlR","DlS"],
"saying":["DlS","DlR"],
"saying hello":["DlR","DlS"],
"scale":["Dty"],
"scales":["CSJ"],
"scan":["CSL"],
"scanner":["CSK"],
"scar":["DLk"],
"scarecrow":["CSR","CSM","CSN","CSO","CSP","CSQ"],
"scared":["DLi","CST","CSS"],
"scarf":["DLj","CSX","CSU","CSV","CSW"],
"scary":["CSZ","CSY"],
"scenery":["CSc","CSa","CSb"],
"scent":["CSf","CSd","CSe"],
"schedule":["Dtz"],
"scholar":["CSj","CSg","CSh","CSi"],
"school":["CSv","CSk","CSl"],
"school bag":["CSm","CSn","CSo","CSp","CSq"],
"school bus":["DLl","CSr","CSs","CSt","CSu"],
"school schedule":["CSw","CSx","CSy"],
"school trip":["CSz","CS0"],
"schoolbag":["Dt0"],
"science":["DYj","CS5"],
"science fiction":["CS1","CS2","CS3","CS4"],
"science lab":["Dt1"],
"scientist":["DLn","DLm","CTA","CS6","CS7","CS8","CS9"],
"scientists":["DYk","CTB","CTC"],
"scissors":["DLo","CTF","CTD","CTE"],
"scoop":["CTI","CTG","CTH"],
"scooter":["DLp","CTN","CTJ","CTK","CTL","CTM"],
"scorch":["CTQ","CTO","CTP"],
"score":["DlT"],
"score a goal":["DlT"],
"score scored":["DlT"],
"scoring":["DlT"],
"scoring a goal":["DlT"],
"scorpion":["DLq","CTV","CTR","CTS","CTT","CTU"],
"scrambled egg on toast":["DLr"],
"scrambled eggs":["CTW","CTX","CTY","CTZ"],
"scream":["DlU","CTc","CTa","CTb"],
"scream screamed":["DlU"],
"screaming":["DlU"],
"screen":["CTg","CTd","CTe","CTf"],
"screw":["DLt","CTn","CTh","CTi"],
"screwdriver":["DLs","CTm","CTj","CTk","CTl"],
"script":["Dt2"],
"scuba diver":["CTo","CTp"],
"scuba diving":["CTq"],
"sculpture":["CTt","CTr","CTs"],
"sea":["CUJ","CTu","CTv","CTw"],
"sea horse":["Dt3"],
"sea lion":["CT8","CT9","CUA","CUB"],
"sea turtle":["CUW","CUX","CUY","CUZ","CUa"],
"sea weed":["CUb","CUc"],
"seafood":["CTx"],
"seagull":["CT1","CTy","CTz","CT0"],
"seahorse":["CT4","CT2","CT3"],
"seal":["CUC","CT5","CT6","CT7"],
"seals":["CUF","CUD","CUE"],
"seam":["CUI","CUG","CUH"],
"search":["Dt4"],
"seaside":["CUN","CUK","CUL","CUM"],
"seat":["CUV","CUO","CUP","CUQ","CUR","CUS"],
"seat belt":["CUT","CUU"],
"seaweed":["Dt5"],
"second":["Dt6"],
"secret":["Dt7"],
"secretary":["DLv","DLu","CUe","CUd"],
"security guard":["DLw","DLx","CUf","CUg","CUh","CUi"],
"see":["DlV","DlW","DlX","DlY"],
"see a ghost":["DlV"],
"see an elephant":["DlW","DlX"],
"see saw":["DlV","DlW","DlX","DlY"],
"see the Eiffel Tower":["DlY"],
"seed":["CUo","CUj","CUk","CUl","CUm","CUn"],
"seeds":["CUp"],
"seeing":["DlY","DlV","DlW","DlX"],
"seeing a ghost":["DlV"],
"seeing an elephant":["DlW","DlX"],
"seeing the Eiffel Tower":["DlY"],
"seesaw":["CUt","CUq","CUr","CUs"],
"selfish":["Dt8"],
"sell":["DlZ","Dla","Dlb","Dlc","CUu"],
"sell apples":["DlZ"],
"sell cars":["Dla"],
"sell drinks":["Dlb"],
"sell medicine":["Dlc"],
"sell sold":["DlZ","Dla","Dlb","Dlc"],
"selling":["Dlc","DlZ","Dla","Dlb"],
"selling apples":["DlZ"],
"selling cars":["Dla"],
"selling drinks":["Dlb"],
"selling medicine":["Dlc"],
"send":["Dld","Dle","Dlf","CUw","CUv"],
"send a message":["Dld"],
"send an email":["Dle","Dlf"],
"send sent":["Dld","Dle","Dlf"],
"sending":["Dlf","Dld","Dle"],
"sending a message":["Dld"],
"sending an email":["Dle","Dlf"],
"September":["Dt9"],
"serious":["DuA"],
"servant":["CUx"],
"servants":["CUy"],
"serve":["Dlh","Dlg"],
"serve food":["Dlg"],
"serve served":["Dlg","Dlh"],
"serving":["Dlh","Dlg"],
"serving food":["Dlg"],
"set the table":["DuB"],
"seven":["Dbw","Dbu"],
"seven hundred":["Dbv"],
"seven o'clock":["DeU"],
"seven thousand":["Dbz"],
"seventeen":["Dby","Dbx"],
"seventy":["Db6","Db0"],
"seventy eight":["Db1"],
"seventy five":["Db2"],
"seventy four":["Db3"],
"seventy nine":["Db4"],
"seventy one":["Db5"],
"seventy seven":["Db7"],
"seventy six":["Db8"],
"seventy thousand":["Db9"],
"seventy three":["DcA"],
"seventy two":["DcB"],
"sew":["Dli","CU6","CUz","CU0"],
"sew clothes":["Dli"],
"sew sewed":["Dli"],
"sewing":["Dli","CU5"],
"sewing clothes":["Dli"],
"sewing machine":["CU1","CU2","CU3","CU4"],
"shade":["CU8","CU7"],
"shades":["CVC","CU9","CVA","CVB"],
"shadow":["CVF","CVD","CVE"],
"shake":["Dlj","Dlk","CVL","CVG","CVH"],
"shake hands":["Dlj","Dlk","CVI","CVJ","CVK"],
"shake shook":["Dlj","Dlk"],
"shaker":["CVN","CVM"],
"shaking":["Dlk","Dlj"],
"shaking hands":["Dlj","Dlk"],
"shallow":["DuC"],
"shampoo":["DLy","CVQ","CVO","CVP"],
"shapes":["CVR"],
"share":["Dll"],
"share a pizza":["Dll"],
"share pizza#":["CVS"],
"share shared":["Dll"],
"sharing":["Dll"],
"sharing a pizza":["Dll"],
"shark":["DLz","CVV","CVT","CVU"],
"sharp":["DL2","CVc","CVW","CVX"],
"sharpener":["DL0","CVb","CVY","CVZ","CVa"],
"sharper":["DL1"],
"shave":["Dlm","Dln"],
"shave shaved":["Dlm","Dln"],
"shave your head":["Dln"],
"shaving":["Dlm","Dln","CVe","CVd"],
"shaving your head":["Dln"],
"shawl":["DuD"],
"shed":["DL3","CVi","CVf","CVg","CVh"],
"sheep":["DL4","CVo","CVj","CVk","CVl","CVm"],
"sheepdog":["DYl","CVn"],
"sheet":["CVr","CVp","CVq"],
"sheets":["CVs"],
"shelf":["CVx","CVt","CVu","CVv","CVw"],
"shell":["DL5","CV1","CVy","CVz","CV0"],
"shells":["CV4","CV2","CV3"],
"shelter":["CV8","CV5","CV6","CV7"],
"shelves":["DL6","CWC","CV9","CWA","CWB"],
"shepherd":["CWF","CWD","CWE"],
"shield":["DL7","CWK","CWG","CWH","CWI","CWJ"],
"shine":["CWM","CWL"],
"shiny":["CWN"],
"ship":["CWQ","CWO","CWP"],
"shirt":["DL9","DL8","CWS","CWR"],
"shitzu":["CWU","CWT"],
"shock":["CWZ","CWV"],
"shocked":["CWY","CWW","CWX"],
"shoe":["CWc","CWa","CWb"],
"shoe shop":["CWh","CWi"],
"shoe store":["CWk","CWl"],
"shoes":["DMC","DMA","DMB","CWj","CWd","CWe","CWf","CWg"],
"shop":["Dlo"],
"shop assistant":["DMD","DME"],
"shop shopped":["Dlo"],
"shopping":["Dlo","CWu","CWm"],
"shopping cart":["DMF"],
"shopping center":["DMG","CWn","CWo"],
"shopping centre":["DuE"],
"shopping list":["CWp"],
"shopping mall":["CWq","CWr","CWs","CWt"],
"shops":["CWv"],
"shore":["DuF"],
"short":["DuH","DuG"],
"short hair":["CWw","CWx"],
"shorter":["DMJ","DMH","DMI"],
"shorts":["DMK","CW1","CWy","CWz","CW0"],
"shoulder":["DML","CW2"],
"shoulders":["CW4","CW3"],
"shout":["Dlp","CW7"],
"shout shouted":["Dlp"],
"shouting":["Dlp","CW6","CW5"],
"shovel":["CXB","CW8","CW9","CXA"],
"show":["Dlq","Dlr"],
"show a phone":["Dlq"],
"show showed":["Dlq","Dlr"],
"show your ID":["Dlr"],
"shower":["DMM","CXG","CXC","CXD","CXE","CXF"],
"showing":["Dlr","Dlq"],
"showing a phone":["Dlq"],
"showing your ID":["Dlr"],
"shrimp":["DMN","CXL","CXH","CXI","CXJ","CXK"],
"shrugged":["CXO","CXM","CXN"],
"shut":["Dls"],
"shut shut":["Dls"],
"shut the door":["Dls"],
"shutting":["Dls"],
"shutting the door":["Dls"],
"shuttlecock":["DuI"],
"shy":["CXP"],
"sibling":["CXQ"],
"siblings":["CXR"],
"sick":["DMO","CXU","CXS","CXT"],
"side dish":["CXV","CXW","CXX"],
"sidewalk":["DuJ"],
"sight":["DuK"],
"sightseeing":["CXa","CXY","CXZ"],
"sign":["Dlt","Dlu","CXc","CXb"],
"sign his name":["Dlt"],
"sign signed":["Dlt","Dlu","Dlv"],
"sign your name":["Dlu"],
"significant":["DuL"],
"signing":["Dlu","Dlt"],
"signing his name":["Dlt"],
"signing your name":["Dlu"],
"signpost":["CXg","CXd","CXe","CXf"],
"silence":["CXi","CXh"],
"silent":["CXj"],
"silk":["CXk"],
"silly":["CXm","CXl"],
"silver":["DMP","CXo","CXn"],
"sing":["Dlx","Dlv","Dlw","CX3","CXp","CXq"],
"sing a song":["CXv"],
"sing karaoke":["Dlw"],
"sing sang":["Dlw","Dlx"],
"Singapore":["CXu","CXr","CXs","CXt"],
"Singapore flag":["DMQ"],
"singer":["DMS","DMR","CXz","CXw","CXx","CXy"],
"singing":["Dlx","Dlv","Dlw","CX2","CX0","CX1"],
"singing karaoke":["Dlw"],
"sink":["DMT","CX8","CX4","CX5","CX6","CX7"],
"sip":["CX9"],
"sister":["DZe","CYA"],
"sit":["CYI","CYB","CYC","CYD","CYE"],
"sit down":["Dly","CYF","CYG"],
"sit down sat down":["Dly"],
"sit on":["Dlz"],
"sit on a sofa":["Dlz"],
"sit on the sofa":["CYH"],
"sit sat":["Dlz"],
"sit up":["CYK"],
"sitcom":["DuM"],
"sitting down":["Dly"],
"sitting on":["Dlz"],
"sitting on a sofa":["Dlz"],
"sitting room":["CYJ"],
"six":["DcE","DcC"],
"six hundred":["DcD"],
"six o'clock":["DeV"],
"six thousand":["DcH"],
"sixteen":["DcG","DcF"],
"sixty":["DcO","DcI"],
"sixty eight":["DcJ"],
"sixty five":["DcK"],
"sixty four":["DcL"],
"sixty nine":["DcM"],
"sixty one":["DcN"],
"sixty seven":["DcP"],
"sixty six":["DcQ"],
"sixty thousand":["DcR"],
"sixty three":["DcS"],
"sixty two":["DcT"],
"skate":["Dl1","Dl0","CYQ"],
"skate park":["DuN"],
"skate skated":["Dl0","Dl1"],
"skateboard":["DMV","CYP","CYL","CYM"],
"skateboarding":["DMU","CYO","CYN"],
"skates":["CYR"],
"skating":["Dl1","Dl0","CYS"],
"skating rink":["CYT"],
"skeleton":["CYW","CYU","CYV"],
"sketch":["CYX"],
"ski":["Dl2","CYf","CYY","CYZ"],
"ski jacket":["CYc"],
"ski skied":["Dl2"],
"skiing":["Dl2","DMW","CYb","CYa"],
"skin":["CYd"],
"skinny":["DuO"],
"skip":["CYi","CYe"],
"skipping":["CYg"],
"skipping rope":["CYh"],
"skirt":["DMX","CYo","CYj","CYk","CYl","CYm","CYn"],
"skis":["DMY","CYp"],
"skull":["CYt","CYq","CYr","CYs"],
"skunk":["DMZ","CYx","CYu","CYv","CYw"],
"sky":["CY1","CYy","CYz","CY0"],
"skydiving":["DuP"],
"skyscraper":["CY4","CY2","CY3"],
"skyscrapers":["CY7","CY5","CY6"],
"skyscrappers":["DMa"],
"sled":["CZG","CY8","CY9","CZA"],
"sledge":["CZF","CZB","CZC","CZD","CZE"],
"sleep":["Dl6","Dl3","Dl4","Dl5","CZP","CZH","CZI"],
"sleep in class":["Dl5"],
"sleep slept":["Dl3","Dl4","Dl5","Dl6"],
"sleeping":["Dl6","Dl3","Dl4","Dl5","CZN","CZJ","CZK"],
"sleeping bag":["CZL","CZM"],
"sleeping in class":["Dl5"],
"sleepover":["CZO"],
"sleepy":["CZS","CZQ","CZR"],
"sleigh":["CZX","CZT","CZU","CZV","CZW"],
"slice":["CZe","CZY","CZZ","CZa","CZb"],
"slice of cake":["CZc"],
"slice of pie":["CZd"],
"slide":["DMb","CZh","CZf","CZg"],
"slim":["CZi"],
"slip":["DuQ"],
"slippers":["DMc","CZm","CZj","CZk","CZl"],
"slope":["CZn"],
"sloth":["DuR"],
"Slovakia":["CZr","CZo","CZp","CZq"],
"slow":["DMe","CZt","CZs"],
"slower":["DMd"],
"slowly":["DuS"],
"small":["DMj","DMf"],
"smaller":["DMi","DMg","DMh"],
"smart":["CZw"],
"smart watch":["DMk"],
"smartphone":["CZv","CZu"],
"smash":["CZy","CZx"],
"smell":["Dl7","Dl8","Dl9","DmA"],
"smell a flower":["Dl7"],
"smell bad":["Dl8","Dl9"],
"smell flowers":["DmA"],
"smell smelled":["Dl7","Dl8","Dl9","DmA"],
"smelling":["DmA","Dl7","Dl8","Dl9"],
"smelling a flower":["Dl7"],
"smelling bad":["Dl8","Dl9"],
"smelling flowers":["DmA"],
"smelly":["DMl"],
"smile":["DmC","DmB","CZ0","CZz"],
"smile smiled":["DmB","DmC"],
"smiling":["DmC","DmB","CZ3","CZ1","CZ2"],
"smoke":["CZ5","CZ4"],
"smooth":["DuT"],
"smoothie":["CaA","CZ6","CZ7","CZ8","CZ9"],
"snack":["DuV","DuU"],
"snacks":["DuW"],
"snail":["DMm","CaE","CaB","CaC","CaD"],
"snake":["DMn","CaK","CaF","CaG","CaH","CaI","CaJ"],
"snakes":["CaM","CaL"],
"sneaker":["CaO","CaN"],
"sneakers":["DMo","CaR","CaP","CaQ"],
"sneaky":["CaS"],
"sneeze":["DmD","CaU","CaT"],
"sneeze sneezed":["DmD"],
"sneezing":["DmD","CaV"],
"sniff":["CaW"],
"sniper":["CaX"],
"snooker":["CaZ","CaY"],
"snore":["Caa"],
"snorkel":["DMp","Cag","Cab","Cac","Cad"],
"snorkeling":["Caf","Cae"],
"snow":["DmE","DMr","DMq","CbR","Cah","Cai","Caj","Cak"],
"snow globe":["Ca5","Ca6","Ca7","Ca8"],
"snow leopard":["CbC","CbD","CbE","CbF","CbG","CbH"],
"snow shoes":["CbS","CbT"],
"snow snowed":["DmE"],
"snowball":["Can","Cal"],
"snowball fight":["Cam"],
"snowboard":["Caw","Cao"],
"snowboarder":["Car","Cap","Caq"],
"snowboarding":["Cav","Cas","Cat","Cau"],
"snowflake":["Ca0","Cax","Cay","Caz"],
"snowflakes":["Ca4","Ca1","Ca2","Ca3"],
"snowing":["DmE","CbB","Ca9","CbA"],
"snowman":["CbO","CbI","CbJ","CbK","CbL","CbM","CbN"],
"snowmen":["CbQ","CbP"],
"snowstorm":["CbW","CbU","CbV"],
"snowy":["CbZ","CbX","CbY"],
"soap":["DMs","Cbe","Cba","Cbb","Cbc","Cbd"],
"soccer":["DMt","Cbs","Cbf","Cbg","Cbh","Cbi"],
"soccer ball":["Cbj","Cbk","Cbl","Cbm"],
"soccer field":["Cbn","Cbo"],
"soccer player":["Cbp","Cbq","Cbr"],
"sociable":["DuX"],
"social media":["Cbt"],
"sock":["Cbx","Cbu","Cbv","Cbw"],
"socket":["DMu"],
"socks":["DMw","DMv","Cb1","Cby","Cbz","Cb0"],
"soda":["DMx","Cb6","Cb2","Cb3","Cb4","Cb5"],
"sofa":["DMy","CcA","Cb7","Cb8","Cb9"],
"soft":["CcC","CcB"],
"software developer":["DMz","DM0"],
"software engineer":["DM1","DM2"],
"soil":["CcH","CcD","CcE","CcF","CcG"],
"solar eclipse":["CcI","CcJ","CcK","CcL"],
"solar system":["CcM","CcN"],
"sold":["DuY"],
"soldier":["DM4","DM3","CcR","CcO","CcP","CcQ"],
"soldiers":["CcV","CcS","CcT","CcU"],
"solid":["CcW"],
"solitary":["CcY","CcX"],
"solve":["CcZ"],
"son":["DZg","Ccc","Cca"],
"son-in-law":["DZf"],
"song":["Ccb"],
"sore throat":["DM5","Ccd"],
"sorry":["DuZ"],
"soul":["Ccf","Cce"],
"soup":["DM6","Ccj","Ccg","Cch","Cci"],
"soup spoon":["Cck","Ccl","Ccm"],
"South Africa":["DM9","Ccn","Cco","Ccp","Ccq"],
"South Africa flag":["DM7"],
"South African":["DM8"],
"South America":["Ccr","Ccs"],
"South Korea":["Cct","Ccu","Ccv"],
"souvenir":["Ccw"],
"soy sauce":["Ccx","Ccy","Ccz"],
"space":["Cc3","Cc0","Cc1","Cc2"],
"space shuttle":["Cc7","Cc8","Cc9"],
"space station":["CdA","CdB"],
"space suit":["CdC","CdD","CdE"],
"spacecraft":["Dua"],
"spaceship":["Cc6","Cc4","Cc5"],
"spacious":["CdG","CdF"],
"spade":["DNA","CdJ","CdH","CdI"],
"spaghetti":["DNC","CdO","CdK","CdL","CdM","CdN"],
"spaghetti bolognese":["DNB"],
"Spain":["DNE","CdS","CdP","CdQ","CdR"],
"Spain flag":["DND"],
"Spanish":["DNG","DNF"],
"spare ribs":["CdT","CdU"],
"spark":["CdY"],
"sparkler":["CdV"],
"sparkling water":["CdW","CdX"],
"sparrow":["Cdb","CdZ","Cda"],
"spatula":["DNH","Cdd","Cdc"],
"speak":["DmH","DmF","DmG","DmI"],
"speak Chinese":["DmF"],
"speak English":["DmG"],
"speak Spanish":["DmI"],
"speak spoke":["DmF","DmG","DmH","DmI"],
"speakers":["DNI","Cdf","Cde"],
"speaking":["DmH","DmF","DmG","DmI"],
"speaking Chinese":["DmF"],
"speaking English":["DmG"],
"speaking Spanish":["DmI"],
"spear":["Cdj","Cdg","Cdh","Cdi"],
"special":["Dub"],
"species":["Duc"],
"speed camera":["Cdk","Cdl"],
"speed limit":["Cdm","Cdn"],
"spell":["Cdo"],
"sphere":["Dud"],
"sphinx":["Cdr","Cdp","Cdq"],
"spicy":["Cdu","Cds","Cdt"],
"spider":["DNJ","Cdy","Cdv","Cdw","Cdx"],
"spider web":["Cd1","Cd2","Cd3","Cd4"],
"spiders":["Cd0","Cdz"],
"spike":["Cd5"],
"spiky":["Cd9","Cd6","Cd7"],
"spiky hair":["Cd8"],
"spill":["DmJ","CeC","CeA","CeB"],
"spill spilt":["DmJ"],
"spill water":["DmJ"],
"spilling":["DmJ"],
"spilling water":["DmJ"],
"spin":["Duf"],
"spinach":["CeH","CeD","CeE","CeF","CeG"],
"spine":["CeJ","CeI"],
"spinkle":["Due"],
"spit":["CeK"],
"splash":["CeN","CeL","CeM"],
"split":["CeO"],
"spoil":["CeQ","CeP"],
"sponge":["CeT","CeR","CeS"],
"spoon":["DNK","CeX","CeU","CeV","CeW"],
"sports":["Duj"],
"sports car":["CeY","CeZ","Cea"],
"sports center":["Dug"],
"sports centre":["Duh"],
"sports field":["Dui"],
"sporty":["Duk"],
"spots":["Dul"],
"spray":["DmK"],
"spray sprayed":["DmK"],
"spraying":["DmK"],
"spread":["DmL"],
"spread butter":["DmL"],
"spread spread":["DmL"],
"spreading":["DmL"],
"spreading butter":["DmL"],
"spring":["Dum"],
"spring onion":["Ceb","Cec"],
"spring onions":["Ced","Cee"],
"spring roll":["Cef","Ceg"],
"spring rolls":["DNL"],
"sprinkler":["Ceh"],
"spy":["Cej","Cei"],
"square":["Cek"],
"squash":["Cen","Cel","Cem"],
"squats":["Cep","Ceo"],
"squeeze":["DmM","Ces","Ceq","Cer"],
"squeeze an orange":["DmM"],
"squeeze squeezed":["DmM"],
"squeezing":["DmM"],
"squeezing an orange":["DmM"],
"squid":["Cew","Cet","Ceu","Cev"],
"squirrel":["DNM","Ce0","Cex","Cey","Cez"],
"Sri Lanka":["Ce1","Ce2","Ce3"],
"stable":["Ce6","Ce4","Ce5"],
"stack of books":["Ce7"],
"stadium":["DNN","CfB","Ce8","Ce9","CfA"],
"stage":["CfD","CfC"],
"stair":["CfG","CfE","CfF"],
"stairs":["DNO","CfM","CfH","CfI","CfJ","CfK","CfL"],
"stamp":["CfQ","CfN","CfO","CfP"],
"stamps":["CfR"],
"stand":["DmN"],
"stand stood":["DmN"],
"stand up":["DmO"],
"stand up stood up":["DmO"],
"standing":["DmN"],
"standing in line":["Dun"],
"standing up":["DmO"],
"stapler":["DNP","CfU","CfS","CfT"],
"star":["Cfh","CfV","CfW"],
"star fish":["CfX","CfY","CfZ"],
"star fruit":["Cfa","Cfb","Cfc","Cfd"],
"stare":["DmP"],
"stare out the window":["DmP"],
"stare stared":["DmP"],
"starfish":["Duo"],
"staring":["DmP"],
"staring out the window":["DmP"],
"starling":["Cfg","Cfe","Cff"],
"starry night":["Cfi"],
"stars":["DNQ","Cfm","Cfj","Cfk","Cfl"],
"start":["DmQ","DmR","Cfo","Cfn"],
"start a race":["DmQ"],
"start school":["DmR"],
"start started":["DmQ","DmR"],
"starting":["DmR","DmQ"],
"starting a race":["DmQ"],
"starting school":["DmR"],
"station":["Cft","Cfp","Cfq","Cfr","Cfs"],
"statue":["DNR","Cfy","Cfu","Cfv","Cfw","Cfx"],
"stay at home":["Dup"],
"stay in":["DmS"],
"stay in bed":["DmS"],
"stay stayed":["DmS"],
"staying in":["DmS"],
"staying in bed":["DmS"],
"steak":["DNT","Cf4","Cfz","Cf0","Cf1","Cf2","Cf3"],
"steak and chips":["DNS"],
"steal":["DmT"],
"steal a wallet":["DmT"],
"steal stole":["DmT"],
"stealing":["DmT"],
"stealing a wallet":["DmT"],
"steam":["Duq"],
"steam engine":["Cf5","Cf6"],
"steep":["Cf9","Cf7","Cf8"],
"stem":["Dur"],
"step ladder":["CgA","CgB","CgC","CgD"],
"steps":["CgH","CgE","CgF","CgG"],
"stereo":["DNU"],
"stethoscope":["DNV","CgK","CgI","CgJ"],
"stew":["CgM","CgL"],
"stick":["CgU","CgN","CgO","CgP"],
"stick insect":["CgQ","CgR","CgS","CgT"],
"stickers":["Dus"],
"sticks":["Dut"],
"sticky":["CgV"],
"sticky rice":["Duu"],
"sticky tape":["CgW"],
"stilt house":["CgX"],
"sting":["DmU","Cga","CgY","CgZ"],
"sting stung":["DmU"],
"stinging":["DmU"],
"stingray":["Duv"],
"stir":["DmV","Cgc","Cgb"],
"stir stirred":["DmV"],
"stiring":["DmV"],
"stocking":["Cgf","Cgd","Cge"],
"stomach":["Cgg"],
"stomach ache":["DNW"],
"stomp":["Duw"],
"stone":["Cgi","Cgh"],
"stool":["DNX"],
"stop":["DmX","DmW","Cgk","Cgj"],
"stop at the lights":["DmW"],
"stop sign":["DNY"],
"stop stopped":["DmW","DmX"],
"stopping":["DmX","DmW"],
"stopping at the lights":["DmW"],
"store":["DNZ","Cgl"],
"stork":["Cgq","Cgm","Cgn","Cgo","Cgp"],
"storm":["DNb","DNa","DYm","Cgt","Cgr","Cgs"],
"stormy":["Cgw","Cgu","Cgv"],
"story":["Cgz"],
"storybook":["Cgy","Cgx"],
"storyteller":["Cg0"],
"stove":["DNc","Cg4","Cg1","Cg2","Cg3"],
"straight":["Cg8","Cg5","Cg6"],
"straight hair":["Cg7"],
"strange":["ChB","Cg9","ChA"],
"straw":["DNf","ChV","ChC","ChD","ChE","ChF","ChG"],
"straw hat":["ChQ","ChR","ChS","ChT","ChU"],
"strawberries":["DNd","ChL","ChH","ChI","ChJ","ChK"],
"strawberry":["DNe","ChP","ChM","ChN"],
"strawberry juice":["ChO"],
"stream":["ChZ","ChW","ChX","ChY"],
"street":["Che","Cha","Chb","Chc","Chd"],
"street light":["DNg"],
"strength":["Chf"],
"stressed":["Chh","Chg"],
"stretch":["DmY","Cho","Chi","Chj","Chk"],
"stretch stretched":["DmY"],
"stretcher":["DNh"],
"stretching":["DmY","Chn","Chl","Chm"],
"strict":["Chq","Chp"],
"strike":["Chs","Chr"],
"string":["Chw","Cht","Chu","Chv"],
"striped":["Chy","Chx"],
"stripes":["Ch0","Chz"],
"stripy":["Ch1"],
"strong":["DNj","Ch2"],
"stronger":["DNi"],
"stubborn":["Dux"],
"student":["Ch7","Ch3","Ch4","Ch5","Ch6"],
"students":["CiB","Ch8","Ch9","CiA"],
"studio":["CiC"],
"study":["Dmb","DmZ","Dma","DNk","DYn","CiF","CiD","CiE"],
"study studied":["DmZ","Dma","Dmb"],
"studying":["Dmb","DmZ","Dma"],
"stuntman":["CiH","CiG"],
"subjects":["DYo"],
"submarine":["DYp","CiM","CiI","CiJ","CiK","CiL"],
"submersible":["DYq"],
"subtract":["CiN"],
"suburban":["CiO"],
"subway":["CiT","CiP","CiQ","CiR","CiS"],
"successful":["Duy"],
"sugar":["DNl","CiW","CiU","CiV"],
"sugary food":["DYr"],
"suggestions":["DYs"],
"suit":["DNn","Cij","CiX","CiY","CiZ","Cia"],
"suit and tie":["Cib","Cic","Cid","Cie"],
"suitcase":["DNm","Cii","Cif","Cig","Cih"],
"sulk":["Cik"],
"summer":["Duz"],
"sun":["CjE","Cil","Cim"],
"sun cream":["Du1"],
"sun hat":["Ci1","Ci2","Ci3","Ci4"],
"sunbathe":["Dmc","Cip","Cin","Cio"],
"sunbathe sunbathed":["Dmc"],
"sunbathing":["Dmc"],
"sunburn":["Du0"],
"suncream":["Ciq"],
"Sunday":["DNq","DNo","DNp"],
"Sunday roast":["Cir"],
"sunflower":["Cit","Cis"],
"sunflowers":["Ciw","Ciu","Civ"],
"sunglasses":["DNr","Ci0","Cix","Ciy","Ciz"],
"sunlight":["Ci8","Ci5","Ci6","Ci7"],
"sunnier":["DNs"],
"sunny":["DNu","DNt","DYt","CjD","Ci9","CjA","CjB","CjC"],
"sunrise":["CjI","CjF","CjG","CjH"],
"sunscreen":["DNv","DYu","CjL","CjJ","CjK"],
"sunset":["CjQ","CjM","CjN","CjO","CjP"],
"sunshine":["CjU","CjR","CjS","CjT"],
"superhero":["DNw","CjX","CjV","CjW"],
"superman":["Du2"],
"supermarket":["DNx","Cja","CjY","CjZ"],
"supernova":["Cjc","Cjb"],
"support":["Dmd"],
"support a team":["Dmd"],
"support supported":["Dmd"],
"supporting":["Dmd"],
"supporting a team":["Dmd"],
"surf":["Cjl","Cjd","Cje"],
"surf board":["Cjf","Cjg"],
"surf the internet":["Du4"],
"surfboard":["Du3"],
"surfing":["DNy","Cjk","Cjh","Cji","Cjj"],
"surgeon":["DN0","DNz","Cjo","Cjm","Cjn"],
"surgery":["Cjr","Cjp","Cjq"],
"surprise":["Du5"],
"surprised":["DN1","Cju","Cjs","Cjt"],
"sushi":["DN2","Cjx","Cjv","Cjw"],
"suspension":["DYv"],
"suspicious":["Cjy"],
"swamp":["Cj3","Cjz","Cj0","Cj1","Cj2"],
"swan":["DN3","Cj6","Cj4","Cj5"],
"sweat":["CkD","Cj7","Cj8"],
"sweater":["DN4","CkC","Cj9","CkA","CkB"],
"sweatshirt":["CkH","CkE","CkF","CkG"],
"Sweden":["CkL","CkI","CkJ","CkK"],
"sweep":["Dme","Dmf","CkP","CkM","CkN","CkO"],
"sweep swept":["Dme","Dmf"],
"sweep the floor":["Dmf"],
"sweeping":["Dme","Dmf"],
"sweeping the floor":["Dmf"],
"sweet":["Du6"],
"sweet potato":["CkV","CkW","CkX","CkZ"],
"sweet potatoes":["CkY"],
"sweet shop":["Ckd","Cke"],
"sweetcorn":["DN5","CkR","CkQ"],
"sweetheart":["CkU","CkS","CkT"],
"sweets":["Ckf","Cka","Ckb","Ckc"],
"swim":["Dmh","Dmg","Ckr","Ckg"],
"swim in the sea":["Du7"],
"swim swam":["Dmg","Dmh"],
"swimmer":["Cki","Ckh"],
"swimming":["Dmh","Dmg","DN7","Ckl","Ckj","Ckk"],
"swimming cap":["DN6"],
"swimming pool":["Ckm","Ckn","Cko","Ckp"],
"swimming trunks":["DN8","Ckq"],
"swimsuit":["DN9","Cks"],
"swing":["Dmi","DOA","Ckx","Ckt","Cku","Ckv","Ckw"],
"swing swung":["Dmi"],
"swinging":["Dmi"],
"swings":["Cky"],
"switch":["DOB"],
"Switzerland":["Ck2","Ckz","Ck0","Ck1"],
"swivel chair":["DOC"],
"sword":["DOD"],
"swordfish":["Ck5","Ck3","Ck4"],
"syringe":["DOE"],
"syrup":["Ck7","Ck6"],
"t":["DaO","DaN"],
"t rex":["Cst","Csu"],
"t shirt":["Cth","Ctj","Ctl","Ctn"],
"table":["DOF","ClG","Ck8","Ck9","ClA","ClB","ClC"],
"table tennis":["DOG","ClK","ClL","ClM","ClN","ClO"],
"tablecloth":["ClF","ClD","ClE"],
"tablespoon":["ClH"],
"tablet":["DOH","ClP","ClI","ClJ"],
"taco":["DOI"],
"tacos":["ClT","ClQ","ClR","ClS"],
"tadpole":["ClW","ClU","ClV"],
"taekwondo":["ClY","ClX"],
"tail":["DOL","Cla","ClZ"],
"tailor":["DOK","DOJ"],
"Taiwan":["Cld","Clb","Clc"],
"Taiwan flag":["DOM"],
"Taj mahal":["Cle","Clf","Clg"],
"take":["Dmu","Dmv","Dm0","Dm1","Dm2"],
"take a bath":["Dmj"],
"take a cookie":["Dmk"],
"take a nap":["Clh"],
"take a photo":["Dml","Dmm","Dmn","Dmo","Cli","Clj","Clk"],
"take a picture":["Du8"],
"take a shower":["Dmp","Dmq","Dmr"],
"take a test":["Dms"],
"take away":["Du9"],
"take care":["Dmt"],
"take care of":["DvA"],
"take care took care":["Dmt"],
"take medicine":["Dmu"],
"take money":["Dmv"],
"take off":["Dmw","Dmx"],
"take off took off":["Dmw"],
"take out":["Dmy","Dmz"],
"take out the trash":["Dmz"],
"take out took out":["Dmy","Dmz"],
"take pictures":["DvB"],
"take some pizza":["Dm0","Dm1"],
"take the bus":["Dm2"],
"take took":["Dm0","Dmj","Dmk","Dml","Dmo","Dmp","Dmu","Dmv"],
"taking":["Dmu","Dmv","Dm0","Dm1","Dm2"],
"taking a bath":["Dmj"],
"taking a cookie":["Dmk"],
"taking a photo":["Dml","Dmm","Dmn","Dmo"],
"taking a shower":["Dmp","Dmq","Dmr"],
"taking a test":["Dms"],
"taking care":["Dmt"],
"taking medicine":["Dmu"],
"taking money":["Dmv"],
"taking off":["Dmw","Dmx"],
"taking out":["Dmy","Dmz"],
"taking out the trash":["Dmz"],
"taking photos":["DvC"],
"taking some pizza":["Dm0","Dm1"],
"taking the bus":["Dm2"],
"talent show":["DvE"],
"talented":["DvD"],
"talk":["Dm7","Dm3","Dm4","Dm5","Dm6","Cll"],
"talk on the phone":["Dm5","Dm6"],
"talk talked":["Dm3","Dm4","Dm5","Dm7"],
"talk to":["Dm8"],
"talk to a friend":["Dm8"],
"talking":["Dm7","Dm3","Dm4","Dm5","Dm6"],
"talking on the phone":["Dm5","Dm6"],
"talking to":["Dm8"],
"talking to a friend":["Dm8"],
"tall":["DOO"],
"taller":["DON"],
"tambourine":["DOP","Cln","Clm"],
"tangerine":["DOQ","Clq","Clo","Clp"],
"tangerines":["DOR","Clt","Clr","Cls"],
"tangle":["Clv"],
"tangled":["Clu"],
"tank":["Clz","Clw","Clx","Cly"],
"tanktop":["Cl0"],
"Tanzania":["Cl3","Cl1","Cl2"],
"tap":["CmD","Cl4","Cl5","Cl6"],
"tape":["DOT","CmC","Cl7","Cl8","Cl9"],
"tape measure":["DOS","CmA","CmB"],
"tarantula":["CmI","CmE","CmF","CmG","CmH"],
"taste":["Dm9","DnA"],
"taste bad":["Dm9"],
"taste good":["DnA"],
"taste tasted":["Dm9","DnA"],
"tasting":["DnA","Dm9"],
"tasting bad":["Dm9"],
"tasting good":["DnA"],
"taxi":["CmM","CmJ","CmK","CmL"],
"taxi rank":["CmN"],
"tea":["DOX","Cmc","CmO","CmP","CmQ"],
"tea set":["Cmi","Cmj","Cmk"],
"tea towel":["DOZ"],
"teach":["DnC","DnB"],
"teach English":["DnB"],
"teach taught":["DnB","DnC"],
"teacher":["DOV","DOU","CmV","CmR","CmS","CmT","CmU"],
"teachers":["DvF"],
"teaching":["DnC","DnB"],
"teaching English":["DnB"],
"teacup":["CmW"],
"teacups":["CmX"],
"teal":["DOW"],
"team":["Cmb","CmY","CmZ","Cma"],
"teapot":["DOY","Cmg","Cmd","Cme","Cmf"],
"tear":["DnD","Cmh"],
"tear tore":["DnD"],
"tear up":["DnE"],
"tear up tore up":["DnE"],
"tearing":["DnD"],
"tearing up":["DnE"],
"teaspoon":["Cmm","Cml"],
"technician":["Cmo","Cmn"],
"technology":["DvG"],
"teddy":["Cmy","Cmp","Cmq","Cmr","Cms"],
"teddy bear":["Cmt","Cmu","Cmv","Cmw","Cmx"],
"teenagers":["Cm0","Cmz"],
"teepee":["Cm4","Cm1","Cm2","Cm3"],
"teeth":["DOa","Cm7","Cm5","Cm6"],
"telephone":["DvH"],
"telescope":["DOb","CnA","Cm8","Cm9"],
"television":["DOc","CnF","CnB","CnC","CnD","CnE"],
"tell":["DnH","DnF","DnG"],
"tell a secret":["DnF"],
"tell off a boy":["DnG"],
"tell told":["DnF","DnG","DnH"],
"telling":["DnH","DnF","DnG"],
"telling a secret":["DnF"],
"telling off a boy":["DnG"],
"temple":["CnH","CnG"],
"ten":["DcV","DcU"],
"ten o'clock":["DeW"],
"ten past eight":["DeX"],
"ten thousand":["DcW"],
"ten to five":["DeY"],
"tennis":["DOd","CnP","CnI","CnJ","CnK","CnL"],
"tennis ball":["CnM"],
"tennis court":["CnN","CnO"],
"tennis racket":["CnQ","CnR"],
"tent":["DOe","CnX","CnS","CnT","CnU","CnV","CnW"],
"terrible":["DvI"],
"text":["CnY"],
"text message":["DvK"],
"textbook":["DvJ"],
"Thai":["DOh"],
"Thailand":["DOg","Cnd","CnZ","Cna","Cnb","Cnc"],
"Thailand flag":["DOf"],
"thanksgiving":["DvL"],
"Thanksgiving dinner":["Cne"],
"the beach":["DvN"],
"the earth":["DOi"],
"the moon":["DOj"],
"the sea":["DvP"],
"the sky":["DvQ"],
"the sun":["DOn"],
"the UK":["DvR"],
"theater":["DvM"],
"theatre":["Cni","Cnf","Cng","Cnh"],
"theme park":["DvO"],
"therapist":["DOl","DOk"],
"thermometer":["DOm","Cnn","Cnj","Cnk","Cnl","Cnm"],
"thief":["Cnq","Cno","Cnp"],
"thigh":["Cnr"],
"thimble":["Cnu","Cns","Cnt"],
"thin":["DOp","Cn1","Cnv","Cnw","Cnx"],
"think":["DnJ","Cn0","Cny","Cnz"],
"think about":["DnI"],
"think about money":["DnI"],
"think about thought about":["DnI"],
"think thought":["DnJ"],
"thinking":["DnJ"],
"thinking about":["DnI"],
"thinking about money":["DnI"],
"thinner":["DOo"],
"third":["DvS"],
"thirsty":["Cn3","Cn2"],
"thirteen":["DcY","DcX"],
"thirty":["Dcf","DcZ"],
"thirty eight":["Dca"],
"thirty five":["Dcb"],
"thirty four":["Dcc"],
"thirty nine":["Dcd"],
"thirty one":["Dce"],
"thirty seven":["Dcg"],
"thirty six":["Dch"],
"thirty thousand":["Dci"],
"thirty three":["Dcj"],
"thirty two":["Dck"],
"thorn":["Cn5","Cn4"],
"thorns":["Cn6"],
"thoughtful":["DvT"],
"three":["Dcn","Dcl"],
"three hundred":["Dcm"],
"three o'clock":["DeZ"],
"three thousand":["Dco"],
"throat":["DvU"],
"throne":["Cn9","Cn7","Cn8"],
"throw":["DnK","CoC","CoA"],
"throw a ball":["DnK","CoB"],
"throw away":["DnL","DnM"],
"throw away a bottle":["DnL"],
"throw away threw away":["DnM"],
"throw away trash":["DnM"],
"throw threw":["DnK","DnL"],
"throwing":["DnK"],
"throwing a ball":["DnK"],
"throwing away":["DnL","DnM"],
"throwing away a bottle":["DnL"],
"throwing away trash":["DnM"],
"thumb":["DOq","CoF","CoD","CoE"],
"thunder":["CoH"],
"thunder and lightning":["CoG"],
"thunderstorm":["DvV"],
"Thursday":["DOt","DOr","DOs"],
"tic tac toe":["CoQ","CoR"],
"tick":["CoP","CoI","CoJ"],
"ticket":["DOu","CoO","CoK","CoL","CoM","CoN"],
"tickets":["DvW"],
"tidier":["DOv"],
"tidy":["DnN","DnO","CoU","CoS","CoT"],
"tidy my room":["DvX"],
"tidy the bed":["DnN"],
"tidy the room":["DnO"],
"tidy tidied":["DnN","DnO"],
"tidy up":["DnP"],
"tidy up tidied up":["DnP"],
"tidying":["DnO","DnN"],
"tidying the bed":["DnN"],
"tidying the room":["DnO"],
"tidying up":["DnP"],
"tie":["DnR","DnQ","DnS","DOw","CoY","CoV","CoW","CoX"],
"tie her shoes":["DnQ"],
"tie tied":["DnQ","DnR","DnS"],
"tie your shoe":["DnS"],
"tie your shoes":["CoZ"],
"tiger":["DOx","Coe","Coa","Cob","Coc","Cod"],
"tigers":["Cog","Cof"],
"tight":["DOz"],
"tighter":["DOy"],
"timber":["Coj","Coh","Coi"],
"timetable":["Cok"],
"tin":["Col"],
"tire":["DvY"],
"tired":["DO0","Con","Com"],
"tissue":["Coo"],
"tissues":["DO1"],
"titanic":["Coq","Cop"],
"toad":["Cou","Cor","Cos","Cot"],
"toads":["Cow","Cov"],
"toast":["DO3","Co5","Cox","Coy","Coz"],
"toaster":["DO2","Co4","Co0","Co1","Co2","Co3"],
"toe":["DO6"],
"toenail":["DO4"],
"toenails":["DO5"],
"toes":["DO7","Co9","Co6","Co7","Co8"],
"tofu":["CpC","CpA","CpB"],
"together":["CpE","CpD"],
"toil":["CpO"],
"toilet":["DO9","CpN","CpF","CpG","CpH"],
"toilet paper":["DO8","CpI","CpJ","CpK","CpL","CpM"],
"tomato":["DPB","CpY","CpP","CpQ"],
"tomato pasta":["CpW","CpX"],
"tomato sauce":["CpZ","Cpa","Cpb"],
"tomato soup":["Cpc","Cpd","Cpe"],
"tomatoes":["DPA","CpV","CpR","CpS","CpT","CpU"],
"tomb":["Cpg","Cpf"],
"tongue":["DPC","Cpk","Cph","Cpi","Cpj"],
"tool":["Cpo"],
"toolbox":["Cpn","Cpl","Cpm"],
"tools":["Cps","Cpp","Cpq","Cpr"],
"tooth":["Cp4","Cpt","Cpu"],
"toothache":["Cpw","Cpv"],
"toothbrush":["DPD","Cp0","Cpx","Cpy","Cpz"],
"toothpaste":["DPE","Cp3","Cp1","Cp2"],
"top":["Ddf"],
"torch":["Cp8","Cp5","Cp6","Cp7"],
"tornado":["DPF","CqB","Cp9","CqA"],
"tortoise":["DPG","CqG","CqC","CqD","CqE","CqF"],
"toucan":["CqJ","CqH","CqI"],
"touch":["DnT","CqM","CqK","CqL"],
"touch touched":["DnT"],
"touch your toes":["DnT"],
"touching":["DnT"],
"touching your toes":["DnT"],
"tour":["DvZ"],
"tour bus":["CqN","CqO","CqP"],
"tour guide":["DPH","DPI","CqQ"],
"tourist":["CqS","CqR"],
"towel":["DPK","DPJ","CqV","CqT","CqU"],
"towels":["CqZ","CqW","CqX","CqY"],
"tower":["Cqc","Cqa","Cqb"],
"town":["Cqi","Cqd","Cqe"],
"town hall":["Cqf","Cqg","Cqh"],
"town house":["Dva"],
"town square":["Cqj","Cqk","Cql"],
"toxic waste":["Cqm","Cqn"],
"toy":["Cqu","Cqo","Cqp"],
"toy box":["Cqq","Cqr"],
"toy car":["Cqs","Cqt"],
"toy shop":["Cqx","Cqy"],
"toy soldier":["Cqz","Cq0"],
"toy soldiers":["Cq1","Cq2","Cq3","Cq4"],
"toy store":["Cq6","Cq7","Cq8"],
"toy train":["Cq9","CrA","CrB"],
"toys":["Cq5","Cqv","Cqw"],
"trachea":["CrC"],
"track":["CrE","CrD"],
"tracks":["CrG","CrF"],
"tracksuit":["DPL","CrJ","CrH","CrI"],
"tractor":["DPM","CrO","CrK","CrL","CrM","CrN"],
"tradition":["Dvb"],
"traffic":["Dvc"],
"traffic cone":["DPN"],
"traffic jam":["CrP","CrQ","CrR"],
"traffic light":["DPO","CrS","CrT","CrU","CrV"],
"traffic lights":["CrW","CrX","CrY","CrZ","Cra","Crb"],
"trail":["Dvd"],
"train":["DPP","Cri","Crc","Crd","Cre"],
"train station":["DPQ","Crj","Crk","Crl","Crm","Crn"],
"trainer":["Crf"],
"trainers":["Crh","Crg"],
"tram":["Crq","Cro","Crp"],
"trampoline":["Cru","Crr","Crs","Crt"],
"transform":["DYw"],
"translate":["DnU"],
"translate translated":["DnU"],
"translating":["DnU"],
"translator":["DPS","DPR"],
"trap":["Crx","Crv"],
"trapezium":["Crw"],
"trash":["Cr7","Cry","Crz","Cr0"],
"trash can":["DPT","Cr1","Cr2","Cr3","Cr4","Cr5"],
"trash collection":["Cr6"],
"travel":["CsA"],
"travel agent":["DPU","DPV"],
"travelling":["Cr9","Cr8"],
"travels":["CsC","CsB"],
"tray":["DPW","CsH","CsD","CsE","CsF","CsG"],
"treadmill":["CsL","CsI","CsJ","CsK"],
"treasure":["CsP","CsM","CsN","CsO"],
"tree":["DPX","Csa","CsQ","CsR","CsS","CsT","CsU","CsV"],
"tree house":["CsW","CsX","CsY","CsZ"],
"trees":["Csi","Csb","Csc","Csd","Cse","Csf","Csg","Csh"],
"trekking":["Csl","Csj","Csk"],
"trench":["Css","Csm","Csn"],
"trench coat":["Cso","Csp","Csq","Csr"],
"triangle":["Csw","Csv"],
"tribe":["Csz","Csx","Csy"],
"trick or treat":["Dve"],
"Trinidad and Tobago":["Cs0","Cs1","Cs2"],
"trio":["Cs4","Cs3"],
"trip":["Cs7","Cs5","Cs6"],
"troll":["CtD","Cs8","Cs9"],
"troll face":["CtC"],
"trolley":["CtB","CtA"],
"trophy":["CtI","CtE","CtF","CtG","CtH"],
"tropical":["CtN","CtJ","CtK","CtL"],
"tropical fish":["CtM"],
"trousers":["DPZ","DPY","CtS","CtO","CtP","CtQ","CtR"],
"truck":["DPc","CtY","CtT","CtU","CtV","CtW","CtX"],
"truck driver":["DPa","DPb"],
"trumpet":["DPd","Ctd","CtZ","Cta","Ctb","Ctc"],
"trunk":["DPe","Ctf","Cte"],
"trust":["Ctg"],
"try on":["DnV"],
"try on tried on":["DnV"],
"trying on":["DnV"],
"tshirt":["DPg","DPf","Cto","Cti","Ctk","Ctm"],
"tsunami":["Cts","Ctp","Ctq","Ctr"],
"tub":["Ctz","Ctt","Ctu"],
"tuba":["Cty","Ctv","Ctw","Ctx"],
"tube":["Dvf"],
"Tuesday":["DPj","DPh","DPi"],
"tulip":["Ct2","Ct0","Ct1"],
"tulips":["Ct5","Ct3","Ct4"],
"tuna":["DPk","Ct9","Ct6","Ct7","Ct8"],
"tune":["CuA"],
"tunnel":["DPl","CuE","CuB","CuC","CuD"],
"Turkey":["DPn","CuK","CuF","CuG"],
"turkey":["CuH","CuI","CuJ"],
"Turkey flag":["DPm"],
"Turkish":["DPo"],
"turn down":["DnW"],
"turn down cake":["DnW"],
"turn down turned down":["DnW"],
"turn into":["DnX"],
"turn into turned into":["DnX"],
"turn off":["DnY"],
"turn off the light":["DnY"],
"turn off turned off":["DnY"],
"turn on":["Dna","DnZ","Dnb"],
"turn on a TV":["DnZ"],
"turn on the AC":["Dnb"],
"turn on turned on":["DnZ","Dna","Dnb"],
"turn over":["Dnc"],
"turn over turned over":["Dnc"],
"turning down":["DnW"],
"turning down cake":["DnW"],
"turning into":["DnX"],
"turning off":["DnY"],
"turning off the light":["DnY"],
"turning on":["Dna","DnZ","Dnb"],
"turning on a TV":["DnZ"],
"turning on the AC":["Dnb"],
"turning over":["Dnc"],
"turquoise":["DPp"],
"turtle":["DPq","CuQ","CuL","CuM","CuN"],
"turtleneck":["CuP"],
"turtlenecked":["CuO"],
"turtles":["CuR"],
"tusk":["CuT","CuS"],
"tutor":["Dnd","DPs","DPr"],
"tutor tutored":["Dnd"],
"tutoring":["Dnd"],
"Tuvalu":["CuW","CuU","CuV"],
"tv":["DPt"],
"tv presenter":["DPu","DPv"],
"twelve":["Dcr","Dcp"],
"twelve hundred":["Dcq"],
"twenty":["Dcy","Dcs"],
"twenty eight":["Dct"],
"twenty five":["Dcu"],
"twenty five past eleven":["Dea"],
"twenty five past six":["Deb"],
"twenty five past ten":["Dec"],
"twenty five to ten":["Ded"],
"twenty four":["Dcv"],
"twenty nine":["Dcw"],
"twenty one":["Dcx"],
"twenty past two":["Dee"],
"twenty seven":["Dcz"],
"twenty six":["Dc0"],
"twenty thousand":["Dc1"],
"twenty three":["Dc2"],
"twenty to four":["Def"],
"twenty two":["Dc3"],
"twig":["Cua","CuX","CuY","CuZ"],
"twin":["Cuc"],
"twin bed":["Cub"],
"twin room":["Cud"],
"twin sister":["DZh"],
"twins":["Cui","Cue","Cuf","Cug","Cuh"],
"two":["Dc6","Dc4"],
"two hundred":["Dc5"],
"two o'clock":["Deg"],
"two thousand":["Dc7"],
"tying":["DnR","DnQ","DnS"],
"tying her shoes":["DnQ"],
"tying your shoe":["DnS"],
"type":["Dng","Dne","Dnf","Cul","Cuj","Cuk"],
"type typed":["Dne","Dnf","Dng"],
"typewriter":["Cun","Cum"],
"typhoon":["Cup","Cuo"],
"typing":["Dng","Dne","Dnf"],
"typist":["Cuq"],
"tyre":["Cuu","Cur","Cus","Cut"],
"u":["DaQ","DaP"],
"ufo":["Cuw","Cuv"],
"uglier":["DPw"],
"ugly":["DPx","Cuz","Cux","Cuy"],
"ukelele":["Cu3","Cu0","Cu1","Cu2"],
"Ukraine":["Cu6","Cu4","Cu5"],
"uluru":["Cu8","Cu7"],
"umbrella":["DPz","DPy","CvA","Cu9"],
"umpire":["CvB"],
"uncle":["DZi"],
"under":["Ddi","Ddg","Ddh"],
"underground":["Dvg"],
"understand":["Dvh"],
"underwater":["CvC"],
"unhappy":["Dvi"],
"unhealthy":["CvE","CvD"],
"unicorn":["CvI","CvF","CvG","CvH"],
"uniform":["CvM","CvJ","CvK","CvL"],
"United Kingdom":["CvN","CvO","CvP","CvQ"],
"United States":["CvR","CvS","CvT","CvU"],
"universe":["CvX","CvV","CvW"],
"university":["Cva","CvY","CvZ"],
"university lecturer":["DP0","DP1"],
"unload":["Cvb"],
"untidy":["Cvc"],
"unusual":["Dvj"],
"up":["Dvl","Dvk"],
"upload":["Cve","Cvd"],
"upset":["Cvf"],
"upside down":["DP2","Cvg","Cvh"],
"upstairs":["Cvi"],
"uranus":["Cvj"],
"usa dollar":["Cvk","Cvl"],
"USA flag":["DP3"],
"usb stick":["DP4","Cvm","Cvn"],
"use":["Dnm","Dnh","Dni","Dnj","Dnl"],
"use a computer":["Dnh"],
"use a hairdryer":["DP5"],
"use a key":["DP6"],
"use a microwave":["DP7"],
"use a mirror":["DP8"],
"use a pen":["DP9"],
"use a phone":["Dni","DQA"],
"use a ruler":["DQB"],
"use a spoon":["DQC"],
"use a tablet":["Dnj"],
"use a tissue":["DQD"],
"use a wheelchair":["Dnk"],
"use chopsticks":["Dnl","DQE"],
"use scissors":["DQF"],
"use the Internet":["Dnn"],
"use used":["Dnh","Dni","Dnj","Dnm"],
"useful":["Dvm"],
"using":["Dnm","Dnh","Dni","Dnj","Dnl"],
"using a computer":["Dnh"],
"using a phone":["Dni"],
"using a tablet":["Dnj"],
"using a wheelchair":["Dnk"],
"using chopsticks":["Dnl"],
"using the Internet":["Dnn"],
"v":["DaS","DaR"],
"vacation":["Cvo"],
"vacuum":["Cvq"],
"vacuum cleaner":["DQG","Cvp"],
"valley":["DYx","Cvt","Cvr","Cvs"],
"valuable":["DYy","Cvu"],
"valve":["DYz","Cvw","Cvv"],
"vampire":["Cvz","Cvx","Cvy"],
"van":["DQH","Cv3","Cv0"],
"vandalism":["Cv2","Cv1"],
"vanilla":["Dvn"],
"vase":["DQI","Cv8","Cv4","Cv5","Cv6","Cv7"],
"vast":["CwA","Cv9"],
"Vatican city":["CwB"],
"vegetable":["CwF","CwC"],
"vegetable garden":["CwD","CwE"],
"vegetables":["DQJ","CwK","CwG","CwH","CwI","CwJ"],
"veins":["CwL"],
"velocity":["CwM"],
"vendor":["CwO","CwN"],
"Venezuela":["CwR","CwP","CwQ"],
"venus":["CwS"],
"vermillion":["DQK"],
"vertical":["CwT"],
"vessel":["CwW","CwU","CwV"],
"vest":["DQL","CwZ","CwX","CwY"],
"vet":["DQN","DQM","Cwc","Cwa"],
"veterinarian":["Cwb"],
"video":["Cwd"],
"Vietnam":["Cwj","Cwe","Cwf","Cwg","Cwh","Cwi"],
"Vietnam flag":["DQO"],
"view":["Cwk"],
"village":["Cwn","Cwl","Cwm"],
"villain":["Cwo"],
"vinegar":["Cwp"],
"violet":["DQP"],
"violin":["DQQ","Cww","Cwq","Cwr","Cws","Cwt"],
"violinist":["Cwv","Cwu"],
"visit":["Dno"],
"visit grandparents":["Dno"],
"visit visited":["Dno"],
"visiting":["Dno"],
"visiting grandparents":["Dno"],
"volcano":["DQT","DQR","DQS","Cw2","Cwx","Cwy","Cwz","Cw0","Cw1"],
"volleyball":["DQU","Cw7","Cw3","Cw4","Cw5","Cw6"],
"volunteer":["Dvo"],
"voting":["Dvp"],
"voucher":["Cw8"],
"voyage":["Dvq"],
"vulture":["CxC","Cw9","CxA","CxB"],
"w":["DaU","DaT"],
"waffles":["DQV","CxF","CxD","CxE"],
"wagon":["CxI","CxG","CxH"],
"wait":["Dns","Dnp","Dnr","CxQ","CxJ","CxK","CxL"],
"wait at the lights":["Dnp"],
"wait for":["Dnq"],
"wait for a bus":["Dnq"],
"wait for a train":["Dnr"],
"wait in line":["CxP"],
"wait waited":["Dnp","Dnq","Dnr","Dns"],
"waiter":["DQX","DQW","CxO","CxM","CxN"],
"waiting":["Dns","Dnp","Dnr"],
"waiting at the lights":["Dnp"],
"waiting for":["Dnq"],
"waiting for a bus":["Dnq"],
"waiting for a train":["Dnr"],
"waitress":["CxT","CxR","CxS"],
"wake up":["Dnt","Dnu","CxU","CxV"],
"wake up woke up":["Dnt","Dnu"],
"waking up":["Dnt","Dnu"],
"walk":["Dnx","Dnv","Dnw","Dny","Cxc","CxW","CxX"],
"walk a dog":["Dnv"],
"walk in the park":["Dnw"],
"walk the dog":["Cxd","Cxe","Cxf","Cxg"],
"walk to class":["Dny"],
"walk to school":["Dvr"],
"walk walked":["Dnv","Dnw","Dnx","Dny"],
"walking":["Dnx","Dnv","Dnw","Dny","Cxb","CxY","CxZ","Cxa"],
"walking a dog":["Dnv"],
"walking in the park":["Dnw"],
"walking stick":["DQY"],
"walking to class":["Dny"],
"wall":["DQa","Cxo","Cxh","Cxi"],
"wallet":["DQZ","Cxn","Cxj","Cxk","Cxl","Cxm"],
"walnuts":["Cxs","Cxp","Cxq","Cxr"],
"walrus":["Cxv","Cxt","Cxu"],
"waltz":["Cxw"],
"wand":["Cxx"],
"war":["Dvs"],
"wardrobe":["Cx0","Cxy","Cxz"],
"warm":["Cx2","Cx1"],
"warmer":["DQb"],
"wash":["Dn2","Dnz","Dn0","Dn1","Dn3","Dn4","Dn5","Dn6","Dn7","Cx8","Cx3"],
"wash dishes":["Dnz","Dn0"],
"wash face":["Dvt"],
"wash his face":["Dn1"],
"wash the car":["CyB"],
"wash the dishes":["Dn3","CyC","CyD"],
"wash up":["Dvu"],
"wash washed":["Dnz","Dn0","Dn1","Dn2"],
"wash your car":["Dn4"],
"wash your face":["Dn5"],
"wash your hair":["Dn6"],
"wash your hands":["Dn7"],
"washbasin":["Cx5","Cx4"],
"washing":["Dn2","Dnz","Dn0","Dn1","Dn3","Dn4","Dn5","Dn6","Dn7"],
"washing dishes":["Dnz","Dn0"],
"washing his face":["Dn1"],
"washing machine":["DQc","Cx6","Cx7"],
"washing the dishes":["Dn3"],
"washing your car":["Dn4"],
"washing your face":["Dn5"],
"washing your hair":["Dn6"],
"washing your hands":["Dn7"],
"washroom":["CyA","Cx9"],
"wasp":["CyH","CyE","CyF","CyG"],
"waste":["CyM","CyI","CyJ"],
"waste basket":["CyK","CyL"],
"watch":["Dn8","Dn9","DoA","DQe","DQd","CyU","CyN","CyO","CyP"],
"watch movies":["Dvv"],
"watch strap":["CyV","CyW"],
"watch TV":["Dn9","DoA"],
"watch tv":["CyX","CyY"],
"watch watched":["Dn8","Dn9","DoA"],
"watches":["CyR","CyQ"],
"watching":["Dn8","Dn9","DoA"],
"watching TV":["Dn9","DoA"],
"watching tv":["CyS","CyT"],
"water":["DoB","DQh","CzA","CyZ","Cya"],
"water balloon":["Cyb"],
"water bottle":["Cyc","Cyd","Cye"],
"water bucket":["Cyf"],
"water cycle":["DY0","Cyg","Cyh"],
"water dispenser":["DQf"],
"water lily":["Cyu","Cyv"],
"water park":["DY1","Cy3","Cy5","Cy8"],
"water shortage":["DY2","CzB","CzC","CzD"],
"water ski":["Dvw"],
"water skiing":["CzE","CzF","CzG","CzH"],
"water slide":["CzI","CzJ","CzK"],
"water the lawn":["CzL","CzM"],
"water vegetables":["DoB"],
"water watered":["DoB"],
"waterfall":["Cym","Cyi","Cyj","Cyk","Cyl"],
"waterfalls":["Cyo","Cyn"],
"watering":["DoB","Cyt"],
"watering can":["Cyp","Cyq","Cyr","Cys"],
"watering vegetables":["DoB"],
"watermelon":["DQg","Cy1","Cyw","Cyx","Cyy","Cyz","Cy0"],
"watermelons":["Cy2"],
"waterpark":["Cy9","Cy4","Cy6","Cy7"],
"waterwheel":["Dvx"],
"wave":["DoE","DoC","DoD","CzQ","CzN","CzO","CzP"],
"wave her hand":["DoD"],
"wave waved":["DoC","DoD","DoE"],
"waves":["CzR"],
"waving":["DoE","DoC","DoD"],
"waving her hand":["DoD"],
"wavy":["Dvy"],
"wavy hair":["CzS","CzT"],
"wax":["CzU"],
"weak":["CzW","CzV"],
"weaker":["DQi"],
"wear":["DoF","DoG","DoH","DoI","DoJ"],
"wear a coat":["DoF"],
"wear a mask":["DoG","DoH"],
"wear a raincoat":["DoI"],
"wear glasses":["DoJ"],
"wear wore":["DoF","DoG","DoI","DoJ"],
"wearing":["DoF","DoG","DoH","DoI","DoJ"],
"wearing a coat":["DoF"],
"wearing a mask":["DoG","DoH"],
"wearing a raincoat":["DoI"],
"wearing glasses":["DoJ"],
"weather":["DY3","CzY","CzX"],
"weather vane":["CzZ"],
"web":["Czg","Cza"],
"web designer":["Czd","Cze","Czf"],
"web developer":["DQj","DQk"],
"webcam":["Czc","Czb"],
"wedding":["Czm","Czh","Czi","Czj","Czk","Czl"],
"Wednesday":["DQn","DQl","DQm"],
"weed":["Czo","Czn"],
"weeds":["Czs","Czp","Czq","Czr"],
"weep":["Czt"],
"weigh":["Czu"],
"weight":["Dvz"],
"weight lifting":["Czv","Czw"],
"weight scale":["Czx","Czy"],
"weightlifting":["DQo"],
"weights":["DQp"],
"welcome":["DY4"],
"well":["DY6","Cz0","Czz"],
"well built":["DY5"],
"werewolf":["Cz4","Cz1","Cz2","Cz3"],
"western":["Cz7","Cz5","Cz6"],
"wet":["DQs","DQq","DQr","C0E","Cz8"],
"wetland":["C0D","Cz9","C0A","C0B","C0C"],
"wetter":["DQt"],
"whale":["DQu","C0L","C0F","C0G","C0H","C0I","C0J","C0K"],
"what":["Ddr","Dds","Ddt"],
"what color":["Ddq"],
"What color is the bike":["Ddq"],
"What is the time":["Ddr"],
"What is your phone number":["Dds"],
"What phone do you have":["Ddt"],
"what time":["Ddv"],
"What time do you wake up":["Ddv"],
"What's the weather like":["Ddu"],
"wheat":["C0Q","C0M","C0N","C0O","C0P"],
"wheel":["C0g","C0R","C0S","C0T","C0U","C0V"],
"wheelbarrow":["DQv","C0a","C0W","C0X","C0Y","C0Z"],
"wheelchair":["DQw","C0f","C0b","C0c","C0d","C0e"],
"when":["Ddw"],
"When do you go to bed":["Ddw"],
"where":["Ddx","Ddy","Ddz","Dd3"],
"Where are you from":["Ddx"],
"Where are you going":["Ddy"],
"Where do you live":["Ddz"],
"Where is she from":["Dd0"],
"Where is the bus stop":["Dd1"],
"Where is the remote":["Dd2"],
"where is the WC":["Dd3"],
"which":["Dd4"],
"Which team do you like":["Dd4"],
"whip":["C0h"],
"whisk":["Dv0"],
"whiskers":["C0j","C0i"],
"whisper":["DoK","C0l","C0k"],
"whisper whispered":["DoK"],
"whispering":["DoK"],
"whistle":["DQx","C0o","C0m","C0n"],
"white":["DQz"],
"whiteboard":["DQy","C0t","C0p","C0q","C0r","C0s"],
"who":["Dd5","Dd6"],
"Who do you love":["Dd5"],
"Who is she":["Dd6"],
"wide":["Dv1"],
"wider":["DQ0"],
"wife":["DZj","C0x","C0u","C0v","C0w"],
"wifi":["C01","C0y","C0z","C00"],
"wig":["C03","C02"],
"wild":["C1C","C04","C05"],
"wild animals":["C06","C07","C08","C09"],
"wildlife":["C1B","C1A"],
"win":["DoL","DoM","C2F","C1D","C1E"],
"win the cup":["DoM"],
"win win won":["DoM"],
"win won":["DoL"],
"wind":["DQ5","C1e","C1F","C1G"],
"wind farm":["DY7","C1H","C1I"],
"wind vane":["DY8"],
"windmill":["DQ1","C1M","C1J","C1K","C1L"],
"window":["DQ4","C1W","C1N","C1O","C1P","C1Q"],
"window blind":["C1R","C1S","C1T"],
"window blinds":["C1U","C1V"],
"window cleaner":["DQ2","DQ3"],
"windows":["C1d","C1X","C1Y","C1Z","C1a","C1b","C1c"],
"windsurf":["C1k","C1f","C1g"],
"windsurfing":["C1j","C1h","C1i"],
"windy":["DQ7","DQ6","C1p","C1l","C1m","C1n","C1o"],
"wine":["C1v","C1q","C1r","C1s","C1t","C1u"],
"wine glass":["DQ8"],
"wing":["C10","C1w","C1x","C1y","C1z"],
"wings":["DQ9","C16","C11","C12","C13","C14","C15"],
"wink":["DY9","C2B","C17","C18","C19","C2A"],
"winner":["DZA","C2D","C2C"],
"winnie the pooh":["C2E"],
"winning":["DoL","DoM"],
"winning the cup":["DoM"],
"winter":["C2J","C2G","C2H","C2I","Dv2"],
"wipe":["DoN"],
"wipe the table":["DoN"],
"wipe wipes":["DoN"],
"wiping":["DoN"],
"wiping the table":["DoN"],
"wire":["C2M","C2K","C2L"],
"wire stripper":["C2N"],
"wise":["Dv3"],
"witch":["C2R","C2O","C2P","C2Q"],
"with":["Dv4"],
"withdraw":["DoO","C2S"],
"withdraw money":["DoO"],
"withdraw withdrew":["DoO"],
"withdrawing":["DoO"],
"withdrawing money":["DoO"],
"wither":["DZB"],
"wizard":["DZC","C2W","C2T","C2U","C2V"],
"wolf":["DRA","C2b","C2X","C2Y","C2Z","C2a"],
"wolly jumper":["DZD"],
"wolves":["C2f","C2c","C2d","C2e"],
"woman":["C2m","C2g","C2h","C2i","C2j","C2k","C2l"],
"women":["C2q","C2n","C2o","C2p"],
"wonderful":["Dv5"],
"wood":["C21","C2r","C2s","C2t","C2u"],
"wood screw":["C22","C23","C24"],
"wooden":["C2y","C2v","C2w"],
"wooden paddle":["C2x"],
"woodlouse":["C20","C2z"],
"woods":["Dv6"],
"wool":["C27","C25","C26"],
"words":["C28"],
"wordsheet":["DZE"],
"work":["DoT","DoP","DoQ","DoR","C3C","C29","C3A","C3B"],
"work in a clothes store":["DoR"],
"work out":["DoS"],
"work out worked out":["DoS"],
"work worked":["DoT","DoP","DoQ","DoR"],
"working":["DoT","DoP","DoQ","DoR"],
"working in a clothes store":["DoR"],
"working out":["DoS"],
"world":["DZF","C3D"],
"worm":["C3G","C3E","C3F"],
"worried":["C3J","C3H","C3I"],
"worry":["C3L","C3K"],
"worse":["DRB"],
"wrap":["DRC"],
"wrappers":["DZG"],
"wreath":["DZH","C3P","C3M","C3N","C3O"],
"wrench":["DZI","C3T","C3Q","C3R","C3S"],
"wrench set":["C3U","C3V"],
"wrestling":["DRD","C3Y","C3W","C3X"],
"wrist":["DRE"],
"write":["DoW","DoU","DoV","DoX","C3b","C3Z","C3a"],
"write an email":["Dv7"],
"write on the board":["DoV"],
"write software":["DoX"],
"write wrote":["DoU","DoV","DoW"],
"writer":["Dv8"],
"writing":["DoW","DoU","DoV","DoX","C3e","C3c","C3d"],
"writing on the board":["DoV"],
"writing software":["DoX"],
"x":["DaW","DaV"],
"x ray":["DRF","C3f","C3g"],
"xylophone":["C3i","C3h"],
"y":["DaY","DaX"],
"yacht":["C3m","C3j","C3k","C3l"],
"yak":["C3r","C3n","C3o","C3p","C3q"],
"yam":["C3t","C3s"],
"yard":["C3w","C3u","C3v"],
"yarn":["C3z","C3x","C3y"],
"yawn":["DoZ","DoY","C33","C30","C31","C32"],
"yawn yawned":["DoY","DoZ"],
"yawning":["DoZ","DoY"],
"yell":["C34"],
"yellow":["DRG"],
"yellow shorts":["DRH"],
"yellow skirt":["DRI"],
"yellow tie":["DRJ"],
"yes":["Dv9"],
"yin and yang":["C35"],
"yo yo":["DwC"],
"yoga":["C4A","C36","C37","C38","C39"],
"yoghurt":["DwA"],
"yogurt":["DRK","C4B"],
"yorkshire pudding":["C4C"],
"young":["C4D"],
"younger":["DRL"],
"youtube":["DwB"],
"yoyo":["DwD"],
"z":["Daa","DaZ"],
"zebra":["DRM","C4J","C4E","C4F","C4G"],
"zebra crossing":["C4H","C4I"],
"zebras":["C4L","C4K"],
"zero":["Dc9","Dc8"],
"zigzag":["DwE"],
"zip":["DRN","C4Q","C4M","C4N"],
"zipper":["C4P","C4O"],
"zombie":["C4T","C4R","C4S"],
"zoo":["DRP"],
"zookeeper":["DwF"],
"zoom call":["DRO"],
"zucchini":["C4Y","C4U","C4V","C4W","C4X"]
}
